/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  infographic: {
    title: 'إنشاء مخطط معلوماتي',
    custom_prompt: 'تعليمات مخصصة (اختياري)',
    prompt_placeholder:
      'مثال: استخدم الألوان الزرقاء، أضف الرسوم البيانية، ركز على الإحصائيات...',
    generating: 'جارٍ إنشاء المخطط المعلوماتي...',
    generated: 'تم إنشاء المخطط المعلوماتي بنجاح!',
    generation_failed: 'فشل إنشاء المخطط المعلوماتي',
    no_content: 'لا يوجد محتوى متاح لإنشاء المخطط المعلوماتي',
    no_image: 'لا يوجد مخطط معلوماتي للتطبيق',
    empty_state: 'انقر على إنشاء لإنشاء المخطط المعلوماتي الخاص بك',
    generate: 'إنشاء مخطط معلوماتي',
    regenerate: 'إعادة الإنشاء',
    apply_question: 'كيف ترغب في استخدام هذا المخطط المعلوماتي؟',
    replace_option: 'استبدال الصورة الحالية',
    add_option: 'إضافة كصورة جديدة',
    replace_success: 'تم استبدال المخطط المعلوماتي بنجاح!',
    add_success: 'تمت إضافة المخطط المعلوماتي بنجاح!',
    page_content: 'محتوى الصفحة',
    generated_infographic: 'المخطط المعلوماتي المنشأ',
    title_label: 'العنوان',
    text_label: 'محتوى النص',
    aspect_ratio: 'نسبة العرض إلى الارتفاع',
    replace_the_existing_image_on_the_page:
      'استبدل الصورة الحالية على الصفحة بهذا المخطط المعلوماتي',
    add_this_infographic: 'أضف هذا المخطط المعلوماتي كعنصر جديد في الصفحة',
    square: '1:1 (مربع)',
    portrait: '2:3 (عمودي)',
    landscape: '3:2 (أفقي)',
    three_four_Portrait: '3:4 (عمودي)',
    four_three_landscape: '4:3 (أفقي)',
    four_five_portrait: '4:5 (عمودي)',
    four_five_landscape: '5:4 (أفقي)',
    mobile_portrait: '9:16 (عمودي للجوال)',
    widescreen: '16:9 (شاشة عريضة)',
    ultrawide: '21:9 (شاشة عريضة جداً)'
  },

  helplist: {
    // MISC
    whats_new: 'ما الجديد',
    whats_new_sharelook: 'ما الجديد في ShareLook',
    whats_new_desc:
      'هل تعلم أن إنشاء تجربة تعليمية بأسلوب سرد القصص أمر سهل وسريع وغير مكلف؟ يجب عليك دمج منشئ دورات ShareLook مع مواهبك الخاصة. اسألنا كيف.',
    no_video_found: 'لم يتم العثور على فيديوهات مطابقة لـ',
    uploaded_on: 'تم الرفع في',
    no_video_available: 'لا توجد فيديوهات جديدة متاحة في الوقت الحالي.',
    no_videos_available: 'لا توجد فيديوهات متاحة',
    user_view: 'عرض المستخدم',
    admin_view: 'عرض المسؤول',
    welcome: 'مرحبًا بك في مركز مساعدة ShareLook',
    video_filter:
      'اختر فيديو من القائمة اليسرى للبدء، أو استخدم البحث للعثور على محتوى محدد.',

    // HELP CENTER
    sharelook: 'Sharelook',
    sharelook_desc: 'مقدمة عن Sharelook وميزاته',

    course_summary: 'ملخص إنشاء الدورة',
    course_summary_desc: 'نظرة عامة وملخص لعملية إنشاء الدورة',

    ai_course_creation: 'العملية الكاملة - إنشاء دورة بالذكاء الاصطناعي',
    ai_course_creation_desc: 'تعلم كيفية إنشاء دورة باستخدام الذكاء الاصطناعي',

    scenario_based_assessment: 'العملية الكاملة - إنشاء تقييم قائم على السيناريوهات (Metamaze)',
    scenario_based_assessment_desc: 'تعلم كيفية إنشاء تقييم قائم على السيناريوهات باستخدام الذكاء الاصطناعي',

    skill_leaderboard_creation: 'العملية الكاملة - إنشاء رحلة المهارة ولوحة المتصدرين',
    skill_leaderboard_creation_desc: 'تعلم كيفية إنشاء رحلة مهارة ولوحة متصدرين باستخدام الذكاء الاصطناعي',

    skill_journey: 'رحلة المهارة',
    skill_journey_desc:
      'فهم ما هي رحلة المهارة وكيف تساعد المتعلمين',

    metamaze: 'Metamaze',
    metamaze_desc:
      'مقدمة عن Metamaze ودوره في التعلم القائم على السيناريوهات',

    share_shorts: 'مقاطع المشاركة القصيرة',
    share_shorts_desc:
      'نظرة عامة على مقاطع المشاركة القصيرة وكيفية استخدامها بفعالية',

    // TRAINING
    view_channel: 'عرض قناة الفيديو',
    view_channel_desc:
      'تعلم كيفية عرض واستكشاف المحتوى في قناة الفيديو',

    take_course: 'أخذ الدورة - المتعلم',
    take_course_desc: 'فهم كيف يمكن للمتعلمين أخذ الدورة والتنقل فيها',

    take_metamaze: 'أخذ Metamaze',
    take_metamaze_desc:
      'تعلم كيف يمكن للمتعلمين المشاركة في وحدة التعلم القائمة على السيناريوهات Metamaze',

    take_skill_journey: 'أخذ رحلة المهارة',
    take_skill_journey_desc:
      'تعلم كيفية البدء وإكمال رحلة المهارة كمتعلم',

    listen_podcast: 'كيفية الاستماع إلى البودكاست',
    listen_podcast_desc: 'تعلم كيفية الاستماع والتنقل في محتوى البودكاست',

    // COURSES
    create_course: 'إضافة شهادة وشارة وغلاف دورة إلى الدورة',
    create_course_desc:
      'إنشاء دورة وتخصيصها بالشارات والشهادات وصور الغلاف',

    create_course_simulation: 'المحاكاة (بيئة الحماية) داخل الدورة',
    create_course_simulation_desc: 'دليل خطوة بخطوة لإنشاء المحاكاة داخل الدورة',

    create_interactive_lesson: 'الدرس التفاعلي',
    create_interactive_lesson_desc: 'دليل خطوة بخطوة لإنشاء دروس تفاعلية داخل الدورة',

    create_lesson: 'كيفية إنشاء درس',
    create_lesson_desc:
      'دليل خطوة بخطوة لإنشاء الدروس داخل الدورة',

    create_course_complete_tutorial: 'دليل كامل لإنشاء دورة',
    create_course_complete_tutorial_desc:
      'دليل شامل حول كيفية إنشاء منهج وإنشاء دورة باستخدام الذكاء الاصطناعي على Sharelook.',

    // COURSES AI
    ai_curriculum: 'إنشاء المنهج بالذكاء الاصطناعي',
    ai_curriculum_desc:
      'تعلم كيفية استخدام الذكاء الاصطناعي لإنشاء منهج الدورة تلقائيًا',

    // COURSES BUILDER
    intro_gen: 'إنشاء المقدمة',
    intro_gen_desc: 'إنشاء مقدمات دورة جذابة باستخدام الذكاء الاصطناعي',

    intro_generation: 'إنشاء مقدمة الدرس',
    intro_generation_desc: 'إنشاء مقدمات دورة جذابة باستخدام الذكاء الاصطناعي',

    ai_story_generation: 'إنشاء القصة والقصة الواقعية بالذكاء الاصطناعي',
    ai_story_generation_desc:
      'إنشاء قصص جذابة وسيناريوهات واقعية باستخدام الذكاء الاصطناعي',

    scenario_gen: 'إنشاء السيناريو',
    scenario_gen_desc: 'بناء سيناريوهات تفاعلية للتعلم الغامر',

    scenario_generation: 'إنشاء السيناريو',
    scenario_generation_desc:
      'بناء سيناريوهات تفاعلية للتعلم الغامر',

    quiz_ai: 'إنشاء الاختبار بالذكاء الاصطناعي',
    quiz_ai_desc: 'إنشاء الاختبارات تلقائيًا باستخدام تقنية الذكاء الاصطناعي',

    ai_quiz_generation: 'إنشاء الاختبار بالذكاء الاصطناعي',
    ai_quiz_generation_desc: 'إنشاء الاختبارات تلقائيًا باستخدام تقنية الذكاء الاصطناعي',

    bullet_gen: 'إنشاء النقاط',
    bullet_gen_desc: 'إنشاء نقاط منظمة لدروسك',

    bullet_points: 'إنشاء النقاط',
    bullet_points_desc: 'إنشاء نقاط منظمة لدروسك',

    summary_gen: 'إنشاء الملخص',
    summary_gen_desc: 'إنشاء ملخصات الدروس تلقائيًا باستخدام الذكاء الاصطناعي',

    summary_generation: 'إنشاء الملخص',
    summary_generation_desc: 'إنشاء ملخصات الدروس تلقائيًا باستخدام الذكاء الاصطناعي',

    add_content: 'إضافة محتوى إلى الدرس',
    add_content_desc: 'إضافة أنواع مختلفة من المحتوى لإثراء دروسك',

    add_lesson_content: 'إضافة محتوى إلى الدرس',
    add_lesson_content_desc:
      'إضافة أنواع مختلفة من المحتوى لإثراء دروسك',

    layout_change: 'تغيير تخطيط الدرس',
    layout_change_desc: 'تخصيص تخطيط صفحات الدرس',

    change_lesson_layout: 'تغيير تخطيط الدرس',
    change_lesson_layout_desc: 'تخصيص تخطيط صفحات الدرس',

    voiceover_gen: 'إنشاء التعليق الصوتي',
    voiceover_gen_desc: 'إضافة تعليقات صوتية احترافية إلى محتوى دورتك',

    voiceover_generation: 'إنشاء التعليق الصوتي',
    voiceover_generation_desc:
      'إضافة تعليقات صوتية احترافية إلى محتوى دورتك',

    manual_quiz: 'إنشاء الاختبار يدويًا',
    manual_quiz_desc: 'تعلم كيفية إنشاء وتخصيص الاختبارات يدويًا',

    manual_quiz_creation: 'إنشاء الاختبار يدويًا',
    manual_quiz_creation_desc:
      'تعلم كيفية إنشاء وتخصيص الاختبارات يدويًا',

    ai_image_gen: 'إنشاء الصور بالذكاء الاصطناعي',
    ai_image_gen_desc: 'إنشاء صور مخصصة لدورتك باستخدام الذكاء الاصطناعي',

    ai_image_generation: 'إنشاء الصور بالذكاء الاصطناعي',
    ai_image_generation_desc: 'إنشاء صور مخصصة لدورتك باستخدام الذكاء الاصطناعي',

    simulation: 'إنشاء المحاكاة',
    simulation_desc: 'إنشاء محاكاة تفاعلية في بيئة الحماية',

    simulation_creation: 'إنشاء المحاكاة (بيئة الحماية)',
    simulation_creation_desc:
      'دليل خطوة بخطوة لبناء المحاكاة في بيئة الحماية',

    course_learner_view: 'عرض المتعلم للدورة',
    course_learner_view_desc:
      'فهم منظور وتجربة المتعلم في الدورات',

    simulation_learner_view: 'عرض المتعلم للمحاكاة',
    simulation_learner_view_desc:
      'تجربة المحاكاة من منظور المتعلم في بيئة الحماية',

    infographic_title: 'إضافة مخططات معلوماتية إلى صفحة الدرس',
    infographic_desc:
      'تعلم إنشاء مخططات معلوماتية تفاعلية لدروسك',

    // MAZE
    ai_metamaze: 'إنشاء AI-Metamaze',
    ai_metamaze_desc:
      'تعلم كيفية إنشاء تجارب metamaze تفاعلية باستخدام الذكاء الاصطناعي',

    ai_metamaze_creation: 'إنشاء AI-Metamaze',
    ai_metamaze_creation_desc:
      'تعلم كيفية إنشاء تجارب metamaze تفاعلية باستخدام الذكاء الاصطناعي',

    // LIBRARY
    media_library: 'مكتبة الوسائط',
    media_library_desc: 'نظرة عامة على مكتبة الوسائط واستخدامها',

    file_management: 'إدارة الملفات',
    file_management_desc: 'تعلم كيفية إدارة ملفاتك بكفاءة',

    upload_files: 'رفع الملفات وإضافتها إلى مستودع الذكاء الاصطناعي',
    upload_files_desc:
      'كيفية رفع ودمج الملفات في مستودع الذكاء الاصطناعي',

    file_upload_repository:
      'رفع الملفات وإضافة الملفات إلى مستودع الذكاء الاصطناعي',
    file_upload_repository_desc:
      'تعلم رفع الملفات وإضافتها إلى مستودع الذكاء الاصطناعي',

    document_creation: 'إنشاء المستندات (Word، Calc، Impress)',
    document_creation_desc:
      'تعلم إنشاء المستندات بتنسيقات Word و Calc و Impress',

    file_organization: 'تنظيم الملفات في المجلدات',
    file_organization_desc: 'تنظيم الملفات بفعالية داخل المجلدات',

    document_creation_screen: 'إنشاء المستندات باستخدام التقاط الشاشة',
    document_creation_screen_desc:
      'إنشاء المستندات باستخدام وظيفة التقاط الشاشة',

    course_creation_screen: 'إنشاء الدورة باستخدام التقاط الشاشة',
    course_creation_screen_desc:
      'إنشاء الدورات باستخدام وظيفة التقاط الشاشة',

    downloads_center: 'مركز التنزيلات',
    downloads_center_desc:
      'الوصول إلى المحتوى المُنزّل وإدارته من مركز التنزيلات',

    // REPORTS
    reports_analytics: 'التقارير والتحليلات',
    reports_analytics_desc:
      'دليل شامل للتقارير والتحليلات في Sharelook',

    reports_detailed: 'التقارير والتحليلات التفصيلية',
    reports_detailed_desc:
      'نظرة عامة تفصيلية لجميع ميزات التقارير وقدرات التحليلات',

    workshop_report: 'تقرير ورشة العمل',
    workshop_report_desc: 'عرض وتحليل تقارير أداء ورشة العمل',

    user_report: 'تقرير المستخدم',
    user_report_desc:
      'الوصول إلى تقارير شاملة لنشاط المستخدم والأداء',

    course_report: 'تقرير الدورة',
    course_report_desc:
      'عرض تقارير تفصيلية عن إكمال الدورة والمشاركة',

    live_events_report: 'تقرير الأحداث المباشرة',
    live_events_report_desc:
      'تحليل مقاييس الحضور والمشاركة للأحداث المباشرة',

    metamaze_reports: 'تقارير Metamaze',
    metamaze_reports_desc:
      'عرض تقارير الأداء والإكمال لوحدات Metamaze',

    live_assessments_reports: 'تقارير التقييم المباشر',
    live_assessments_reports_desc:
      'الوصول إلى تقارير أداء ونتائج التقييم المباشر',

    skill_journey_reports: 'تقارير رحلة المهارة',
    skill_journey_reports_desc:
      'تتبع التقدم وتقارير الإكمال لرحلات المهارات',

    sharesphere_report: 'تقرير Sharesphere',
    sharesphere_report_desc:
      'عرض تقارير المشاركة والنشاط لمحتوى ShareSphere',

    // SKILL JOURNEY
    create_skill_journey: 'إنشاء رحلة المهارة',
    create_skill_journey_desc:
      'تعلم كيفية إنشاء وإدارة رحلات المهارات للمتعلمين',

    // PODCAST
    podcast_creation: 'إنشاء البودكاست',
    podcast_creation_desc: 'تعلم كيفية إنشاء وإدارة قنوات البودكاست',

    // CHANNEL
    video_channel_creation: 'إنشاء قناة الفيديو',
    video_channel_creation_desc:
      'إنشاء وتخصيص قنوات الفيديو للمحتوى الخاص بك',

    // REEL
    short_video_creation: 'إنشاء الفيديو القصير',
    short_video_creation_desc: 'تعلم كيفية إنشاء فيديوهات قصيرة جذابة',

    short_video_admin: 'عرض المسؤول للفيديو القصير',
    short_video_admin_desc:
      'إدارة ومراجعة الفيديوهات القصيرة من منظور المسؤول',

    // TRIVIA
    create_trivia: 'إنشاء التريفيا',
    create_trivia_desc: 'تعلم كيفية إنشاء ألعاب تريفيا جذابة',

    take_trivia: 'كيفية أخذ التريفيا - المتعلم',
    take_trivia_desc: 'تعلم كيفية المشاركة في ألعاب التريفيا كمتعلم',

    // MANAGEMENT
    add_users: 'إضافة المستخدمين',
    add_users_desc: 'إضافة وإدارة المستخدمين في مؤسستك',

    add_group: 'إضافة مجموعة',
    add_group_desc: 'إنشاء وإدارة مجموعات المستخدمين',

    // COACHING
    virtual_coach: 'المدرب الافتراضي',
    virtual_coach_desc: 'تعلم كيفية استخدام ميزة المدرب الافتراضي',

    coaching_creation: 'إنشاء جلسة التدريب',
    coaching_creation_desc: 'إنشاء وجدولة جلسات التدريب',

    coaching_session_creation: 'إنشاء جلسة التدريب',
    coaching_session_creation_desc: 'إنشاء وجدولة جلسات التدريب',

    coaching_booking: 'حجز موعد جلسة التدريب',
    coaching_booking_desc: 'كيفية حجز مواعيد جلسات التدريب المتاحة',

    booking_coaching_slot: 'حجز موعد جلسة التدريب',
    booking_coaching_slot_desc: 'كيفية حجز مواعيد جلسات التدريب المتاحة',

    // WORKSHOP
    my_workshop: 'ورشة العمل الخاصة بي',
    my_workshop_desc: 'نظرة عامة على قسم ورشة العمل وميزاته',

    add_scorm: 'إضافة SCORM في Sharelook',
    add_scorm_desc:
      'رفع دورة SCORM وتخصيصها بالشارات والشهادات وصور الغلاف',

    edit_skill_journey: 'تحرير رحلة المهارة',
    edit_skill_journey_desc: 'تعلم كيفية تحرير رحلة مهارة موجودة',

    edit_live_event: 'تحرير الحدث المباشر',
    edit_live_event_desc: 'تحرير وإدارة الأحداث المباشرة بفعالية',

    clone_course: 'استنساخ الدورة',
    clone_course_desc: 'استنساخ دورة موجودة لإعادة الاستخدام أو التعديل',

    clone_metamaze: 'استنساخ Metamaze',
    clone_metamaze_desc:
      'تعلم كيفية تكرار Metamaze للمتعلمين الجدد أو التحديثات',

    delete_skill_journey: 'حذف رحلة المهارة',
    delete_skill_journey_desc: 'عملية خطوة بخطوة لحذف رحلة المهارة',

    delete_live_event: 'حذف الحدث المباشر',
    delete_live_event_desc: 'حذف الأحداث المباشرة غير المرغوب فيها من المنصة',

    edit_course: 'تحرير الدورة',
    edit_course_desc: 'تحرير الدورات الموجودة وتحديث محتواها',

    delete_metamaze: 'حذف Metamaze',
    delete_metamaze_desc: 'تعلم كيفية حذف وحدة Metamaze بأمان',

    delete_podcast: 'حذف البودكاست',
    delete_podcast_desc: 'إزالة البودكاست الموجود من قناتك',

    delete_video_channel: 'حذف قناة الفيديو',
    delete_video_channel_desc: 'حذف قنوات الفيديو غير المرغوب فيها بسهولة',

    edit_video_channel: 'تحرير قناة الفيديو',
    edit_video_channel_desc: 'تعلم كيفية تحرير تفاصيل قنوات الفيديو الخاصة بك',

    delete_course: 'حذف الدورة',
    delete_course_desc: 'خطوات حذف الدورة نهائيًا',

    edit_metamaze: 'تحرير Metamaze',
    edit_metamaze_desc: 'تعلم كيفية إجراء تعديلات على وحدات Metamaze الموجودة',

    edit_podcast: 'تحرير البودكاست',
    edit_podcast_desc: 'تحرير حلقات البودكاست والتفاصيل بسهولة',

    create_live_event: 'كيفية إنشاء حدث مباشر',
    create_live_event_desc:
      'دليل خطوة بخطوة لإنشاء وجدولة الأحداث المباشرة',

    translate_course: 'كيفية ترجمة الدورة',
    translate_course_desc:
      'تعلم كيفية ترجمة محتوى الدورة إلى لغات متعددة',

    // LEADERBOARD
    create_competition: 'كيفية إنشاء مسابقة',
    create_competition_desc:
      'إعداد المسابقات ولوحات المتصدرين لإشراك المتعلمين',

    leaderboard_settings: 'إعدادات لوحة المتصدرين',
    leaderboard_settings_desc: 'تكوين إعدادات لوحة المتصدرين والمسابقة',

    leaderboard_learner_view: 'لوحة المتصدرين - عرض المتعلم',
    leaderboard_learner_view_desc:
      'عرض لوحات المتصدرين والمسابقات من منظور المتعلم',

    // MARKETPLACE
    marketplace: 'السوق',
    marketplace_desc:
      'نظرة عامة على السوق وكيفية شراء وبيع المحتوى',

    buy_course: 'كيفية شراء دورة',
    buy_course_desc: 'تعلم كيفية شراء الدورات من السوق',

    book_coaching: 'كيفية حجز جلسة تدريب',
    book_coaching_desc:
      'دليل خطوة بخطوة لحجز جلسات التدريب من السوق',

    buy_podcast: 'كيفية شراء بودكاست',
    buy_podcast_desc: 'تعلم كيفية شراء اشتراكات البودكاست',

    subscribe_channel: 'كيفية شراء/الاشتراك في قناة فيديو',
    subscribe_channel_desc:
      'الاشتراك في قنوات الفيديو والوصول إلى المحتوى المميز'
  },

  v5: {
    my_video_shorts: 'مقاطع الفيديو الخاصة بي',
    see_more: 'عرض المزيد',
    no_shorts_found: 'لم يتم العثور على مقاطع قصيرة',
    shorts: 'مقاطع قصيرة',
    general_information: 'معلومات عامة',
    gamification: 'الت gamification',
    click_to_select_files: 'انقر لاختيار الملفات',
    selected_files: 'الملفات المحددة',
    uploaded: 'تم الرفع',
    failed: 'فشل',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'سيقوم النظام بتحليل وتحديد أكثر المستندات صلة من مكتبة مؤسستك بناءً على متطلبات المحتوى.',
    select_from_library: 'اختر من المكتبة',
    search_document: 'ابحث في المستندات...',
    selected: 'تم التحديد',
    loading_documents: 'جارٍ تحميل المستندات...',
    review_generated_content: 'مراجعة المحتوى المُولد',
    confirm_and_replace_content: 'تأكيد واستبدال المحتوى',
    the_generate_content_will_replace:
      'سيحل المحتوى المُولد محل النص الموجود على الصفحات المحددة. إذا لم ترغب في تطبيق هذه التغييرات، يمكنك العودة إلى الخطوة السابقة.',
    pages_to_be_updated: 'الصفحات التي سيتم تحديثها',
    generated_revisions: 'المراجعات المُولدة',
    lesson_preview: 'معاينة الدرس',
    create_new_folder: 'إنشاء مجلد جديد',
    interactive_simulation: 'درس تفاعلي',
    rename_item: 'إعادة تسمية العنصر',
    enter_folder_name: 'أدخل اسم المجلد:',
    enter_new_name: 'أدخل الاسم الجديد:',
    folder_name: 'اسم المجلد:',
    new_name: 'اسم جديد',
    move_items: 'نقل العناصر',
    copy_items: 'نسخ العناصر',
    move_here: 'انقل إلى هنا',
    copy_here: 'انسخ إلى هنا',
    select_destination_library_and_folder: 'اختر مكتبة و مجلد الوجهة:',
    items_selected: 'العناصر المحددة',
    version: 'الإصدار',
    modified_by: 'تم التعديل بواسطة',
    size: 'الحجم',
    restore: 'استعادة',
    are_you_sure_you_want_to_restore_this_version:
      'هل أنت متأكد من رغبتك في استعادة هذا الإصدار؟',
    this_will_replce_the_current_version_with_the_selected_one:
      'سيتم استبدال الإصدار الحالي بالإصدار المحدد.',
    restore_this_version: 'استعادة هذا الإصدار',
    restore_not_available: 'الاستعادة غير متوفرة',
    version_history: 'سجل الإصدارات:',
    by_making_items_public:
      'بجعل العناصر عامة، ستكون مرئية للجميع. يرجى مراجعة الشروط والأحكام قبل المتابعة.',
    the_selected_items_will_be_copied:
      'سيتم نسخ العناصر المحددة إلى مكتبتك العامة وستكون مرئية للجميع.',
    the_selected_items_will_be_copied_to_org:
      'سيتم نسخ العناصر المحددة إلى مكتبة مؤسستك وستكون مرئية لجميع أعضاء المؤسسة.',
    the_selected_items_will_be_copied_to_your_private:
      'سيتم نسخ العناصر المحددة إلى مكتبتك الخاصة ولن تكون مرئية إلا لك.',
    loading_organization: 'جارٍ تحميل مستخدمي المؤسسة...',
    click_download_to_view: 'انقر على "تحميل" للعرض',
    archive_file: 'ملف أرشيف',
    no_preview_available: 'لا توجد معاينة متاحة',
    audit_report: 'تقرير التدقيق',
    audit_type: 'نوع الإجراء',
    i_agree_to_the_terms_and_conditions: 'أوافق على الشروط والأحكام.',
    this_file_is_indexed_for_ai: 'تم فهرسة هذا الملف للذكاء الاصطناعي.',
    file_is_not_indexed_for_ai: 'لم يتم فهرسة الملف للذكاء الاصطناعي.',
    no_users_found: 'لم يتم العثور على مستخدمين',
    no_users_available: 'لا يوجد مستخدمون متاحون',
    add_people: 'إضافة أشخاص',
    people: 'أشخاص',
    access_type: 'نوع الوصول',
    no_group_found: 'لم يتم العثور على مجموعات',
    add_group: 'إضافة مجموعات',
    groups: 'مجموعات',
    users_top: 'مستخدم(ون)',
    confirm_delete: 'تأكيد الحذف',
    do_you_want_remove: 'هل أنت متأكد من رغبتك في إزالة',
    form_this_documents_permissions: 'من أذونات هذا المستند؟',
    no_users_found_in_this_group: 'لم يتم العثور على مستخدمين في هذه المجموعة',
    add_selected_users: 'إضافة المستخدمين المحددين',
    choose_users_from_the_list: 'اختر مستخدمين من القائمة',
    selected_users: 'المستخدمون المحددون',
    archived: 'تم أرشفته',
    request_approval: 'طلب الموافقة',
    document_in_review: 'المستند قيد المراجعة',
    approve: 'موافقة',
    reject: 'رفض',
    comment: 'تعليق:',
    enter_your_commit: 'أدخل تعليقك...',
    confirm_cancel: 'تأكيد الإلغاء',
    upload_3d_zip: 'رفع ملف 3D Zip',
    delete_items: 'حذف العناصر',
    video_upload_request: 'طلب رفع فيديو',
    reject_video: 'رفض الفيديو',
    enter_rejection_reason: 'أدخل سبب الرفض...',
    please_provide_a_reason_for_reejection_this_video:
      'يرجى تقديم سبب لرفض هذا الفيديو:',
    generate_trivia_with_ai: 'إنشاء أسئلة تريفيا بالذكاء الاصطناعي',
    select_category: 'اختر الفئة:',
    number_of_question: 'عدد الأسئلة',
    generated_questions: 'الأسئلة المُنشأة',
    this_will_clear_all_generate_question:
      'سيؤدي هذا إلى مسح جميع الأسئلة المُنشأة. هل تريد المتابعة؟',
    sure_delete: 'هل أنت متأكد من الحذف؟',
    delete_this_question: 'هل أنت متأكد من حذف هذا السؤال؟',
    loading_quiz: 'جارٍ تحميل الاختبار...',
    creteing_file: 'جارٍ إنشاء الملف',
    opening_desktop_app: 'جارٍ فتح تطبيق سطح المكتب',
    this_folder_is_empty: 'هذا المجلد فارغ',
    select_a_competition: 'اختر مسابقة...',
    activity_badges: 'شارات النشاط',
    awarded_every_badges: 'تُمنح كل 4، 8، 16، 32، 64، 128، 256، 512 تسجيل دخول',
    learning_badges: 'شارات التعلم',
    awarded_every_courses: 'تُمنح كل 1، 4، 8، 16، 32، 64، 128 دورة مكتملة',
    test_badges: 'شارات الاختبار',
    awarded_every_passes_tests:
      'تُمنح كل 2، 4، 8، 16، 32، 64، 128، 256 اختبار ناجح',
    assignment_badges: 'شارات المهام',
    awarded_every_passed_assignments:
      'تُمنح كل 1، 2، 4، 8، 16، 32، 64، 128 مهمة ناجحة',
    perfectionism_badges: 'شارات الإتقان',
    awarded_every_assignments_with_scrore:
      'تُمنح كل 1، 2، 4، 8، 16، 32، 64، 128 اختبار أو مهمة بنتيجة 90%+',
    communication_badges: 'شارات التواصل',
    awarded_every_topics_or_comments:
      'تُمنح كل 2، 4، 8، 16، 32، 64، 128، 256 موضوع أو تعليق',
    certification_badges: 'شارات الشهادة',
    awarded_every_certificates: 'تُمنح كل 1، 2، 4، 8، 16، 32، 64، 128 شهادة',
    level_name: 'اسم المستوى',
    delete_competition: 'حذف المسابقة',
    this_week: 'هذا الأسبوع',
    this_year: 'هذا العام',
    folder: 'مجلد',
    item: 'عنصر',
    make_organization: 'جعلها منظمة',
    no_results_found: 'لم يتم العثور على نتائج لـ',
    no_items_available: 'لا توجد عناصر متاحة',
    help_video: 'فيديوهات المساعدة',
    select_a_video_from_the_list: 'اختر فيديو من القائمة للبدء بالتعلم',
    relevant_videos_label: 'فيديوهات فردية',
    pinned_bundle_label: 'دليل كامل',

    recording: 'التسجيل',
    on: 'تشغيل',
    off: 'إيقاف',
    started_on: 'بدأ في',
    created_on: 'تم الإنشاء في',
    this: 'هذا',
    list_arrangement_will_be_primary_order:
      'سيكون ترتيب القائمة هو الترتيب الأساسي للقائمة المرئية في صفحة التدريب.',
    sequence_order: 'ترتيب التسلسل',
    sequence_not_set: 'لم يتم تعيين التسلسل',
    order_sequence_set_successfully: 'تم تعيين تسلسل الترتيب بنجاح',
    search_for_stock_images: 'البحث عن صور مخزنة...',
    search_for_a_location: 'البحث عن موقع...',
    loading_suggestions: 'جارٍ تحميل الاقتراحات...',
    suggested_locations: 'المواقع المقترحة:',
    available: 'متاح',
    no_podcast_is_available: 'لا يوجد بودكاست متاح!',
    no_mazes_available: 'لا توجد متاهات متاحة!',
    grid_view: 'عرض الشبكة',
    list_view: 'عرض القائمة',
    create_a_subtle_and_non_distracting_background_image:
      'إنشاء صورة خلفية دقيقة وغير مشتتة للانتباه لدورة رقمية، مستوحاة من',
    the_image_should_incorporate_elements_of:
      'يجب أن تتضمن الصورة عناصر من',
    vary_abstract_faded_or_minimalist_way:
      'بطريقة مجردة جدًا أو باهتة أو بسيطة. استخدم ألوانًا ناعمة للغاية أو تدرجات لطيفة أو أنماطًا بالكاد ملحوظة تلمح إلى الموضوع دون أن تكون حرفية أو بارزة جدًا. يجب أن يكون التأثير العام خفيفًا وجيد التهوية، مما يسمح بسهولة قراءة النص والمحتوى المتراكب. يجب أن يكون التصميم مناسبًا لنسبة عرض إلى ارتفاع 16:9 ويستوعب عناصر واجهة المستخدم المختلفة. تأكد من توزيع العناصر بالتساوي عبر الصورة لإنشاء خلفية متوازنة وغير مشتتة.',
    top_left: 'أعلى اليسار',
    top_right: 'أعلى اليمين',
    bottom_left: 'أسفل اليسار',
    bottom_right: 'أسفل اليمين',
    select_position_of_image_you_like: 'اختر موضع الصورة التي تعجبك',
    select_a_position_of_image:
      'اختر موضع الصورة التي تعجبك لإنشاء تنويعاتها',
    generate_variations: 'إنشاء تنويعات',
    select_a_position_of_image_upscale:
      'اختر موضع الصورة التي تعجبك لتكبيرها',
    upscale_image_for_selection: 'تكبير الصورة للاختيار',
    generation_variations: 'جارٍ إنشاء التنويعات...',
    generating_your_image: 'جارٍ إنشاء صورتك...',
    waiting_start_generation: 'في انتظار بدء الإنشاء',
    variations: 'تنويعات',
    upscaling_image: 'جارٍ تكبير الصورة...',
    upscaled_image: 'الصورة المكبرة',
    ai_generate_image: 'صورة منشأة بالذكاء الاصطناعي',
    select: 'اختيار',
    generate_image_using_your_image: 'إنشاء صورة باستخدام فكرة صورتك الخاصة',
    please_enter_your_idea: 'يرجى إدخال فكرة صورتك...',
    your_prompt_here: 'اكتب طلبك هنا...',
    add_text_in_the_image: 'إضافة نص في الصورة',
    what_type_image_do_you_generate:
      'ما نوع الصورة التي ترغب في إنشائها؟ يرجى وصف المشهد أو الأشياء أو أي تفاصيل محددة لديك، وسأبذل قصارى جهدي لإنشائها لك.',
    are_you_sure_you_want_to_start_a_new_chat:
      'هل أنت متأكد من رغبتك في بدء محادثة جديدة؟',
    start_new_chat: 'بدء محادثة جديدة',
    stop_chat: 'إيقاف المحادثة',
    start_chat: 'بدء المحادثة',
    created_successfully: 'تم الإنشاء بنجاح',
    failed_to_create_folder: 'فشل في إنشاء المجلد',
    please_enter_name: 'يرجى إدخال اسم',
    failed_to_rename_file_folder: 'فشل في إعادة تسمية الملف/المجلد',
    opened_download_link_in_new_tab: 'تم فتح رابط التنزيل في علامة تبويب جديدة',
    failed_to_get_download_link: 'فشل في الحصول على رابط التنزيل',
    prepare_download: 'جارٍ تحضير التنزيلات...',
    failed_download_link: 'فشل في الحصول على رابط التنزيل للمعرف',
    open_first_download: 'تم فتح رابط التنزيل الأول. تحقق من وحدة التحكم للحصول على',
    additional_link: 'روابط إضافية.',
    prepared: 'تم التحضير',
    download_link: 'روابط التنزيل',
    no_download_file: 'لم يتم العثور على ملفات قابلة للتنزيل',
    download_failed: 'فشل تحضير التنزيل',
    certificate_title_is_required: 'عنوان الشهادة مطلوب.',
    are_you_sure_you_want_to_attach_this_certificate:
      'هل أنت متأكد من رغبتك في إرفاق هذه الشهادة بهذه الدورة؟ ستكون متاحة أيضًا في سجل شهاداتك.',
    update_badge: 'تحديث الشارة',
    attach_audio: 'إرفاق صوت',
    correct_answer_is_required: 'الإجابة الصحيحة مطلوبة.',
    or: 'أو',
    insert_scenario: 'إدراج سيناريو',
    as_screen_capture: 'مع التقاط الشاشة',
    as_simulation: 'مع المحاكاة',
    added_avatar: 'تمت إضافة الصورة الرمزية',
    select_avatar: 'اختر الصورة الرمزية',
    add_audio: 'إضافة صوت',
    only_to_options: 'من 2 إلى 4 خيارات فقط',
    only_to_layers: 'من 2 إلى 8 طبقات فقط',
    shop: 'SOP',
    video_channel: 'قناة الفيديو',
    podcasts: 'البودكاست',
    organisations: 'المنظمات',
    org_groups: 'مجموعات المنظمة',
    channel_outline_is_required: 'مخطط القناة مطلوب',
    channel_obj_required: 'أهداف القناة مطلوبة.',
    enter_value: 'يرجى إدخال قيمة.',
    no_basket_to_add: 'لم يتم تحديد عنصر (عناصر) لإضافتها إلى السلة',
    find_your_video: 'ابحث عن معرفات مستخدم وقناة YouTube الخاصة بك',
    each_youtube_channel_has_unique:
      'كل قناة YouTube لها معرف مستخدم فريد ومعرف قناة. تُستخدم هذه المعرفات للإشارة إلى القناة في تطبيقات وخدمات معينة.',
    find_channel_id: 'كيفية العثور على معرف المستخدم ومعرف القناة لقناتك',
    your_channel_user_id:
      'يمكنك العثور على معرف المستخدم ومعرف القناة لقناتك في',
    advance_account: 'إعدادات الحساب المتقدمة',
    computer_or_mobile_browser: 'على جهاز كمبيوتر أو متصفح الجوال.',
    sign_in_to: 'تسجيل الدخول إلى',
    click_profile_pic_left: 'في أعلى اليمين، انقر على صورة ملفك الشخصي',
    from_the_left_menu: 'من القائمة اليسرى، اختر',
    adv_setting: 'الإعدادات المتقدمة',
    user_channel_id_there:
      'سترى معرف المستخدم ومعرف القناة لقناتك هناك.',
    you_can_also: 'يمكنك أيضًا',
    manage_channel: 'إدارة اسم قناتك',
    studio_youtube: 'في YouTube Studio.',
    sharesphere_question_updated: 'تم تحديث سؤال ShareSphere',
    select_category: 'اختر الفئة (الفئات)',
    please_select_category: 'يرجى اختيار الفئة (الفئات)!',
    ShareSphere_question_created: 'تم إنشاء سؤال ShareSphere',
    generate_text: 'إنشاء إلى نص',
    ar_trigger_image: 'صورة تفعيل الواقع المعزز',
    name_of_the_guest: 'اسم الضيف رقم',
    library: 'المكتبة',
    previous: 'السابق',
    draft: 'مسودة',
    unpublishing: 'جارٍ إلغاء النشر',
    publishing: 'جارٍ النشر',
    unpublish_from_marketplace: 'إلغاء النشر من السوق',
    unpublished: 'غير منشور',
    unpublish: 'إلغاء النشر',
    publish: 'نشر',
    quiz_complete: 'اكتمل الاختبار',
    lesson_complete: 'اكتمل الدرس',
    get_certificate: 'الحصول على الشهادة',
    select_participants: 'اختر المشاركين',
    competition_updated_successfully: 'تم تحديث المسابقة بنجاح!',
    competition_created_successfully: 'تم إنشاء المسابقة بنجاح!',
    levels_configuration: 'تكوين المستويات',
    account_subscribptions: 'الاشتراكات النشطة',
    search_organisation: 'البحث عن منظمة',

    generate_an_engaging_introduction_to_capture:
      'إنشاء مقدمة جذابة لجذب انتباه جمهورك وتحديد نبرة الدرس.',
    create_a_comprehensive_summary:
      'إنشاء ملخص شامل يعزز النقاط الرئيسية ويختتم درسك بفعالية.',
    introductio_added_at_the_beginning:
      'تمت إضافة المقدمة في بداية الدرس.',
    summary_added: 'تمت إضافة الملخص في نهاية الدرس.',
    you_cannot_add_other_element_in_a_scenario_page:
      'لا يمكنك إضافة عنصر آخر في صفحة السيناريو. يرجى تجربة صفحات أخرى أو إزالة السيناريو من الصفحة أولاً.',
    pages_list_whose_content_you_want_to_reference:
      'يرجى النقر على الصفحات من قائمة الصفحات التي تريد الإشارة إلى محتواها في',
    choose_your_story: 'اختر قصتك',
    generate_scenario: 'إليك السيناريو المُنشأ!',
    will_help_you_create_scenario:
      'مرحبًا! سأساعدك في إنشاء سيناريو. على ماذا تريد التركيز؟',
    sorry_encountered_an_error:
      'عذرًا، واجهت خطأ. يرجى المحاولة مرة أخرى.',
    chat_based_scenario_generation: 'إنشاء السيناريو بالمحادثة',
    start_conversation_to_generate:
      'ابدأ محادثة لإنشاء السيناريو الخاص بك من خلال حوار تفاعلي.',
    view_scenario: 'عرض السيناريو',
    use_this_scenario: 'استخدام هذا السيناريو',
    prompt_helper: 'مساعد الطلب',
    hide_prompt_helper: 'إخفاء مساعد الطلب',
    please_upload_reference_image:
      'يرجى رفع صورة مرجعية واحدة على الأقل لوضع تحرير الصورة',
    error_generating_image: 'خطأ في إنشاء الصورة. يرجى المحاولة مرة أخرى!',
    max_reference_images_allowed:
      'الحد الأقصى 9 صور مرجعية. يرجى إزالة صورة أولاً.',
    failed_to_convert_image_url: 'فشل في تحويل رابط الصورة!',
    preparing_variations: 'جارٍ تحضير التنويعات...',
    preparing_image: 'جارٍ تحضير الصورة...',
    generated_image_alt: 'الصورة المُنشأة',
    processing_your_request: 'جارٍ معالجة طلبك...',
    generating_variations_in_progress: 'جارٍ إنشاء التنويعات',
    lightning_fast_generation_in_progress:
      'جارٍ الإنشاء السريع',
    file: 'ملف',
    is_too_large: 'كبير جدًا',
    mb: 'ميجابايت',
    limit_is: 'الحد هو',
    please_enter_image_idea: 'يرجى إدخال فكرة صورتك...',
    what_type_image_generate:
      'ما نوع الصورة التي ترغب في إنشائها؟ يرجى وصف المشهد أو الأشياء أو أي تفاصيل محددة لديك، وسأبذل قصارى جهدي لإنشائها لك.',
    select_pixel_image_title: 'اختر صورة البكسل',
    stock_image: 'صورة مخزنة',
    pagination_of: 'من',
    pagination_images: 'صور',
    reference_image_alt: 'صورة مرجعية',
    user_alt: 'مستخدم',
    story_description_tone: 'المزاج أو الموقف العام للقصة.',
    story_description_narrative_hook:
      'سطر أو فقرة افتتاحية جذابة تجذب انتباه القارئ وتمهد للقصة.',
    story_description_narrative_style:
      'منظور يُروى منه القصة.',
    story_description_story_plot:
      'الحبكة هي كيفية عرض القصة، مثل الفيلم أو الكتاب. إنها الترتيب الذي تحدث به الأحداث. في بعض الأحيان يتم عرضها واحدة تلو الأخرى، وفي أحيان أخرى يتم خلطها. على سبيل المثال، تبدأ بعض القصص بالنهاية ثم تعود إلى البداية للشرح.',
    story_description_complexity: 'مستوى الصعوبة وعمق القصة.',
    story_description_genre: 'فئة أو نوع القصة.',
    story_description_vocabulary: 'اختيار واستخدام الكلمات.',
    story_description_narrative_structure: 'تنظيم أحداث القصة.',
    story_description_time_period: 'الحقبة التي تدور فيها القصة.',
    story_description_story_length: 'طول السرد.',
    story_description_character_names: 'أسماء الشخصيات في القصة.',
    story_description_output_type: 'تنسيق القصة.',
    story_chat_initial_message:
      'مرحبًا! سأساعدك في إنشاء قصة. على ماذا تريد التركيز؟',
    story_add_to_pages_title: 'هل تريد إضافة القصة إلى الصفحات؟',
    story_add_to_pages_content:
      'سيتم استبدال المحتوى الأصلي بنص القصة.',
    story_chat_error_message:
      'عذرًا، واجهت خطأ. يرجى المحاولة مرة أخرى.',
    story_generated_story_label: 'القصة المُنشأة',
    story_generating: 'جارٍ الإنشاء...',
    story_use_story_title: 'هل تريد استخدام هذه القصة المُنشأة؟',
    story_use_story_content:
      'سيؤدي هذا إلى فتح محرر القصة حيث يمكنك إجراء مزيد من التعديلات قبل إضافتها إلى درسك.',
    story_use_story_button: 'استخدام القصة',
    story_chat_placeholder: 'اكتب رسالتك...',
    story_chat_send: 'إرسال',
    story_form_mode: 'وضع النموذج',
    story_chat_mode: 'وضع المحادثة',
    story_page_heading: 'القصة',
    bullet_points: 'النقاط',
    scenario_generation: 'إنشاء السيناريو',
    please_enter_number_of_questions: 'يرجى إدخال عدد الأسئلة',
    bullet_points: 'النقاط',
    tags_all: 'الكل',
    delete_file_confirm: 'هل أنت متأكد من رغبتك في حذف هذا الملف؟',
    delete_file_title: 'حذف الملف',
    tooltip_publish: 'نشر الدورة على الخيار المحدد',
    tooltip_save: 'حفظ الدورة مع التحديثات الحالية',
    tooltip_next: 'الانتقال إلى إعداد الدورة التالي',
    tooltip_finish: 'إكمال وحفظ التحديثات الحالية',
    delete_confirmation: 'هل أنت متأكد من رغبتك في الحذف',
    maze_summary: 'ملخص المتاهة',
    course_recommendation: 'توصية الدورة',
    downlad_center_save_summary: 'حفظ الملخص في مركز التنزيلات',
    loading_maze_summary: 'جارٍ تحميل ملخص المتاهة...',
    generating_course_recommendation: 'جارٍ إنشاء توصية الدورة...',
    no_course_recommended: 'لا توجد دورة موصى بها.',
    click_to_view_course: 'انقر لعرض الدورة',
    select_simulation_type: 'اختر نوع المحاكاة',
    simulation_mode: 'وضع المحاكاة',
    attempts_count: 'عدد المحاولات',
    no_of_attempts_user_can_try: 'عدد المحاولات التي يمكن للمستخدم تجربتها',
    uload_section_file: 'رفع ملف القسم',
    my_library: 'مكتبتي',
    search_documents_by_name: 'البحث عن المستندات بالاسم...',
    document: 'مستند',
    org_library: 'مكتبة المنظمة',
    top_center: 'أعلى الوسط',
    center: 'الوسط',
    bottom_center: 'أسفل الوسط',
    big: 'كبير',
    small: 'صغير',
    medium: 'متوسط',
    text_position: '📝 موضع النص',
    please_select_text: 'يرجى اختيار موضع النص',
    note_that_ai_generated_content_may_not_always_be_accurate:
      '* يرجى ملاحظة أن المحتوى المُنشأ بالذكاء الاصطناعي قد لا يكون دقيقًا دائمًا. قد يكون وضع النص وتنسيقه، مثل إضافة النص، غير دقيق في بعض الأحيان.',
    number_of_images: '📝 عدد الصور',
    please_select_of_image: 'يرجى اختيار عدد الصور',
    creating_calc_spreadsheet: 'جارٍ إنشاء جدول بيانات Calc...',
    creating_calc_spreadsheet_successfully:
      'تم إنشاء ورفع جدول بيانات Calc بنجاح!',
    opening_sharelook: 'جارٍ فتح ShareLook...',
    shareLook_opened_successfully: 'تم فتح ShareLook بنجاح!',
    upload_function_not_provided:
      'تم إنشاء ورفع عرض Impress بنجاح!',
    creating_impress_presentation: 'جارٍ إنشاء عرض Impress...',

    talk_with_course_assistants: 'تحدث مع مساعدي الدورة',
    select_your_coacher: 'اختر مدربك',
    simon_witts_aviation_generation_ccoacher:
      'Simon Witts - Aviation Generation - مدرب',
    simon_witts: 'Simon Witts',
    aviation_generation_coacher: 'Aviation Generation - مدرب',
    coacher_mode_active: 'وضع المدرب نشط',
    your_personal_coaching_experience: 'تجربة التدريب الشخصية الخاصة بك',
    powered_by: 'مدعوم من',
    uk_civil_viation_authority_data: 'بيانات هيئة الطيران المدني البريطانية',
    start_coaching_session: 'بدء جلسة التدريب',
    what_image_do_you_need: 'ما الصورة التي تحتاجها؟',
    write_something: 'اكتب شيئًا.',
    speak: 'تحدث',
    grid: 'شبكة',
    ar: 'الواقع المعزز',
    premium_voices: 'أصوات مميزة',
    default_tts: 'TTS الافتراضي',
    generate_audio: 'إنشاء صوت',
    username_or_email_address: 'اسم المستخدم أو عنوان البريد الإلكتروني',
    meta_maze_avatars: 'صور MetaMaze الرمزية',
    training_skill_journey: 'رحلة مهارة التدريب',
    marketplace: 'السوق',
    are_you_sure_you_want_to_update_your_course_template:
      'هل أنت متأكد من رغبتك في تحديث قالب دورتك؟',
    this_will_automatically_update_the_template:
      'سيؤدي هذا إلى تحديث القالب تلقائيًا لجميع الدروس والصفحات المُنشأة في دورتك.',
    note_this_process_will_change_the_course_lesson_layouts:
      'ملاحظة: ستؤدي هذه العملية إلى تغيير تخطيطات دروس الدورة، مما قد يؤثر على مواضع الصوت والفيديو والصور والعناصر الأخرى. إذا أضفت عناصر جديدة إلى قالب موجود في أي صفحة، فستظل مواضعها دون تغيير.',
    open_sharelook_application: 'فتح تطبيق ShareLook؟',
    this_will_launch_sharelook_for_screen_capture:
      'سيؤدي هذا إلى تشغيل ShareLook لالتقاط الشاشة.',
    open: 'فتح',
    are_you_sure_you_want_to_save_this_certificate_for_later:
      'هل أنت متأكد من رغبتك في حفظ هذه الشهادة لاحقًا؟ لن يتم إرفاقها بهذه الدورة ولكنها ستكون متاحة في سجل شهاداتك.',
    are_you_sure_you_want_to_remove_this_media:
      'هل أنت متأكد من رغبتك في إزالة هذه الوسائط؟',
    the_media_will_be_removed_from_the_scenario:
      'ستتم إزالة الوسائط من السيناريو.',
    proceed_to_template_selection: 'المتابعة إلى اختيار القالب',
    template_selection: 'اختيار القالب',

    competition_title_is_required: 'عنوان المسابقة مطلوب!',
    competition_description_is_required: 'وصف المسابقة مطلوب!',
    skill_selection_is_required: 'اختيار المهارة مطلوب!',
    start_date_is_required: 'تاريخ البدء مطلوب!',
    end_date_is_required: 'تاريخ الانتهاء مطلوب!',
    start_date_must_be_before_end_date: 'يجب أن يكون تاريخ البدء قبل تاريخ الانتهاء!',
    points_cannot_be_negative: 'لا يمكن أن تكون النقاط سالبة!',
    points_connot_exceed: 'لا يمكن أن تتجاوز النقاط 1000!',
    error_occured_while_creating_the_competition:
      'حدث خطأ أثناء إنشاء المسابقة.',
    select_question_type: 'اختر نوع السؤال',
    please_select_question_type: 'يرجى اختيار نوع السؤال!',
    search_by_title_or_description: 'البحث بالعنوان أو الوصف...',
    no_videos_found_matching: 'لم يتم العثور على فيديوهات مطابقة لـ',
    what_new_at_shareLook: 'ما الجديد في ShareLook',
    did_you_know_that_creating_learning_experience:
      'هل تعلم أن إنشاء تجربة تعليمية بأسلوب سرد القصص أمر سهل وسريع وغير مكلف؟ يجب عليك دمج منشئ دورات ShareLook مع مواهبك الخاصة. اسألنا كيف.',
    welcome_to_shareLook_help_center: 'مرحبًا بك في مركز مساعدة ShareLook',
    select_video_from_the_left_navigation:
      'اختر فيديو من القائمة اليسرى للبدء، أو استخدم البحث للعثور على محتوى محدد.',
    date_time_error_peer:
      'يجب أن يكون وقت بدء الحدث قبل دقيقة واحدة على الأقل من الآن.',
    no_language_information_available:
      'لا توجد معلومات لغوية متاحة لهذه الأصوات.',
    loading_eventlabs_voices: 'جارٍ تحميل أصوات ElevenLabs...',
    search_voices: 'البحث عن الأصوات...',
    please_upload_at_last_one_supported_file:
      'يرجى رفع ملف واحد مدعوم على الأقل.',
    you_can_upload_a_maximum_of_files: 'يمكنك رفع 5 ملفات كحد أقصى.',
    failed_to_load_documents: 'فشل في تحميل المستندات. يرجى المحاولة مرة أخرى.',
    file_not_supported: 'ليس نوع ملف مدعوم. الأنواع المقبولة:',
    required_fields_are_missing: 'الحقول المطلوبة مفقودة.',
    form_validation_failed: 'فشل التحقق من النموذج.',
    select_cloned_voice: 'اختر الصوت المستنسخ',
    upload_voice: 'الأصوات المرفوعة',
    max_five: '5 (الحد الأقصى)',
    loading_list: 'جارٍ تحميل القائمة...',
    failed_to_create_podcast: 'فشل في إنشاء البودكاست!',
    failed_to_create_voicce: 'فشل في إنشاء الصوت!',
    make_public_success: 'تم جعل العناصر عامة بنجاح',
    make_org_success: 'تم نقل العناصر إلى المنظمة بنجاح',
    make_private_success: 'تم جعل العناصر خاصة بنجاح',
    make_public_failed: 'فشل في جعل العناصر عامة',
    make_org_failed: 'فشل في نقل العناصر إلى المنظمة',
    make_private_failed: 'فشل في جعل العناصر خاصة',
    the_number_of_choices_or_paths_available:
      'عدد الخيارات أو المسارات المتاحة للمتعلم. سيتم تعطيل هذا القسم إذا اختار المتعلم نوع السيناريو المفتوح. <2، 3، 4>',
    select_this_image: 'اختر هذه الصورة',
    please_select_a_font_size: 'يرجى اختيار حجم الخط',
    font_style: 'نمط الخط',
    please_select_a_font_style: 'يرجى اختيار نمط الخط',
    font_type: 'نوع الخط',
    please_select_a_font_type: 'يرجى اختيار نوع الخط',
    text_color: 'لون النص',
    please_select_a_text_color: 'يرجى اختيار لون النص',
    regular: 'عادي',
    bold: 'عريض',
    italic: 'مائل',
    thin: 'رفيع',
    font_retro: 'ريترو',
    font_techy: 'تقني',
    font_neon: 'نيون',
    font_sketch: 'رسم',
    font_3d: 'ثلاثي الأبعاد',
    font_comic_style: 'نمط كوميدي',
    font_anime_style: 'نمط أنمي',
    font_illustration: 'رسم توضيحي',
    font_hand_written: 'مكتوب بخط اليد',
    font_quirky: 'غريب',
    font_chalk_board: 'لوح طباشيري',
    color_vibrant: 'نابض بالحياة',
    color_black_white: 'أبيض وأسود',
    color_gold_script: 'نص ذهبي',
    color_rainbow_neon: 'نيون قوس قزح',
    color_gradient: 'تدرج',
    text_options: 'خيارات النص',
    icon_text: '📝 نص',
    type_message: 'اكتب رسالة',
    please_upload_at_least_one_supported_file:
      'يرجى رفع ملف واحد مدعوم على الأقل (.pdf, .doc, .docx, .ppt, .pptx, .txt).',
    select_files_to_upload: 'اختر الملفات للرفع',
    showing: 'عرض',
    are_you_sure_delete_file_confirm: 'هل أنت متأكد من رغبتك في حذف هذا',
    click_to_open_pdf_reference: 'انقر لفتح مرجع PDF',
    click_to_open: 'انقر للفتح',
    write_here: 'اكتب هنا...',
    content_edited_successfully: 'تم تحرير المحتوى بنجاح!',
    failed_to_edit_content: 'فشل في تحرير المحتوى',
    please_enter_editing_instruction: 'يرجى إدخال تعليمات التحرير',
    review_course_wide_changes: 'مراجعة التغييرات على مستوى الدورة',
    collapse_all: 'طي الكل',
    expand_all: 'توسيع الكل',
    adding_content_from_internet: 'جارٍ إضافة محتوى من الإنترنت...',
    no_content_found: 'لم يتم العثور على محتوى.',
    please_enroll_to_take_this_skill_journey:
      'يرجى التسجيل لأخذ رحلة المهارة هذه',
    edited_content: 'المحتوى المحرر',

    a_recommended_course_is_available:
      'دورة موصى بها متاحة. يرجى التحقق من التطبيق لمزيد من التفاصيل.',
    competition_deleted_successfully: 'تم حذف المسابقة بنجاح!',
    failed_to_delete_the_competition: 'فشل في حذف المسابقة!',
    generate_content_from: 'إنشاء محتوى من',
    minimum_score: 'الحد الأدنى للنتيجة',
    please_select_style: 'يرجى اختيار النمط',
    document_type: 'نوع المستند',
    select_document_type: 'اختر نوع المستند',
    please_select_document_type: 'يرجى اختيار نوع المستند',
    document_name: 'اسم المستند',
    please_enter_document_name: 'يرجى إدخال اسم المستند',

    infographics: 'مخططات معلوماتية',
    generate_infographics: 'إنشاء مخططات معلوماتية',
    course_builder: 'منشئ الدورة',
    short_videos: 'فيديوهات قصيرة',
    user_management: 'إدارة المستخدمين',
    user_agreement: 'اتفاقية المستخدم',
    terms_and_conditions_upper: 'الشروط والأحكام',

    connected: 'متصل',
    waiting_for_coach: 'في انتظار المدرب...',
    disconnected: 'غير متصل',
    coach_intro: 'مرحبًا، أنا مدرب DGF Logistic.',
    coach_help: 'كيف يمكنني مساعدتك؟',
    press_to_speak: 'اضغط هنا قبل التحدث',
    leave: 'مغادرة',
    open_the_sharelook_application_for_building_interactive_lesson: 'سيؤدي هذا إلى فتح تطبيق ShareLook لإنشاء درس تفاعلي. إذا لم يفتح التطبيق، فقد لا يكون مثبتًا على جهازك.',
    launch_interactive_lesson: 'بدء الدرس التفاعلي',
    create_interactive_lesson: 'إنشاء درس تفاعلي',
    set_up_your_interactive_lesson: 'إعداد الدرس التفاعلي الخاص بك',
    interactive_lesson_title: 'عنوان الدرس التفاعلي',
    enter_interactive_lesson_title: 'أدخل عنوان الدرس التفاعلي',
    this_feature_available_for_windows_user_only: 'هذه الميزة متاحة فقط لمستخدمي ويندوز',
    preparing_interactive_lesson: 'جاري إعداد الدرس التفاعلي...',
    please_wait_while_we_set_up_your_interactive_lesson: 'يرجى الانتظار بينما نقوم بإعداد الدرس التفاعلي الخاص بك',
    open_sharelook_app: 'فتح تطبيق ShareLook',
    current_color: 'اللون الحالي',
    new_color: 'اللون الجديد',
    infographic_content_required: 'المحتوى مطلوب',
infographic_content_required_desc: 'يرجى إضافة محتوى للصفحة أو تقديم تعليمات مخصصة لإنشاء الإنفوجرافيك.',
infographic_using_custom_prompt: 'باستخدام تعليمات مخصصة',
infographic_using_custom_prompt_desc: 'الإنشاء استنادًا فقط إلى تعليماتك المخصصة.',
infographic_source_context: 'سياق المصدر',
infographic_no_source_content: 'لم يتم العثور على محتوى في الصفحة. يرجى استخدام التعليمات المخصصة.',
infographic_custom_instructions: 'تعليمات مخصصة',
infographic_prompt_placeholder_new: 'مثال: ركز على الإحصائيات، استخدم لوحة ألوان زرقاء...',
infographic_generate_btn: 'إنشاء إنفوجرافيك',
infographic_creating_magic: 'جارٍ الإبداع...',
infographic_preview_area: 'منطقة المعاينة',
infographic_preview_desc: 'سيظهر الإنفوجرافيك الذي تم إنشاؤه هنا جاهزًا للمراجعة.',
infographic_discard: 'تجاهل',
video_not_loading: 'الفيديو لا يعمل؟',
watch_on_youtube: 'مشاهدة على يوتيوب',
generate_infographics: 'إنشاء إنفوجرافيكات',
select_language_error: 'يرجى اختيار لغة لإنشاء دورة الذكاء الاصطناعي.',

narrativeHook: 'خطاف السرد',
storyPlot: 'حبكة القصة',
complexity: 'التعقيد',
genre: 'النوع الأدبي',
vocabulary: 'المفردات',
narrativeStructure: 'هيكل السرد',
timePeriod: 'الفترة الزمنية',
storyLength: 'طول القصة',
characterNames: 'أسماء الشخصيات',
outputType: 'نوع الإخراج',
tone: 'النبرة',
narrativeStyle: 'أسلوب السرد',

formal: 'رسمي',
informal: 'غير رسمي',
humorous: 'فكاهي',
assertive: 'حازم',
sarcastic: 'ساخر',
optimistic: 'متفائل',
firstPerson: 'ضمير المتكلم',
secondPerson: 'ضمير المخاطب',
thirdPerson: 'ضمير الغائب',
thirdPersonLimited: 'ضمير الغائب المحدود',
thirdPersonOmniscient: 'ضمير الغائب العليم',
epistolary: 'رسائلي',
beginner: 'مبتدئ',
intermediate: 'متوسط',
advanced: 'متقدم',
experimental: 'تجريبي',
realistic: 'واقعي',
historical: 'تاريخي',
casual: 'عفوي',
drama: 'دراما',
fantasy: 'خيال',
adventure: 'مغامرة',
satire: 'هجاء',
scienceFiction: 'خيال علمي',
mystery: 'غموض',
linear: 'خطي',
nonLinear: 'غير خطي',
circular: 'دائري',
inMediaRes: 'في صلب الأحداث',
framedNarrative: 'سرد مؤطر',
past: 'الماضي',
present: 'الحاضر',
future: 'المستقبل',
timelessOrUnspecified: 'دائم / غير محدد زمنياً',
short: 'قصيرة (300 - 500 كلمة)',
medium: 'متوسطة (500 - 800 كلمة)',
long: 'طويلة (أكثر من 800 كلمة)',
screenplay: 'سيناريو',
narrative: 'سرد',
simple: 'بسيط',
moderate: 'متوسط',
advanced: 'متقدم',
jargonOrTechnical: 'مصطلحات فنية أو تقنية',
periodSpecific: 'خاص بفترة معينة',
slangOrColloquial: 'عامي أو لغة محكية'


  },
  v4: {
    drop_files: 'اسحب الملف واختر مكان الرفع.',
    duplicate_lesoon: 'الدرس موجود بالفعل في الدورة',
    duplicate_lessoon: 'الدرس موجود بالفعل في الدورة',
    skill_rule_title: 'يرجى إدخال عنوان رحلة المهارة',
    imageCreatorTitle: 'منشئ الصور',
    isTranslated: 'مترجم',
    translationCourseDesc: 'قد تستغرق ترجمة هذه الدورة بضع دقائق. شكراً لصبرك!',
    translateCourseTip:
      'إنشاء دورة مترجمة يمكنك تعديلها بشكل مستقل عن الأصل، بما يشمل جميع الدروس والصفحات.',
    translateModalBtn: 'ترجم',
    translationSuccess: 'تم ترجمة الدورة "<0/>" بنجاح!',
    translatingCourse: 'جاري ترجمة الدورة...',
    translateModalTitle: 'ترجمة الدورة',
    translateSelectLang: 'اختر اللغة',
    fileDeleteconfirm:
      'هل أنت متأكد من حذف هذا الملف؟ لا يمكن التراجع عن هذا الإجراء.',
    fileDeleteMessage: 'تم حذف الملف بنجاح.',
    fileDeleteFailedMessage: 'فشل في حذف الملف!',
    fileDelete: 'حذف هذا الملف.',
    certificate_save_btn: 'إضافة الشهادة إلى ',
    maze_path_info: 'لا توجد مسارات متاحة للرسم البياني!',
    file_size_mb: 'يجب أن يكون حجم الملف أقل من 25 ميجابايت!',
    reports: {
      products: 'المنتجات',
      users: 'المستخدمون',
      ph_username: 'البحث عن المستخدم بالاسم',
      ph_id: 'البحث عن المستخدم برقم الهوية',
      ph_email: 'البحث عن المستخدم بالبريد الإلكتروني'
    },
    select_upload_section_id: 'ملف القسم مطلوب',
    tags_all: 'الكل',
    delete_file_confirm: 'هل أنت متأكد من حذف هذا الملف؟',
    delete_file_title: 'حذف الملف',
    tooltip_publish: 'نشر الدورة في الخيار المحدد',
    tooltip_save: 'حفظ الدورة مع التحديثات الحالية',
    tooltip_next: 'الانتقال إلى إعداد الدورة التالي',
    tooltip_finish: 'إكمال وحفظ التحديثات الحالية',
    stories_modal: {
      title_upload: 'رفع القصص',
      title_update: 'تحديث القصص',
      title_audio: 'ملف القصة الصوتية',
      btn_upload: 'رفع',
      btn_update: 'تحديث',
      btn_close: 'إغلاق',
      btn_cancel: 'إلغاء',
      lbl_cover: 'صورة غلاف القصة',
      rule_cover: 'يرجى رفع غلاف القصة الصوتية!',
      lbl_title: 'عنوان القصة الصوتية',
      rule_title: 'يرجى إدخال عنوان القصة الصوتية!',
      lbl_description: 'وصف القصة الصوتية',
      rule_description: 'يرجى إدخال وصف القصة الصوتية!',
      lbl_file: 'رفع ملف القصة الصوتية',
      rule_file: 'يرجى رفع ملف القصة الصوتية!',
      rule_file_type: 'يرجى رفع ملف قصة صوتية صالح!',
      lbl_select_file: 'اختيار ملف القصة الصوتية',
      msg_valid_file: 'يرجى اختيار ملف قصة صوتية صالح!',
      msg_success: 'تم رفع ملف القصة الصوتية بنجاح',
      msg_failed: 'فشل في تعيين بيانات الوسائط!',
      msg_error: 'خطأ في رفع الملف!'
    },
    audio_modal: {
      title_upload: 'رفع',
      title_update: 'تحديث',
      title_audio: 'ملف صوتي',
      btn_upload: 'رفع',
      btn_update: 'تحديث',
      btn_close: 'إغلاق',
      btn_cancel: 'إلغاء',
      lbl_cover: 'غلاف الصوت',
      rule_cover: 'يرجى رفع غلاف الصوت!',
      lbl_title: 'عنوان الصوت',
      rule_title: 'يرجى إدخال عنوان الصوت!',
      lbl_description: 'وصف الصوت',
      rule_description: 'يرجى إدخال وصف الصوت!',
      lbl_file: 'رفع ملف صوتي',
      rule_file: 'يرجى رفع ملف صوتي!',
      rule_file_type: 'يرجى رفع ملف صوتي صالح!',
      lbl_select_file: 'اختيار ملف صوتي',
      msg_valid_file: 'يرجى اختيار ملف صوتي صالح!',
      msg_success: 'تم رفع الملف الصوتي بنجاح',
      msg_failed: 'فشل في تعيين بيانات الوسائط!',
      msg_error: 'خطأ في رفع الملف!'
    },
    info_episode: 'صورة غلاف للحلقة.',
    btn_delete_episode: 'حذف حلقة البودكاست هذه.',
    btn_edit_marketplace: 'تحرير تفاصيل السوق.',
    btn_save_marketplace: 'حفظ التغييرات الحالية.',
    btn_ai_podcast: 'إنشاء حلقة بودكاست مدعومة بالذكاء الاصطناعي.',
    btn_upload_podcast: 'رفع حلقة البودكاست الصوتية الخاصة بك.',
    attach_file: 'رفع الملفات لمشاركة المزيد من المحتوى مع جمهورك',
    fileDownload: 'تحميل هذا الملف.',
    singleEpishode: 'حلقة',
    podcast_music: 'بودكاست، موسيقى وقصص',
    publishHeader: 'نشر البودكاست، الموسيقى والقصص',
    editHeader: 'تحرير البودكاست، الموسيقى والقصص',
    createHeader: 'إنشاء البودكاست، الموسيقى والقصص',
    marketplaceHeader: 'تفاصيل السوق للبودكاست، الموسيقى والقصص',
    message_marketplace: 'يرجى إكمال نموذج السوق!',
    create_podcast_live: 'بودكاست وموسيقى مباشرة',
    create_podcast_custom: 'بودكاست وموسيقى مخصصة',
    create_podcast_stories: 'قصة',
    ai_Assisted_podcast_reation:
      'إنشاء بودكاست وموسيقى بمساعدة الذكاء الاصطناعي',
    publishTitle: 'نشر البودكاست، الموسيقى والقصص للعرض العام.',
    customButton: 'إنشاء مخصص',
    customTitle: 'حفظ التغييرات المدخلة على البودكاست.',
    updateButton: 'تحديث',
    createButton: 'إنشاء',
    createNewButton: 'إنشاء جديد',
    updateTitle: 'تحديث تفاصيل البودكاست، الموسيقى والقصص الحالية.',
    createTitle: 'إنشاء بودكاست، موسيقى وقصص جديدة',
    createNewTitle:
      'سيتم إنشاء بودكاست، موسيقى وقصص جديدة على البودكاست الحالي مع تفاصيل الإدخال الجديدة.',
    podcastTitle: 'قائمة الحلقات',
    podcastStoryTitle: 'قائمة حلقات القصص',
    podcastToolTipTitle: 'قائمة حلقة (حلقات) البودكاست',
    uploadAudio: 'رفع',
    aiAudio: 'صوت ذكي',
    emptyPodcast: 'لا يوجد مسجل صوتي للبودكاست، الموسيقى والقصص بعد.',
    emptyStoriesPodcast: 'لم تتم إضافة قصص بعد.',
    emptyCreatePodcast: 'يرجى إنشاء بودكاست لتتمكن من إضافة الصوت.',
    playPodcast: 'تشغيل البودكاست، الموسيقى والقصص المحددة.',
    pausePodcast: 'إيقاف البودكاست، الموسيقى والقصص المحددة.',
    selectPodcast: 'اختيار هذا البودكاست، الموسيقى والقصص.',
    downloadPodcast: 'تحميل هذا الصوت.',
    uploadAudioFile: 'رفع صوت جديد واستبدال الصوت الحالي.',
    deleteConfirm: 'هل أنت متأكد من حذف هذا الصوت؟',
    roomName: 'اسم البودكاست',
    addGuestTitle: 'إضافة متحدث ضيف',
    showTime: 'وقت العرض',
    startTime: 'وقت البداية',
    endTime: 'وقت النهاية',
    erorMsgImg: 'يرجى اختيار صورة صالحة.',
    failedMsgImg: 'فشل في تحميل الصورة. يرجى المحاولة مرة أخرى!',
    failedMsgUpload: 'فشل في رفع صورة الغلاف!',
    btnCoverUpload: 'رفع الغلاف',

    is_private: 'خاص',
    to_attach: 'إرفاق ملف',
    file_attached: 'إرفاق ملف (ملفات)',
    main_event: 'الحدث الرئيسي',
    event: 'الأحداث',
    upload_pdf: 'رفع PDF',
    portrait: 'عمودي',
    landscape: 'أفقي',
    import_from_library: 'استيراد النص من مكتبة الوسائط',
    question_answer_ai: 'سؤال/جواب ذكي',
    take_maze: 'خذ MetaMaze',
    training: 'التدريب',
    select_transcribe_locale: 'اختر اللغة للنسخ',
    transcribe_limit: 'يرجى إدخال دقائق النسخ',
    not_complete: 'معلومات السوق غير مكتملة',
    complete: 'معلومات السوق مكتملة',
    not_admin: 'تحتاج صلاحية المدير للنشر في السوق',
    no_course: 'يرجى إدخال العنوان واختيار صورة لتفعيل السوق',
    scorm_not_complete: 'يرجى إدخال العنوان واختيار صورة لرفع ملف SCORM',
    not_found_maze: 'MetaMaze غير موجود',
    email_require: 'رسائل البريد الإلكتروني مطلوبة',
    poll_required: 'بيانات الاستطلاع مطلوبة',
    alert: 'تنبيه!',
    warning: 'تحذير!',
    ok: 'موافق',
    cancel: 'إلغاء',
    done: 'تم',
    insert: 'إدراج',
    private: 'خاص',
    public: 'عام',
    no_connection: 'فقدان الاتصال بالإنترنت',
    switch: 'تبديل',
    share_screen: 'مشاركة الشاشة',
    stop_share_screen: 'إيقاف مشاركة الشاشة',
    share_screen_with_camera: 'مشاركة الشاشة مع الكاميرا',
    stop_share_screen_with_camera: 'إيقاف مشاركة الشاشة مع الكاميرا',
    camera_on: 'تشغيل الكاميرا',
    camera_off: 'إيقاف الكاميرا',
    mic_on: 'إلغاء كتم الصوت',
    mic_off: 'كتم الصوت',
    fullscreen: 'ملء الشاشة',
    live_now: 'مباشر الآن',
    schedule_on: 'مجدول لـ',
    organisations: 'المنظمات',
    org_groups: 'مجموعات المنظمات',
    specific_user: 'مستخدم محدد',
    gif: 'صورة متحركة',
    unavailable: 'غير متاح',
    yes: 'نعم',
    no: 'لا',
    event_duration_message: 'الحد الأقصى 300 دقيقة (5 ساعات)',
    send_email: 'إرسال إشعار بريد إلكتروني',
    admin_only: 'المدير فقط',
    join: 'انضمام',
    leave: 'مغادرة',
    share: 'مشاركة',
    share_text:
      'يرجى كتابة عنوان البريد الإلكتروني لمن تريد مشاركة هذا الملف معه.',
    share_text_title: 'مشاركة PDF',
    share_text_title_txt: 'مشاركة النص',
    select_users: 'اختيار المستخدمين',
    delete: 'حذف',
    attachment_event: 'مرفقات للحدث:',
    transcribe_limit: 'دقائق النسخ',
    monthly_transcribe: 'الحد الشهري للنسخ:',
    enable_ai: 'تفعيل الذكاء الاصطناعي:',
    enable_maze: 'تفعيل MetaMaze:',
    media_service: 'خدمة الوسائط',
    allow_others: 'السماح للآخرين بالتحرير',
    join_breakout_room: 'الانضمام إلى غرفة فرعية',
    bio: 'السيرة الذاتية',
    linkedin: 'لينكد إن',
    select_org_report: 'يرجى العثور على واختيار منظمة لإنشاء التقرير.',
    org_image_not_found: 'الصورة غير موجودة',
    insert_text: 'إدراج نص',
    insert_question_answer: 'سؤال/جواب ذكي',
    modal_title2: 'معرض النصوص',
    my_text_library: 'مكتبة النصوص الخاصة بي',
    ai: 'ذكي',
    public_text_library: 'مكتبة النصوص العامة',
    organization_text_library: 'مكتبة نصوص المنظمة',
    no_transcribed_text: 'لم يتم العثور على نص منسوخ',
    public_text_not_found: 'لم يتم العثور على نص عام منسوخ',
    org_text_not_found: 'لم يتم العثور على نص منظمة منسوخ',
    org_video_not_found: 'الفيديو غير موجود',
    canva: 'افعل ذلك من Canva',
    canva_open: 'انقر هنا لفتح محرر Canva.',
    pdf: 'PDF',
    txt: 'نص',
    human: 'مميز',
    shared_file: 'تم مشاركة ملفك بنجاح.',
    error_shared_file: 'هناك مشكلة في مشاركة الملف. يرجى المحاولة مرة أخرى.',
    publish: 'نشر',
    maze_scenes: 'مشاهد MetaMaze',
    pexel_images: 'صور Pexel',
    group: 'مجموعة',
    group_name: 'اسم المجموعة',
    select_group: 'اختيار المجموعة',

    search_maze: 'البحث في MetaMaze',
    hosts: 'المضيفون',
    avg_score: 'النتيجة المئوية',
    maze_report: 'تقرير المتاهة',
    maze_view: 'عرض المتاهة',
    title_maze: 'MetaMaze',
    author: 'المؤلف',
    match: 'تطابق المسار',
    preview_mazeTitle: 'العنوان: ',
    other: 'أخرى',
    total: 'المجموع',
    report_course: 'دورة',
    report_courses: 'دورات',
    report_event: 'حدث',
    report_events: 'أحداث',
    report_maze: 'متاهة',
    report_personalize_learning: 'تعلم شخصي',
    report_live_assessment: 'تقييم مباشر',
    report_live_assessments: 'تقييمات مباشرة',
    report_skill_journey: 'رحلة المهارة',
    skill_journey: 'رحلة المهارة',
    skill_journeys: 'رحلات المهارات',
    date: 'التاريخ: ',
    search_people: 'البحث عن الأشخاص',
    passed: 'نجح',
    failed: 'فشل',
    item: 'عنصر',
    type: 'النوع',
    minimum_pass_score: 'الحد الأدنى للنجاح',
    resources_count: 'عدد الموارد',
    back: 'العودة',
    resources: 'الموارد',
    time_spent: 'الوقت المستغرق (دقائق)',
    detail: 'التفاصيل',
    watched_time_mins: 'وقت المشاهدة (دقائق)',
    personalize_learning: 'تعلم شخصي',
    result: 'النتيجة',
    assessment_title: 'العنوان',
    marketPlace_graph: 'رسم بياني للسوق',
    attachments: 'مرفقات إضافية',

    new_scorm_course: 'رفع دورة SCORM جديدة',
    upload_scorm_course: 'رفع دورة SCORM',
    new_maze: 'إنشاء MetaMaze جديد',
    new_skill_journey: 'إنشاء رحلة مهارة',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'رحلة المهارة',
    new_discussion_room: 'إنشاء بودكاست جديد',

    title: 'ماذا تريد أن تفعل اليوم؟',
    build_course: 'بناء دورتي',
    live_broadcast: 'بث مباشر',
    invite_users: 'دعوة المستخدمين إلى منظمتي',
    build_voice_over: 'بناء التعليق الصوتي',
    view_reports: 'عرض التقارير',
    upload_media: 'رفع الوسائط أو العمل ومشاركته',
    main_menu: 'القائمة الرئيسية',
    get_started: 'ابدأ الآن',
    search_group: 'البحث في مجموعة المنظمة',
    ai_course: 'دورة ذكية',
    search_user: 'البحث عن اسم الشركة',
    no_maze: 'لا توجد MetaMaze حالياً.',
    conference_event_title: 'أحداث المؤتمر',
    conference_event_subTitle: 'أحداث المؤتمر المنتهية',
    conference_event: 'لا توجد أحداث مؤتمر حالياً.',
    no_skill: 'لا توجد رحلات مهارات حالياً.',
    no_podcast: 'لا يوجد بودكاست حالياً.',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'التقييمات المباشرة السابقة',
    no_live_assessment: 'لا توجد تقييمات مباشرة حالياً.',
    enrolled_courses: 'الدورات',
    my_video_channel: 'قنوات الفيديو الخاصة بي',
    enrolled_liveEvents: 'الأحداث المباشرة',
    sharebot: 'Sharebot',
    selected_language: 'اللغة المختارة',
    shareSphere_game: 'لعبة ShareSphere',
    maze: 'MetaMaze',
    skill: 'رحلة المهارة',
    channel: 'القناة',
    order: 'الترتيب',
    is_record: 'تسجيل',
    no_maze_found: 'لم يتم العثور على MetaMaze.',
    maze_self_limit_reached: 'تم الوصول إلى حد التقييم الذاتي لـ MetaMaze.',
    metamaze_two_times: 'لقد أجريت هذا الاختبار مرتين بالفعل.',
    metamaze_two_times_no_result:
      'لقد أجريت هذا الاختبار مرتين بالفعل. لن يتم تتبع نتيجتك لإكمال هذا التقييم الذاتي بعد المرة الثانية.',
    scorm_zip: 'ملف SCORM مضغوط',
    pass_score: 'الحد الأدنى للنجاح',
    organization: 'يرجى اختيار منظمة',
    pass_score_mark: 'يرجى إدخال درجات بين 1 إلى 100',

    maze_cloning_success: 'تم استنساخ MetaMaze "<0/>" بنجاح!',
    create_certificate: 'إنشاء شهادة',
    create_badge: 'إنشاء شارة',
    certificate_added: 'تم إضافة الشهادة.',
    badge_added: 'تم إضافة الشارة.',
    certificate_warning: 'لا يمكنك تحرير الشهادة/الشارة بمجرد نشرها!',
    created_course_plan: 'تحرير ونشر الدورة المُنشأة وتخطيط الأحداث المباشرة',
    market_place_space: 'السوق',
    select_course_language: 'اختيار اللغة (اختياري)',
    select_language: 'اختيار اللغة',
    file_upload: 'رفع ملف',
    text: 'اكتب النص هنا…',
    attempts_count: 'عدد المحاولات التي يمكن للمستخدم إعادة المحاولة',
    no_of_people_placeholder: 'عدد الأشخاص',

    back_to_maze: 'العودة إلى سيناريو MetaMaze',
    edit_maze: 'تحرير المتاهة',
    wait: 'انتظر...',
    retry: 'إعادة المحاولة',
    publish_scorm_course: 'نشر دورة SCORM الخاصة بك',
    publish_maze: 'نشر MetaMaze الخاص بك',
    import: 'استيراد العناصر',

    answer_correct: 'اختر الإجابة الصحيحة',
    author_name: 'يرجى إدخال اسم المؤلف',
    select_category: 'يرجى اختيار فئة',
    course_outline: 'يرجى إدخال مخطط الدورة',
    course_obj: 'يرجى إدخال أهداف الدورة',
    course_description: 'يرجى إدخال وصف الدورة',
    maze_outline: 'يرجى إدخال مخطط المتاهة',
    maze_obj: 'يرجى إدخال أهداف المتاهة',
    maze_description: 'يرجى إدخال وصف المتاهة',
    lessons: 'يرجى إدخال عدد الدروس',
    user_email_require: 'بريد المستخدم الإلكتروني مطلوب',
    team_size: 'حجم الفريق مطلوب',
    enter_price: 'يرجى إدخال سعر (5 أو أكثر)',
    input_title_maze: 'يرجى إدخال عنوان المتاهة',
    trainer_bio: 'يرجى إدخال السيرة الذاتية للمدرب',
    trainer_linkedin: 'يرجى إدخال لينكد إن الخاص بالمدرب',
    error_video: 'يرجى إدخال عدد الفيديوهات',
    input_video_link: 'يرجى إدخال رابط الفيديو',
    number_of_video: 'عدد الفيديوهات',
    number_of_lessions: 'عدد الدروس',

    no_of_people_in_conference: 'كم عدد الأشخاص في المؤتمر؟',
    transcribe_settings: 'إعدادات النسخ',
    transcribe: 'نسخ',
    cloning_maze: 'جاري استنساخ MetaMaze...',
    id_number: 'رقم الهوية',
    timezone: 'المنطقة الزمنية',
    edit_maze: 'تحرير',
    delete_maze: 'حذف',
    view_maze: 'عرض',
    create_metamaze: 'إنشاء MetaMaze',
    metamaze_scenario: 'سيناريو MetaMaze',
    publish_metamaze: 'إعداد النشر',
    search_result: 'نتائج البحث:',
    search_for: 'البحث عن',
    search_no_result: '- لا توجد نتائج متاحة!',
    channel_no_available: 'لا توجد قناة متاحة!',
    this_card: 'هذه بطاقة',
    course_no_available: 'لا توجد دورات متاحة!',
    exit_fullscreen: 'الخروج من وضع ملء الشاشة',
    bg_image: 'صورة الخلفية',
    introduction: 'المقدمة',
    summary: 'الملخص',
    generate_introduction: 'إنشاء المقدمة',
    generate_summary: 'إنشاء الملخص',
    title_simulation: 'يرجى إدخال اسم المحاكاة',
    view_generated_images: 'عرض الصور المُنشأة',
    image_transparency: 'شفافية الصورة',
    template_bg_color: 'لون خلفية القالب',
    select_template_layout: 'اختر تخطيط القالب',
    reload_template: '(إعادة تحميل القوالب)',
    are_you_sure_want_close: 'هل أنت متأكد من رغبتك في الإغلاق؟',
    all_your_changes_will_be_lost: 'سيتم فقدان جميع تغييراتك.',
    please_checked_before_generated_video:
      'يرجى التحقق قبل إنشاء الفيديو',
    voice_must_be_selected: 'يجب اختيار صوت',
    avatar_must_be_selected: 'يجب اختيار صورة رمزية.',
    maximum_five_slides_try_again:
      'خطأ في استخراج الصور من ملفك. تأكد من وجود حد أقصى 5 شرائح في ملفك وأن هناك ملاحظات في كل شريحة. يرجى المحاولة مرة أخرى!',
    back_to_upload: 'العودة إلى الرفع',
    uploading_file_to_server: 'جارِ رفع ملفك إلى الخادم',
    extracting_images_from_your_file: 'جارِ استخراج الصور من ملفك',
    upload_your_ppt_or_drag:
      'رفع ملف العرض التقديمي الخاص بك (.PPTX) أو اسحبه هنا.',
    maximum_five_slides_error:
      'يرجى التأكد من أن ملف PowerPoint الخاص بك يحتوي على حد أقصى 5 شرائح وأن هناك ملاحظات في كل شريحة. وإلا فسيؤدي ذلك إلى خطأ.',
    number_of_questions_generated: 'عدد الأسئلة المراد إنشاؤها',
    quiz_page_this_cannot_be_done:
      'هل أنت متأكد من رغبتك في إضافة الاختبار إلى هذه الصفحة؟ لا يمكن التراجع عن هذا.',
    confirm_selection: 'تأكيد الاختيار',
    select_quiz_page: 'اختر صفحة الاختبار',
    lesson_do_you_want_add_this_quiz:
      'في أي جزء من الدرس تريد إضافة هذا الاختبار؟',
    beginning_of_lesson: 'في بداية الدرس',
    end_of_lesson: 'نهاية الدرس',
    currently_active_page: 'الصفحة النشطة حاليًا',
    finish: 'إنهاء',
    upload_selection_file: 'رفع ملف القسم',
    general_quiz: 'اختبار عام',
    manage_sequence: 'إدارة التسلسل',
    save_sequence: 'حفظ التسلسل',
    new: 'جديد',
    in_progress: 'قيد التنفيذ',
    recommended_course: 'دورة موصى بها',
    up_coming: 'القادمة',
    past_live: 'المباشرة السابقة',
    input_your_channel_name: 'يرجى إدخال اسم القناة!',
    organization_place: 'سوق المنظمة',
    marketplace_report: 'تقرير السوق',
    story_writing: 'كتابة القصة',
    Ai_quiz: 'اختبار الذكاء الاصطناعي',
    generate_quiz: 'إنشاء اختبار',
    create_story: 'إنشاء قصة',
    change_layout_page: 'أنت على وشك تغيير تخطيط هذه الصفحة.',
    change_layout_message:
      'يرجى ملاحظة أنه سيتم الاحتفاظ فقط بالنصوص، الصور، الخلفية والشعار. سيتم إزالة جميع العناصر الأخرى من الصفحة.',
    reviews: 'المراجعات',
    tab_attachments: 'المرفقات',
    zoom_in: 'تكبير',
    zoom_out: 'تصغير',
    zoom_reset: 'إعادة ضبط التكبير',
    no_attachment: 'لا توجد مرفقات.',
    select_upload_simulation: 'يرجى تحديد/تحميل المحاكاة.',
    quiz_updated_successfully: 'تم تحديث الاختبار بنجاح!',
    quizes: 'الاختبارات',
    trivia: 'معلومات عامة',
    closing: 'جاري الإغلاق...',
    products: 'المنتجات',
    ask_questions: 'اطرح سؤالك هنا...',
    course_information: 'معلومات الدورة',
    course_assistance: 'مساعدة منشئ الدورة',
    go_back: 'الرجوع',
    ai_generate_content_progress: 'جارٍ إنشاء المحتوى',
    view_generate_content: 'عرض المحتوى المُنشأ',
    generate_error: 'خطأ في الإنشاء!',
    confirm_creating_course: 'هل تريد تأكيد إنشاء الدورة باستخدام هذا المحتوى؟',
    generate_content_automatically:
      'سيتم إضافة جميع المحتويات المُنشأة كدروس وصفحات إلى دورتك تلقائيًا.',
    quiz_created_successfully: 'تم إنشاء الاختبار بنجاح!',
    create_quiz: 'إنشاء اختبار',
    quiz_setting: 'إعدادات الاختبار',
    please_fill_quiz_setting: '* يرجى تعبئة جميع الحقول في إعدادات الاختبار',
    question_list: 'قائمة الأسئلة',
    add_quiz_to_page: 'إضافة اختبار إلى الصفحة',
    form_create_question: 'نموذج إنشاء سؤال',
    user_information_updated: 'تم تحديث معلومات المستخدم!',
    your_stripe_activete_to_continue:
      'حساب Stripe الخاص بك غير نشط. يرجى توصيله أو تفعيله للمتابعة.',
    connect_tripe: 'ربط Stripe',
    certificate_sent_sucessfully:
      'تم إرسال الشهادة إلى بريدك الإلكتروني بنجاح.',
    error_try_again: 'خطأ. حاول مرة أخرى!',
    error_delete_channel: 'حدث خطأ أثناء حذف القناة.',
    error_update_sub: 'خطأ أثناء تحديث الاشتراك.',
    end_time_cannot_start: 'وقت الانتهاء لا يمكن أن يكون قبل وقت البدء.',
    start_date_time_interval: 'تاريخ ووقت البدء مطلوبان!',
    podcast_updated_successful: 'تم تحديث البودكاست بنجاح.',
    podcast_created_successful: 'تم إنشاء البودكاست بنجاح.',
    podcast_published_successful: 'تم نشر البودكاست بنجاح',
    podcast_cover_updated: 'تم تحديث غلاف البودكاست',
    new_podcast_details: 'سيتم إنشاء بودكاست جديد باستخدام البيانات الجديدة.',
    current_update_podcast: 'تحديث البودكاست الحالي والموسيقى وتفاصيل القصص.',
    create_new_podcast: 'إنشاء بودكاست جديد',
    publish_podcast_public_view: 'نشر البودكاست للعرض العام.',
    only_allowed_twenty_five_email: 'مسموح فقط بـ 25 بريدًا إلكترونيًا',
    only_allowed_five_email: 'مسموح فقط بـ 5 بريد إلكتروني.',
    cover_is_required: 'الغلاف مطلوب.',
    topic_is_required: 'الموضوع مطلوب.',
    delete_schedule: 'حذف الجدول',
    make_as_coaching: 'تحديد كجلسة تدريبية',
    manage_category: 'إدارة الفئة',
    threshold: 'العتبة',
    threshold_popup:
      'قيمة العتبة بالنسبة المئوية (%)، القيمة التي يتم عندها تفعيل التوصيات للفئة المحددة.',
    list_of_catagory: 'قائمة الفئات',
    category_name: 'اسم الفئة',
    category_threshold: 'عتبة الفئة',
    play_game: 'تشغيل اللعبة',
    switching_organization: 'جارٍ التبديل بين المؤسسات...',
    coaching_session: 'جلسة تدريبية',
    required_channel_id: 'معرّف القناة مطلوب!',
    error_occured_try_again: 'حدث خطأ. حاول مرة أخرى!',
    please_complete_marketplace_form: 'يرجى إكمال نموذج السوق!',
    upload_file_corrupt: 'الملف المرفوع تالف.',
    course_not_published: 'الدورة لم يتم نشرها بعد!',
    error_request: 'خطأ في الطلب. حاول مرة أخرى!',
    skill_request: 'يرجى إكمال الحقول الناقصة!',
    error_occured: 'حدث خطأ. حاول مرة أخرى!',
    show_time: 'إظهار الوقت',
    start_time: 'وقت البدء',
    end_time: 'وقت الانتهاء',
    room_name: 'اسم البودكاست',
    add_guest_speaker: 'إضافة متحدث ضيف',
    cover_picture: 'صورة الغلاف',
    guest_speaker: 'المتحدثون الضيوف',
    see_more: 'عرض المزيد',
    see_less: 'عرض أقل',
    background: 'الخلفية',
    icon: 'الأيقونة',
    icon_size: 'حجم الأيقونة',
    icon_color: 'لون الأيقونة',
    only_text: 'نص فقط',
    change_bg: 'تغيير لون الخلفية',
    bg_color: 'لون الخلفية',
    font_size: 'حجم الخط',
    normal: 'عادي',
    change_color: 'تغيير لون النص',
    slant_text: 'نص مائل',
    text_radius: 'نصف قطر النص',
    vertical_align: 'محاذاة رأسية',
    horizontal_align: 'محاذاة أفقية',
    change_icon_color: 'تغيير لون الأيقونة',
    upload_icon: 'تحميل الأيقونة',
    upload_signature: 'تحميل التوقيع',
    add_another_sign: 'إضافة توقيع آخر',
    name_badges: 'اسم الشارة',
    should_less_150: 'يجب أن يكون 150 حرفًا أو أقل',
    your_badge: 'شارتك',
    do_you_want_delete_badge: 'هل أنت متأكد أنك تريد حذف هذه الشارة؟',
    do_you_want_delete_cert: 'هل أنت متأكد أنك تريد حذف هذه الشهادة؟',
    upload_logo: 'تحميل الشعار',
    name_of_cert: 'اسم الشهادة',
    upload_cert: 'تحديث الشهادة',
    your_cert: 'شهادتك',
    translate_to: 'الترجمة إلى',
    select_file_attach: 'حدد ملفًا لإرفاقه',
    certificate: 'شهادة',
    badge: 'شارة',
    publish_options: 'خيارات النشر',
    publish_skills_journey: 'نشر رحلة المهارات',
    videos: 'فيديوهات',
    generate_ai_video:
      'قد تستغرق عملية إنشاء الفيديو بعض الوقت. سيتم إعلامك عبر البريد الإلكتروني عند اكتمالها.',
    trainer_information: 'معلومات المدرب',
    promotional_video_link: 'رابط الفيديو الترويجي',
    please_select: 'يرجى الاختيار',
    image_name: 'اسم الصورة:',
    image_size: 'حجم الصورة:',
    charecters_fifteen_less: '15 حرفًا أو أقل',
    leadership: 'القيادة',
    text_arc: 'قوس النص',
    vertical: 'رأسي',
    horizontal: 'أفقي',
    badge_history: 'سجل الشارات',
    templates: 'القوالب',
    sign: 'توقيع',
    logo: 'شعار',
    certificate_history: 'سجل الشهادات',
    please_wait: 'يرجى الانتظار...',
    information: 'معلومة',
    support_five_thousand_live_event: 'يدعم حتى 5000 مشارك في الحدث',
    support_ten_live_event: 'يدعم حتى 10 مشاركين بالفيديو المباشر',
    we_will_back_participant:
      'سنعود مع الحدث بإمكانية وصول لعدد كبير من المشاركين.',
    course_objectives: 'أهداف الدورة',
    course_outlines: 'مخطط الدورة',
    price_dollor: 'السعر (دولار)',
    not_completed: 'غير مكتمل',
    enable_marketplace: 'تفعيل السوق',
    enable_course_ai: 'تمكين إنشاء الدورات باستخدام الذكاء الاصطناعي',
    enable_report_to_admin: 'تمكين عرض التقارير للمسؤول',
    enable_white_label: 'تمكين العلامة البيضاء',
    enable_eleven_labs_for_maze_play: 'تمكين Elevenlabs لتشغيل Maze',
    enable_eleven_labs_for_maze_play_cloned: 'تمكين أصوات Elevenlabs المستنسخة',
    not_completed: 'غير مكتمل',
    simulation_quiz: 'اختبار المحاكاة',
    bg_color_setting: 'إعدادات لون الخلفية',
    color_preview: 'معاينة اللون',
    choose_new_color: 'اختر لونًا جديدًا',
    remove_color: 'إزالة اللون',
    apply_color: 'تطبيق اللون',
    elemeent_in_a_sceenario_page:
      'لا يمكنك إضافة عناصر أخرى في صفحة السيناريو. يرجى تجربة صفحات أخرى أو إزالة السيناريو أولاً.',
    no_data_found: 'لم يتم العثور على بيانات.',
    references: 'المراجع',
    open_file: 'فتح الملف',
    showing_result: 'عرض النتائج:',
    fiften_day_free_trail: 'تجربة مجانية لمدة 15 يومًا',
    your_browser_does_not_support: 'متصفحك لا يدعم عنصر الصوت.',
    podcast_desc: 'وصف البودكاست',
    input_podcast_desc: 'يرجى إدخال وصف البودكاست',
    podcast_obj: 'أهداف البودكاست',
    input_podcast_obj: 'يرجى إدخال أهداف البودكاست',
    podcast_outline: 'مخطط البودكاست',
    input_podcast_outline: 'يرجى إدخال مخطط البودكاست',
    add_file: 'إضافة ملف',
    generate_podcast_audio: 'إنشاء صوت البودكاست',
    generate_uploaded_file_input_parameter:
      'ينشئ المحتوى بناءً على الملفات المرفوعة مع المعايير المحددة.',
    go_backe_generation_state: 'العودة إلى حالة إنشاء المحتوى.',
    create_ai_powered_podcast:
      'إنشاء حلقة بودكاست مدعومة بالذكاء الاصطناعي مع الصوت المُنشأ.',
    generate_voice_for_all_podcast: 'يرجى إنشاء صوت لجميع حلقات البودكاست.',
    create_podcast_episode: 'إنشاء حلقة بودكاست',
    voice_name: 'اسم الصوت',
    input_custom_name: 'يرجى إدخال اسم مخصص!',
    enter_custom_name: 'أدخل اسم الصوت المخصص',
    upload_complete: 'اكتمل التحميل',
    uploading_in_progress: 'جارٍ التحميل...',
    podcast_stream_content: 'تدفق محتوى البودكاست',
    upload_podcast_cover: 'الرجاء تحميل غلاف البودكاست!',
    enter_podcast_name: 'الرجاء إدخال اسم البودكاست!',
    podcast_topic: 'موضوع البودكاست',
    enter_podcast_topic: 'الرجاء إدخال موضوع البودكاست!',
    enter_podcast_desc: 'الرجاء إدخال وصف البودكاست!',
    number_of_speaker: 'عدد المتحدثين',
    select_the_number_of_speaker: 'يرجى اختيار عدد المتحدثين!',
    select_the_number_of_speaker: 'يرجى اختيار عدد المتحدثين!',
    number_of_episode: 'عدد الحلقات',
    input_number_of_episode: 'يرجى إدخال عدد الحلقات!',
    podcast_length: 'مدة البودكاست',
    select_the_podcast_length: 'يرجى اختيار مدة البودكاست!',
    short_podcast: 'قصير (5-10 دقائق)',
    medium_podcast: 'متوسط (15-18 دقيقة)',
    long_podcast: 'طويل (أكثر من 18 دقيقة)',
    name_of_host: 'اسم المضيف',
    enter_host_name: 'يرجى إدخال اسم المضيف!',
    guest_name: 'أسماء الضيوف',
    enter_guest_name: 'يرجى إدخال اسم الضيف!',
    choose_speaker_tone: 'اختر نبرة المتحدث',
    enter_speaker_tone: 'يرجى اختيار نبرة البودكاست!',
    informal: 'غير رسمي',
    formal: 'رسمي',
    serious: 'جدي',
    light_humor: 'فكاهي خفيف',
    casual: 'عفوي',
    select_content_source: 'اختر مصدر المحتوى',
    from_internet: 'من الإنترنت',
    upload_pdf_internet: 'تحميل ملف PDF أو مستند داخلي',
    note: 'ملاحظة:',
    podcast_content_will_be_automatically_generated:
      'سيتم إنشاء محتوى البودكاست تلقائيًا باستخدام مصادر موثوقة من الإنترنت.',
    upload_or_select_file: 'يرجى تحميل أو اختيار ملف(ات)!',
    podcast_eposode_title: 'عنوان حلقة البودكاست',
    enter_podcast_title: 'يرجى إدخال عنوان الحلقة!',
    podcast_episode_des: 'وصف حلقة البودكاست',
    enter_podcast_episode_des: 'يرجى إدخال وصف الحلقة!',
    voice: 'الصوت',
    music: 'الموسيقى',
    select_music: 'اختر الموسيقى',
    play_the_music: 'تشغيل الموسيقى',
    stop_the_music: 'إيقاف الموسيقى',
    context: 'السياق',
    generate_audio_content_selected_voice:
      'سيتم إنشاء الصوت بناءً على الأصوات المحددة.',
    required_field_before_submitting:
      'يرجى ملء جميع الحقول المطلوبة قبل الإرسال.',
    regenerate_voice: 'إعادة توليد الصوت',
    generate_voice: 'توليد الصوت',
    your_browser_does_not_suppot: 'متصفحك لا يدعم عنصر الصوت.',
    are_sure_leave_podcast: 'هل أنت متأكد من مغادرة البودكاست؟',
    broadcast_ongoing: 'البث جارٍ حاليًا. هل تريد فعلاً مغادرة هذه الصفحة؟',
    brodcaster_unavailable: 'المذيع غير متاح حاليًا.',
    setting_calender_for_booking: 'إعداد التقويم للحجز',
    add_calender: 'إضافة تقويم',
    waiting_join_host: 'في انتظار انضمام المضيف...',
    no_reviews_found: 'لم يتم العثور على مراجعات.',
    rated_already: 'لقد قمت بتقييم هذا الحدث المباشر مسبقًا.',
    downlink_png: 'تنزيل PNG',
    downlink_jpg: 'تنزيل JPG',
    donwload_file_format: 'يرجى اختيار تنسيق الملف الذي تريد تنزيله.',
    crashed_event: 'تعطل هذا الحدث. يجب عليك إنشاء حدث جديد. نعتذر عن الإزعاج.',
    prompt: 'المطالبة:',
    generated_image: '🚀 يتم إنشاء صورتك... يرجى الانتظار.',
    download_add: 'تنزيل الكل',
    setting_generator: 'إعداد المُولد',
    enter_image_prompt: 'يرجى إدخال مطالبة الصورة',
    image_prompt: 'أدخل مطالبة الصورة الخاصة بك',
    negative_prompt: 'المطالبة السلبية',
    negative_image_prompt: 'أدخل مطالبة الصورة السلبية',
    number_output: 'عدد المخرجات',
    enter_number_output: 'يرجى إدخال عدد المخرجات',
    image_style: 'يرجى اختيار نمط للصورة',
    output_format: 'تنسيق الإخراج',
    seeds: 'البذور',
    enter_seeds: 'يرجى إدخال عدد البذور',
    performance_mode: 'وضع الأداء',
    quality: 'الجودة',
    speed: 'السرعة',
    balanced: 'متوازن',
    guidance_scale: 'مقياس التوجيه',
    enter_guidance: 'يرجى إدخال مقياس التوجيه',
    select_image: 'يرجى اختيار صورة.',
    image_prmt: 'مطالبة الصورة',
    generate_image_list_empty: 'قائمة الصور المُولدة فارغة.',
    knowledge_center_tooltrip_des:
      'احصل على إجابات دقيقة وسياقية لمجموعة واسعة من الأسئلة بما في ذلك الأسئلة العامة. يتم الحصول على الإجابات من معلومات الإنترنت العامة من نموذج ذكاء اصطناعي مدرب على مجموعة متنوعة من النصوص.',
    contexts: 'السياقات',
    ai_processing_video_sharebot:
      'سيستغرق معالجة الفيديو بواسطة الذكاء الاصطناعي حوالي 24 ساعة للظهور في Sharebot.',
    remove_sharebot_video:
      'إذا كنت ترغب في إزالة الإشارة إلى الفيديو في Sharebot، يرجى حذف النص المرتبط مع الفيديو.',
    remove_sharebot_video_audio:
      'سيؤدي حذف النص إلى إزالة الإشارة إلى الفيديو/الصوت المرتبط في Sharebot، لكن سيظل الفيديو ظاهرًا في مكتبة الوسائط/القناة.',
    monthly_live_stream: 'لتغيير حد البث المباشر الشهري، يرجى التواصل مع',
    monthly_transcribe_limit: 'لتغيير حد النسخ الشهري، يرجى التواصل مع',
    must_be_one_to_three_hundred: 'يجب أن يكون بين 1 إلى 300 دقيقة.',
    all_field_required: 'جميع الحقول مطلوبة.',
    duration_minute: 'المدة (حد أقصى 300 دقيقة)',
    gender: 'الجنس',
    select_gender: 'اختر الجنس',
    accent: 'اللهجة',
    select_accent: 'اختر اللهجة',
    create_voice: 'إنشاء صوت',
    enter_voice_name: 'أدخل اسم الصوت',
    select_voice_gender: 'يرجى اختيار جنس الصوت',
    upload_voice: 'تحميل صوتك',
    upload_voice_mp_three: 'قم بتحميل صوتك (.mp3)',
    cloned_voice: 'الأصوات المستنسخة',
    voice_type: 'نوع الصوت',
    select_voice_type: 'اختر نوع الصوت',
    sharelook_stand: 'قياسي',
    sharelook_premium: 'مميز',
    sharelook_custum_voice: 'مخصص (استنساخ الصوت)',
    create_auto_flow: 'إنشاء تدفق تلقائي',
    how_many_layers: 'كم عدد الطبقات',
    verify_selection: 'تحقق من الاختيار',
    uploaded_successful: 'تم التحميل بنجاح',
    upload_failed: 'فشل التحميل',
    upload_only_five_mb: 'تحميل محتوى (ملفات PDF، بحد أقصى 5)',
    docs_from_org_library: 'استخدام مستند من مكتبة المؤسسة',
    failed_maze_generate: 'فشل في إنشاء المتاهة. يرجى المحاولة مرة أخرى.',
    generate_metamaze: 'يتم إنشاء MetaMaze...',
    metamaze_being_generated:
      'يتم الآن إنشاء MetaMaze الخاصة بك. سيتم إشعارك عبر البريد الإلكتروني عند الانتهاء.',
    metamaze_generate_successfully: 'تم إنشاء MetaMaze بنجاح!',
    metamaze_with_proceed: 'يمكنك الآن المتابعة باستخدام MetaMaze.',
    ai_metamaze_generate: 'إنشاء MetaMaze بالذكاء الاصطناعي',
    what_kind_maze_create: 'ما نوع المتاهة التي ترغب في إنشائها؟',
    manual_metamaze_creation: 'إنشاء MetaMaze يدويًا',
    manually_maze_customizing_scnario:
      'قم بإنشاء متاهة يدويًا عن طريق تخصيص السيناريو وشجرة الخيارات',
    maze_ai_generated: 'إنشاء متاهة تلقائيًا باستخدام الذكاء الاصطناعي',
    unmark_deadend: 'إلغاء تحديد كنقطة نهاية',
    mark_deadend: 'تحديد كنقطة نهاية',
    select_multiple_image_for_scenario: 'يمكنك اختيار عدة صور للسيناريو.',
    select_your_image: 'الصور التي اخترتها',
    click_to_preview: 'انقر للمعاينة',
    are_you_sure_delete_image: 'هل أنت متأكد من حذف هذه الصورة؟',
    select_image_from_library: 'اختر صورة من مكتبة الوسائط',
    uploading_video: 'جارٍ تحميل الفيديو...',
    tree_node_type: 'نوع عقدة الشجرة',
    correct_option_scenario: 'الخيار الصحيح أو السيناريو',
    incorrect_option: 'خيار غير صحيح',
    option_scenario_without_text: 'خيار أو سيناريو بدون نص',

    dead_end: 'نهاية مسدودة (إطار أحمر)',
    correct_path: 'المسار الصحيح',
    incorrect_path_not_selected_correct_option_path:
      'مسار غير صحيح / مسار لم يتم فيه اختيار الخيار الصحيح.',
    double_click_on_tree_node:
      'عند النقر المزدوج على عقدة الشجرة، سيتم تمرير محرر النص تلقائيًا لعرض محتوى هذه العقدة المحددة في العرض.',
    add_scenario: 'إضافة سيناريو',
    add_option: 'إضافة خيار',
    an_error_occured: 'حدث خطأ:',
    download_summary: 'تحميل الملخص',
    step_wise_analysis: 'تحليل خطوة بخطوة',
    step: 'خطوة',
    upload_csv_file: 'تحميل ملف CSV',
    download_template_to_import: 'تحميل قالب نموذجي للاستيراد',
    please_input_email: 'يرجى إدخال البريد الإلكتروني.',
    email_at_least_three_characters:
      'يجب أن يحتوي البريد الإلكتروني على 3 أحرف على الأقل.',
    email_cannot_be_empty: 'لا يمكن أن يكون البريد الإلكتروني فارغًا.',
    input_email_in_new_line:
      'يرجى إدخال البريد الإلكتروني (كل بريد إلكتروني في سطر جديد)',
    role: 'الدور',
    select_role: 'يرجى اختيار الدور',
    select_group: 'يرجى اختيار المجموعة',
    identification_number: 'رقم الهوية (اختياري)',
    add_identification_number: 'يرجى إضافة رقم الهوية',
    pie_chart_of_all_categories:
      'مخطط دائري لجميع الفئات بناءً على استخدامها في Sharelook.',
    total_sharesphere_question_answered_by_users:
      'إجمالي أسئلة ShareSphere التي أجاب عليها المستخدمون في المؤسسة الحالية، مع هذه الفئات ونتائجها من النجاحات والإخفاقات.',
    voice_style_over_the_text:
      'حيث يمكنك استخدام العديد من أنماط الصوت على النص الذي تكتبه بلا بلا بلا لوريم إيبسوم هو ببساطة نص وهمي لصناعة الطباعة والتنضيد.',
    input_your_question: 'يرجى إدخال سؤالك!',
    make_me_sales_manager: 'مثال: ما الذي يمكن أن يجعلني مدير مبيعات',
    enter_the_number_relevant_document: 'أدخل عدد المستندات ذات الصلة',
    please_wait_loading_result: 'يرجى الانتظار جاري تحميل النتائج...',
    no_result_found: 'لم يتم العثور على نتائج، حاول طرح المزيد من الأسئلة',
    browser_doesnot_support_iframes: 'متصفحك لا يدعم iframes',
    total_duration: 'المدة الإجمالية',
    number_of_messages: 'عدد الرسائل',
    search_result: 'نتائج البحث',
    count_result: '(1244 نتيجة)',
    your_other_interests: 'اهتماماتك الأخرى',
    your_total_score: 'إجمالي نقاطك',
    add_a_question: '+إضافة سؤال',
    travia_question_empty: 'قائمة أسئلة Travia فارغة.',
    video_generation_is_on_queue: 'توليد الفيديو الخاص بك في قائمة الانتظار!',
    checking_video_status: 'جارٍ التحقق من حالة الفيديو...',
    total_quizzes: 'إجمالي الاختبارات',
    number_of_votes: 'عدد الأصوات',
    total_events: 'إجمالي الفعاليات',
    number_of_rates: 'عدد التقييمات',
    number_of_likes: 'عدد الإعجابات',
    all_courses: 'جميع الدورات',
    total_questions: 'إجمالي الأسئلة',
    no_skill_journey: 'لا توجد رحلة مهارية متاحة!',
    search_no_results: '- لا توجد نتائج متاحة!',
    no_image_generated: 'لم يتم توليد صور!',
    all_topic_in_this_lesson:
      'سيتم حذف جميع المواضيع في هذا الدرس. لا يمكن التراجع عن هذا.',
    content_has_been_generated: 'تم توليد المحتوى لهذا الموضوع.',
    update_course_template: 'تحديث قالب الدورة',
    add_course_template: 'إضافة قالب دورة',
    create_course_now: 'أنشئ الدورة الآن',
    preview_course: 'معاينة الدورة',
    layout: 'التخطيط',
    import_from_youtube: 'الاستيراد من يوتيوب',
    my_media_library: 'مكتبتي الإعلامية',
    bg_added: 'تمت إضافة الخلفية',
    add_bg: 'إضافة خلفية',
    booked_schedule: 'الجدول المحجوز',
    add_schedule: 'إضافة جدول',
    are_you_delete_schedule: 'هل أنت متأكد من حذف هذا الجدول؟',
    add_task: 'إضافة مهمة',
    update_calender: 'تحديث التقويم',
    manage_cookies: 'إدارة ملفات تعريف الارتباط',
    cookie_banner_text:
      'نستخدم ملفات تعريف الارتباط لتحسين تجربة التصفح الخاصة بك، وتحليل حركة مرور الموقع، وتخصيص المحتوى. خصوصيتك مهمة بالنسبة لنا.',
    accept_all_cookies: 'قبول جميع ملفات تعريف الارتباط',
    reject_all: 'رفض الكل',
    customize: 'تخصيص',
    cookie_preferences_title: 'تفضيلات ملفات تعريف الارتباط وإعدادات الخصوصية',
    privacy_subtitle:
      'خصوصيتك تهمنا. اختر ملفات تعريف الارتباط التي تناسبك. يمكنك تغيير هذه الإعدادات في أي وقت.',
    save_choices: 'حفظ اختياراتي',
    strictly_necessary: 'ضرورية للغاية',
    strictly_necessary_desc:
      'تعد هذه الملفات ضرورية لعمل الموقع بشكل صحيح. فهي تمكّن من الوظائف الأساسية مثل التنقل بين الصفحات وإرسال النماذج والوصول إلى المناطق الآمنة. لا يمكن للموقع أن يعمل بشكل صحيح بدونها.',
    analytics_performance: 'التحليلات والأداء',
    analytics_performance_desc:
      'تساعدنا هذه الملفات على فهم كيفية تفاعل الزوار مع موقعنا من خلال جمع المعلومات والإبلاغ عنها بشكل مجهول. هذا يساعدنا في تحسين أداء موقعنا وتجربة المستخدم.',
    advertising_marketing: 'الإعلانات والتسويق',
    advertising_marketing_desc:
      'تُستخدم هذه الملفات لجعل الرسائل الإعلانية أكثر صلة بك. فهي تمنع تكرار عرض نفس الإعلان باستمرار وتضمن عرض الإعلانات بشكل صحيح للمعلنين.',
    tracking_social: 'التتبع ووسائل التواصل الاجتماعي',
    tracking_social_desc:
      'تُتيح هذه الملفات وظائف مُحسّنة وتخصيصًا مثل ميزات وسائل التواصل الاجتماعي والمحتوى المخصص. قد يتم تعيينها من قبلنا أو من قبل مزودي خدمات خارجيين.',
    functional: 'وظيفية',
    functional_desc:
      'تمكّن هذه الملفات من وظائف محسّنة مثل دعم الدردشة والمساعدة المباشرة والميزات التفاعلية الأخرى التي تُحسّن تجربتك على موقعنا.',
    your_rights: 'حقوقك:',
    rights_description:
      'يمكنك سحب موافقتك في أي وقت، أو الوصول إلى بياناتك، أو طلب حذفها في أي وقت.',
    withdraw_consent: 'سحب جميع الموافقات',

    how_many_options: 'كم عدد الخيارات',
    add_content: 'إضافة محتوى',
    downloads_center: 'مركز التنزيلات',
    sharelook_help_center: 'مركز مساعدة Sharelook',
    channel_outline: 'مخطط القناة',
    channel_objectives: 'أهداف القناة',
    no_sop_available: 'لا توجد قائمة SOP متاحة.',
    generate_world_summary: 'إنشاء سيناريو',
    world_scenario: 'سيناريو واقعي',
    drag_icon_hint: 'نصيحة: اسحب الأيقونة على اللوحة لتحديد موقعها',
    drag_text_hint: 'نصيحة: اسحب النص على اللوحة لتحديد موقعه',
    edit_badge: 'تعديل الشارة',
    create_new_badge: 'شارة جديدة',
    select_video_preview: 'اختر فيديو للمعاينة',
    certificate_title_required: 'عنوان الشهادة مطلوب',
    discard_changes: 'تجاهل التغييرات',
    edit_certificate: 'تعديل الشهادة',
    add_another_logo: 'إضافة شعار آخر',
    optional: 'اختياري',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'إنشاء مهمة جديدة',
    quest_filter_title: 'المهمة',
    sharelook_assistance: 'مساعدة Sharelook',
    upload_scorm_zip: 'تحميل ملف Scorm مضغوط',
    only_letters_numbers_space_dot_allowed:
      'يُسمح فقط بالأحرف والأرقام والمسافات والنقاط!',
    video_playing: 'يتم التشغيل',
    course_price_message:
      '*سيتم نشر الدورة فقط للمستخدمين داخل المؤسسة ولا يمكن بيعها في السوق.',
    lesson_must_be_positive: 'يجب أن يكون عدد الدروس أكبر من 1',
    btn_proceed: 'متابعة',
    rule_select_music: 'يرجى اختيار موسيقى',
    course_info: 'معلومات الدورة',
    content_selection: 'اختيار المحتوى',
    course_content_source: 'مصدر محتوى الدورة',
    choose_how_to_source: 'اختر كيفية الحصول على محتوى هذه الدورة:',
    automatic_selection: 'اختيار تلقائي',
    system_will_automatically_select_relavant_documents:
      'سيقوم النظام تلقائيًا باختيار المستندات ذات الصلة من مكتبتك',
    manual_selection: 'اختيار يدوي',
    choose_specific_documents_from_your_library: 'اختر مستندات محددة من مكتبتك',
    upload_files: 'تحميل الملفات',
    upload_new_documents:
      'قم بتحميل مستندات جديدة (PDF، DOC، DOCX، PPT، PPTX، TXT) - بحد أقصى 5 ملفات',
    file: 'ملف',
    ready_to_upload: 'جاهز للتحميل',
    clear_all: 'مسح الكل',
    confirm_course_wide_premiew: 'تأكيد المعاينة الشاملة للدورة',
    generate_course_preview: 'إنشاء معاينة للدورة',
    instructions_across_the_course_to_generate:
      'سنطبق تعليماتك عبر الدورة لإنشاء معاينة. راجع كل شيء أولاً، ثم اختر الاحتفاظ بالتغييرات أو تجاهلها.',
    instruction_to_preview_course_wide: 'تعليمات لمعاينة الدورة:',
    edit_content: 'تعديل المحتوى',
    manage_course_template: 'إدارة قالب الدورة',
    undo: 'تراجع',
    apply_changes: 'تطبيق التغييرات',
    characters: 'أحرف',
    apply_all: 'تطبيق الكل',
    apply_to_all: 'تطبيق على الجميع',
    use_this_content: 'استخدم هذا المحتوى',
    original: 'الأصلي',
    edited: 'المعدل',
    edited_content_preview: 'معاينة المحتوى المعدل',
    apply_edits_to_all_topices: 'هل تريد تطبيق التعديلات على جميع المواضيع؟',
    current_editing_instructions_across_the_whole_course:
      'سيتم تطبيق تعليمات التحرير الحالية على كامل الدورة. يمكنك مراجعة المعاينة المجمعة قبل الحفظ.',
    edit_content_instructions: 'تعليمات تعديل المحتوى',
    generate_content_for_this_topic_instruction:
      'قم بإنشاء محتوى لهذا الموضوع باستخدام تعليماتك',
    descrip_edit_content:
      'صف كيفية تعديل هذا المحتوى (مثل: اختصره، بسّط اللغة، أعد الصياغة)',
    try_short_clear_direcctives:
      'جرّب توجيهات قصيرة وواضحة. أمثلة: "اختصر إلى 100 كلمة مع الاحتفاظ بالنقاط الأساسية"، "بسّط اللغة"، "اجعلها أكثر إيجازًا".',
    we_preserve_the_core_meaning:
      'نحافظ على المعنى الأساسي أثناء تطبيق تعليماتك.',
    feedback_optional: 'ملاحظات (اختياري)',
    write_your_feedback_here: 'اكتب ملاحظاتك هنا',
    from_web: 'من الويب',
    from_desktop: 'من سطح المكتب',
    pleae_wait_processing: 'يرجى الانتظار حتى انتهاء المعالجة...',
    create_simulation_from_screen_capture: 'إنشاء محاكاة من تسجيل الشاشة',
    sharelook_not_found: 'لم يتم العثور على ShareLook',
    sharelook_screen_capture_application_not_be_opened:
      'تعذر فتح تطبيق ShareLook لتسجيل الشاشة. ربما لم يتم تثبيته على جهازك.',
    download_sharelook: 'تحميل ShareLook',
    launch_sharelook_application: 'تشغيل تطبيق ShareLook',
    this_will_open_the_sharelook_application_for_screen_capture:
      'سيؤدي هذا إلى فتح تطبيق ShareLook لتسجيل الشاشة.',
    sharelook_dosenot_open:
      'إذا لم يفتح ShareLook، فقد لا يكون مثبتًا على جهازك.',
    open_sharelook: 'فتح ShareLook',
    download_app: 'تحميل التطبيق',
    background_image_setting: 'إعدادات صورة الخلفية',
    current_image: 'الصورة الحالية',
    change_image: 'تغيير الصورة',
    remove_image: 'إزالة الصورة',
    no_background_image_selected: 'لم يتم اختيار صورة خلفية',
    add_image: 'إضافة صورة',
    this_will_open_for_screen_recording:
      'سيؤدي هذا إلى فتح تطبيق ShareLook لتسجيل الشاشة.',
    ai_image_generation: 'توليد الصور بالذكاء الاصطناعي',
    image_edit: 'تعديل الصورة',
    text_to_image: 'تحويل النص إلى صورة',
    output_gallary: 'معرض النتائج',
    instant_generation: 'جاهز للتوليد الفوري',
    prompt_and_unleash_the_power: 'أدخل التعليمات واستفد من القوة الكاملة',
    use_this_image: 'استخدم هذه الصورة',
    error_generating: 'حدث خطأ أثناء التوليد.',
    generation_tips: 'نصائح التوليد',
    detailed_descriptions_for_more_accurate_results:
      'استخدم أوصافًا تفصيلية للحصول على نتائج أكثر دقة',
    reference_image: 'صورة مرجعية',
    select_pixel_image: 'اختر صورة بكسل',
    max_mb: 'الحد الأقصى 50 ميغابايت',
    please_enter_text_to_appear_image: 'يرجى إدخال النص الذي سيظهر في الصورة',
    enter_text_to_apear_in_the_image: 'أدخل النص الذي سيظهر في الصورة',
    generate_image: 'توليد الصورة',
    prompt_assistant: 'مساعد الأوامر النصية',
    generate_image_using_suggested_prompt: 'توليد صورة باستخدام الأمر المقترح',
    talk_to_ai_about_the_image_generate:
      'تحدث إلى الذكاء الاصطناعي عن الصورة التي تريد توليدها',
    ask_for_prompt_suggestions: 'اطلب اقتراحات للأوامر...',
    enter_a_search_term_to_find_stock_images:
      'أدخل مصطلح بحث للعثور على صور جاهزة',
    choose_your_content_source: 'اختر مصدر المحتوى:',
    upload_new_document_from_your_device: 'تحميل مستند جديد من جهازك',
    automatic_library_selection: 'اختيار المكتبة تلقائيًا',
    system_automatically_selects_relevant_document:
      'يقوم النظام تلقائيًا باختيار المستندات ذات الصلة',
    manual_library_selection: 'اختيار يدوي من المكتبة',
    generate_content: 'توليد المحتوى',
    add_to_current_page: 'إضافة إلى الصفحة الحالية',
    generate_bullet_points: 'توليد نقاط مختصرة',
    generating: 'جارٍ التوليد',
    this_may_take_a_few_moments: 'قد يستغرق ذلك بضع لحظات',
    apply_to_page: 'تطبيق على الصفحة',
    scenario_escription: 'وصف السيناريو:',
    feedback: 'ملاحظات',
    form_mode: 'وضع النموذج',
    chat_mode: 'وضع الدردشة',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'سيقوم بإنشاء استمرار للقصة المحددة باستخدام الذكاء الاصطناعي.',
    continue_this_story_question: 'هل ترغب في متابعة هذه القصة؟',
    continue_this_story: 'تابع هذه القصة',
    what_will_happen: 'ماذا سيحدث:',
    the_ai_will_analyze_the_existing_story_content:
      'سيقوم الذكاء الاصطناعي بتحليل محتوى القصة الحالية',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'سينشئ استمرارًا طبيعيًا بنفس النغمة والأسلوب',
    create_new_content_that_build_upon_the_current_narrative:
      'سيُنشئ محتوى جديدًا يبني على السرد الحالي',
    this_process_may_take_a_few_moments_to_complete:
      'قد تستغرق هذه العملية بضع لحظات.',
    no_existing_stories_found_for_this_course:
      'لم يتم العثور على قصص موجودة لهذه الدورة.',
    create_your_first_story: 'أنشئ قصتك الأولى',
    existing_stories: 'القصص الحالية',
    create_new_story: 'إنشاء قصة جديدة',
    tone: 'النغمة',
    style: 'الأسلوب',
    genre: 'النوع الأدبي',
    loading_your_stories: 'جارٍ تحميل قصصك...',
    edit_story: 'تعديل القصة',
    story_preferences: 'تفضيلات القصة',
    please_input_your: 'يرجى إدخال',
    add_character_names_and_press_enter: 'أضف أسماء الشخصيات واضغط إدخال',
    select_or_type_your: 'اختر أو اكتب',
    enter_your: 'أدخل',
    position_of_the_story_in_the_lesson:
      'موضع القصة في الدرس. ستُضاف القصة ككتلة في الموضع المحدد.',
    save_previous_content_on_the_pages: 'حفظ المحتوى السابق في الصفحات',
    the_existing_content_in_the_selected_pages:
      'سيتم استبدال المحتوى الحالي في الصفحات المحددة بالقصة المولدة.',
    real_world_scenario: 'سيناريو واقعي',
    add_optional_instructions:
      'أضف تعليمات اختيارية (النغمة، الطول، الجمهور، إلخ)',
    ready_to_enerate_your_real_world_scenario: 'جاهز لإنشاء سيناريو واقعي',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'انقر على "إنشاء سيناريو واقعي" لإنشاء سيناريو واقعي بناءً على محتوى درسك.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'سيقوم الذكاء الاصطناعي بتحليل موضوع الدرس والمحتوى',
    generate_a_practical_real_world_scenario:
      'إنشاء سيناريو عملي من العالم الواقعي',
    you_can_then_edit_and_customize_the_result:
      'يمكنك بعد ذلك تعديل النتيجة وتخصيصها',
    add_it_as_a_new_page_to_your_lesson: 'أضفها كصفحة جديدة إلى الدرس الخاص بك',
    regenerate_with_instructions: 'إعادة التوليد مع التعليمات',
    add_real_world_scenario: 'أضف سيناريو من العالم الحقيقي',
    generate_real_world_scenario: 'إنشاء سيناريو من العالم الحقيقي',
    simulation_has_been_stopped: 'تم إيقاف المحاكاة!',
    loading_simulation: 'جارٍ تحميل المحاكاة…',
    you_have_exhausted_all_the_attempts: 'لقد استنفدت جميع المحاولات',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'ادرس السيناريو في هذه الصفحة واختر الإجابة الصحيحة من الخيارات أدناه.',
    attempts_limit_reached:
      'تم الوصول إلى حد المحاولات. يمكنك اللعب مرة أخرى لكن لن يتم حفظ نتيجتك.',
    play_again: 'العب مرة أخرى',
    import_music_from_computer: 'استيراد الموسيقى من الكمبيوتر.',
    more: 'المزيد',
    no_badge_yet: 'لا توجد شارات بعد',
    competition_filter: 'مرشح المسابقة',
    global_leaderboard: 'قائمة المتصدرين العالمية',
    placeholder_for_the_global_leaderboard:
      'هذا عنصر نائب لقائمة المتصدرين العالمية.',
    badge_editor: 'مُحرّر الشارات',
    adjust_the_appearance_of_this_badge_icon:
      'قم بضبط مظهر أيقونة الشارة هذه. التغييرات تنطبق على هذه الشارة فقط.',
    badge_style: 'أسلوب الشارة',
    the_image_must_be_pixels: 'يجب أن تكون الصورة ‎200×200 بكسل.',
    badge_name: 'اسم الشارة',
    badge_descrription: 'وصف الشارة',
    enter_badge_criteria: 'أدخل معايير الشارة',
    discard: 'تجاهل',
    badge_enable: 'تمكين الشارات',
    award_users_with_badges_to_highlight_the_milestones:
      'امنح المستخدمين شارات لتسليط الضوء على الإنجازات في رحلة التعلم الخاصة بهم.',
    badge_types: 'أنواع الشارات',
    enable_or_disable_specific_badge_types_for_your_users:
      'قم بتمكين أو تعطيل أنواع الشارات المحددة لمستخدميك.',
    levels_enabled: 'تم تمكين المستويات',
    level_rules: 'قواعد المستوى',
    points: 'النقاط',
    add_new_level: 'أضف مستوى جديد',
    add_level: 'أضف مستوى',
    points_enabled: 'تم تمكين النقاط',
    learning_activities_and_encourage_healthy_competition:
      'امنح المستخدمين نقاطاً للأنشطة التعليمية المختلفة وشجّع المنافسة الصحية.',
    award_points: 'امنح نقاطاً',
    the_following_equates_the_value_of_one_item_completion:
      'ما يلي يعادل قيمة إكمال عنصر واحد',
    general: 'عام',
    others: 'أخرى',
    certificate: 'شهادة',
    quiz_passed: 'تم اجتياز الاختبار',
    tip_approved: 'تم اعتماد النصيحة',
    tip_liked: 'تم الإعجاب بالنصيحة',
    rewards: 'المكافآت',
    offer_discounts_when_learners_achieve:
      'قدّم خصومات عندما يحقق المتعلمون مجموعة من النقاط أو الشارات أو المستويات.',
    give_rewards: 'قدّم مكافآت',
    discount_course_purchases_by: 'خصم عند شراء الدورات بـ',
    with_points_more_than: 'مع نقاط أكثر من',
    with_badges_more_than: 'بشارات أكثر من',
    with_level_upwards_more_than: 'بمستوى أعلى من',
    leaderboard: 'قائمة المتصدرين',
    leaderboard_enabled: 'تم تمكين قائمة المتصدرين',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'توفر قوائم المتصدرين للمستخدمين عرضاً لتقدمهم في التعلم بالنقاط مقارنةً بجميع الآخرين.',
    show_levels: 'عرض المستويات',
    show_points: 'عرض النقاط',
    show_badges: 'عرض الشارات',
    show_courses: 'عرض الدورات',
    show_certificates: 'عرض الشهادات',
    leaderboard_settings: 'إعدادات قائمة المتصدرين',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'قم بإعداد تجارب قائمة متصدرين جذّابة لزيادة تحفيز المتعلّمين.',
    award_users_with_points_for_different_learning_activities:
      'منح المستخدمين نقاطاً عن أنشطة تعليمية مختلفة.',
    badge_set: 'مجموعة الشارات',
    choose_the_type_of_badges_your_users:
      'اختر نوع الشارات التي سيحصل عليها مستخدموك أثناء تعلمهم.',
    levels: 'المستويات',
    Levels_represent_the_stages:
      'المستويات تمثل المراحل في رحلة تعلم المستخدم.',
    enabled: 'ممكّن',
    disabled: 'معطّل',
    quick_select: 'اختيار سريع',
    yesterday: 'أمس',
    last_week: 'الأسبوع الماضي',
    Last_month: 'الشهر الماضي',
    last_quarter: 'الربع الماضي',
    historical_leaderboard: 'قائمة المتصدرين التاريخية',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'تتبّع أدائك وانظر كيف تحتل موقعاً بين أقرانك',
    time_period: 'الفترة الزمنية',
    page_of: 'الصفحة 1 من 1',
    edit_competition: 'تحرير المسابقة',
    create_competition: 'إنشاء مسابقة',
    arrow_right: 'سهم – يمين',
    update_competition: 'تحديث المسابقة',
    competition_title: 'عنوان المسابقة',
    enter_competition_title: 'أدخل عنوان المسابقة',
    enter_competition_description: 'أدخل وصف المسابقة',
    leaderboard_skill: 'المهارة',
    select_a_skill: 'اختر مهارة',
    no_skills_found: 'لم تُعثر على مهارات',
    competition_period: 'فترة المسابقة',
    add_badge_rule: 'أضف قاعدة شارة',
    create_badge: 'إنشِئ شارة',
    add_level_rule: 'أضف قاعدة مستوى',
    selected_participants: 'المشاركون المختارون',
    no_participants: 'لا يوجد مشاركون',
    start_end_date: 'تاريخ البدء–الانتهاء',
    created_date: 'تم الإنشاء بواسطة',
    new_competition: 'مسابقة جديدة',
    competitions_list: 'قائمة المسابقات',
    search_competitions: 'ابحث في المسابقات…',
    are_you_sure_you_want_to_delete_the_competition:
      'هل أنت متأكد أنك تريد حذف المسابقة؟',
    history: 'السجل',
    export: 'تصدير',
    search_by_name: 'البحث بالاسم…',
    no_historical_data_available_for_the_selected_period:
      'لا توجد بيانات تاريخية متاحة للفترة المحددة.',
    no_leaderboard_data_available: 'لا تتوفر بيانات قائمة المتصدرين.',
    competitions: 'المسابقات',
    leaderboards: 'قوائم المتصدرين',
    welcome_back: 'مرحباً بعودتك',
    track_your_performance_and_see: 'تتبّع أدائك وانظر:',
    team_leaderboard: 'قائمة المتصدرين للفريق',
    try_again: 'حاول مرة أخرى',
    no_competitions_for_search: 'لا توجد مسابقات متاحة لـ',
    no_competitions_available: 'لا توجد مسابقات متاحة',
    no_competitions_matching_search:
      'لم تُعثر على مسابقات تطابق بحثك. حاول تعديل مصطلحات البحث أو تحقق لاحقاً من مسابقات جديدة.',
    no_competitions_general:
      'لا توجد حاليّاً مسابقات مُعدة. تحقق لاحقاً أو اتصل بمسؤولك لإنشاء مسابقات جديدة.',
    media_management: 'إدارة الوسائط',
    badgess_set: 'مجموعة الشارات',
    choose_the_default_visual_style_for_badge:
      'اختر النمط البصري الافتراضي لأيقونات الشارات المستخدمة عبر المنصة.',
    enable_badges: 'تمكين الشارات',
    add_badge: 'أضف شارة',
    min: 'دقيقة',
    max: 'عظمى',
    your_rank: 'ترتيبك',
    your_points: 'نقاطك',
    your_level: 'مستواك',
    rank: 'الترتيب #',
    level: 'المستوى',
    progress: 'التقدم',
    new_folder: 'مجلد جديد',
    file_upload: 'رفع ملف',
    writer: 'كاتب',
    text_documents: 'مستندات نصية',
    spreadsheets: 'جداول البيانات',
    impress: 'عروض تقديمية',
    presentations: 'العروض التقديمية',
    capture_desktop_screen: 'التقاط شاشة سطح المكتب',
    capture_desktop_screens: 'التقاط شاشات سطح المكتب',
    your_documents: 'مستنداتك',
    manage_your_videos_images_audio_files:
      'قم بإدارة مقاطع الفيديو، الصور، ملفات الصوت، وغيرها من الموارد المستخدمة في إنشاء المحتوى.',
    your_organization_documents: 'مستندات منظمتك',
    keep_your_organization_creative_assets_organized:
      'احتفظ بأصول منظمتك الإبداعية منظمة ومتاحة — بسّط العمل الجماعي وإنتاج المحتوى.',
    your_public_documents: 'مستنداتك العامة',
    curated_collection_of_media_assets_available:
      'مجموعة مُنقّحة من أصول الوسائط المتاحة للجميع — استعرض، أعد استخدامها، وابتكر.',
    your_download_center_documents: 'مستندات مركز التنزيلات لديك',
    repository_of_approved_media_assets_for_download:
      'مستودع لأصول الوسائط المعتمدة للتحميل والاستخدام في مشاريعك.',
    search_files_and_folders: 'ابحث في الملفات والمجلدات..',
    home: 'الرئيسية',
    folders: 'المجلدات',
    folder_name: 'اسم المجلد',
    owner: 'المالك',
    last_updated: 'آخر التحديث',
    action: 'إجراء',
    no_folders_found: 'لم تُعثر على مجلدات',
    files: 'الملفات',
    enabling_ai: 'تمكين الذكاء الاصطناعي…',
    rename: 'إعادة التسمية',
    copy: 'نسخ',
    move: 'نقل',
    verson_history: 'سجل الإصدارات',
    manage_permission: 'إدارة الأذونات',
    generate_audit_report: 'إنشاء تقرير تدقيق',
    last_edited: 'آخر تعديل',
    no_files_found: 'لم تُعثر على ملفات',
    are_you_sure_you_want_to_make_this_item_public:
      'هل أنت متأكد أنك تريد جعل هذا العنصر عاماً؟ سيتم نسخه إلى مكتبتك العامة.',
    move_to_organization: 'نقل إلى المنظمة',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'هل أنت متأكد أنك تريد نسخ هذا العنصر إلى مكتبة منظمتك؟',
    are_you_sure_you_want_to_make_this_item_private:
      'هل أنت متأكد أنك تريد جعل هذا العنصر خاصاً؟ سيتم نسخه إلى مكتبتك الخاصة.',
    date_modified: 'تاريخ التعديل',
    workflow_management: 'إدارة سير العمل',
    configure_editors_approvers_and_viewers_for_this_document:
      'ضبط المحرّرين، الموافقين، والمشاهدين لهذا المستند.',
    error_Loading_editor: 'خطأ في تحميل المحرّر',
    debug_info: 'معلومات تصحيح',
    loading_editor: 'جارٍ تحميل المحرّر…',
    submitted_for_review: 'تم الإرسال للمراجعة',
    editors: 'المحرّرون',
    no_editors_added_yet:
      'لم يُضف محرّر حتى الآن. اضغط "إضافة محرّر" لإضافة واحد.',
    add_editor: 'أضف محرّراً',
    approvers: 'الموافقون',
    no_approvers_added_yet:
      'لم يُضف موافق حتى الآن. اضغط "أضف موافق" لإضافة واحد.',
    add_approvers: 'أضف الموافقين',
    viewer: 'المشاهد',
    no_viewers_added_yet:
      'لم يُضف مشاهد حتى الآن. اضغط "أضف مشاهد" لإضافة واحد.',
    add_viewer: 'أضف مشاهد',
    are_you_sure_you_want_to_delete_the_selected_items:
      'هل أنت متأكد أنك تريد حذف العناصر المحددة؟'
  },
  v3: {
    reportShareSphere: 'شـيرسـفير',
    overview: 'نظرة عامة على الفئة',
    triviaReport: 'فئة شيرسـفير',
    overviewGraph: 'رسم بياني لنظرة عامة على الفئة',
    category: 'الفئة',
    phCategory: 'اختر الفئة',
    podcast: 'بودكاست، موسيقى وقصص',
    pastPodcast: 'البودكاست السابق',
    upcomingPodcast: 'البودكاست القادم',
    podcastLanguageTitle: 'لغة البودكاست، الموسيقى والقصص',
    podcastLanguageCheckbox: 'إنشاء اللغة تلقائيًا باستخدام الذكاء الاصطناعي',
    howRate: 'كيف تقيم هذا البودكاست؟',
    podcastSubmit: 'إرسال',
    podcastGuest: 'المتحدث الضيف:',
    podcastReview: 'المراجعات',
    podcastEpishode: 'الحلقات',
    podcastEnd: 'انتهى البودكاست',
    date_podcast: 'تاريخ البودكاست',
    skill_not_found: 'عذرًا! لم يتم العثور على رحلة مهارية.',
    coaching: 'تدريب',
    webinar: 'ويبينار',
    public_conference: 'مؤتمر عام',
    skill_journey_subtitle:
      'أضف إعدادات إلى رحلتك المهارية وحدد من يمكنه رؤية والتفاعل مع الرحلة.',
    enable_white_label: 'تمكين العلامة البيضاء',
    create_new_event_org: 'إنشاء فعالية جديدة لمؤسستك.',
    create_new_event_marketplace: 'إنشاء فعالية جديدة للسوق.',
    create_new_event_both: 'إنشاء فعالية جديدة لكل من مؤسستك والسوق.',
    event_outline: 'يرجى إدخال مخطط الفعالية',
    event_obj: 'يرجى إدخال أهداف الفعالية',
    event_description: 'يرجى إدخال وصف الفعالية',
    create_new_metamaze_org: 'إنشاء متاهة جديدة لمؤسستك.',
    create_new_metamaze_marketplace: 'إنشاء متاهة جديدة للسوق.',
    create_new_metamaze_both: 'إنشاء متاهة جديدة لكل من مؤسستك والسوق.',
    add_key_words: 'أضف كلمات مفتاحية',
    press_enter_make_keyword: 'اضغط Enter لإنشاء كلمة مفتاحية',
    disable_skip_quiz: 'تعطيل تخطي الاختبار',
    warning_complete_quiz: 'يرجى إكمال الاختبار للمتابعة.',
    signup_email_verification:
      'لقد أرسلنا رابط التحقق إلى البريد الإلكتروني الذي قدمته. يرجى زيارة الرابط لتأكيد التسجيل.',
    verifying_registration: 'جارٍ التحقق من تسجيل الحساب...',
    reset_password_linK:
      'لقد أرسلنا رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني. يرجى زيارة الرابط لإعداد كلمة مرور جديدة.',
    reset_email_error:
      'لم يتم العثور على مستخدم بهذا البريد الإلكتروني، يرجى المحاولة باستخدام اسم المستخدم بدلاً من ذلك!',
    first_name: 'الاسم الأول',
    last_name: 'اسم العائلة',
    error_firstName: 'يرجى إدخال الاسم الأول',
    error_sharebot_organization: 'يرجى إدخال اسم المؤسسة',
    error_lastName: 'يرجى إدخال اسم العائلة',
    private_conference: 'مؤتمر خاص',
    public_conference: 'مؤتمر عام',
    discussion_room: 'غرفة النقاش',
    training_no_courses: 'أنت غير مسجل حاليًا في أي دورة.',
    training_no_events: 'أنت غير مسجل حاليًا في أي فعالية.',
    allow_sharing_trainer_info: 'السماح بمشاركة البريد الإلكتروني في السوق',
    error_username_space: 'لا يمكن لاسم المستخدم أن يحتوي على مسافات.',
    error_sharebot_organization_space:
      'لا يمكن لاسم المؤسسة أن تحتوي على مسافات.',
    edit_permission: 'تعديل الصلاحية',
    valid_price: 'يجب أن يكون السعر أكبر من 0',
    course_price_message: `* سيتم نشر الدورة فقط لعدد المستخدمين الذين اشترتهم المؤسسة
ولن تكون متاحة لإعادة البيع في السوق`,
    valid_edit_price: 'يجب أن يكون سعر التعديل أقل من سعر الشراء.',
    my_calendar: 'تقويمي',
    error_valid_firstName: 'يرجى إدخال اسم أول صحيح.',
    error_valid_organization: 'يرجى إدخال اسم مؤسسة صحيح.',
    error_valid_lastName: 'يرجى إدخال اسم عائلة صحيح.',
    error_name_spaces: 'لا يمكن أن يحتوي الاسم على مسافات',
    items: 'العناصر',
    publish_to_channel: 'نشر في مجموعة قنواتي',
    create_a_channel: 'إنشاء قناتي',
    create_a_trivia: 'لعبة معلومات عامة',
    create_a_new_channel: 'إنشاء قناة جديدة',
    add_videos: 'إضافة فيديوهات',
    save_and_continue: 'حفظ ومتابعة',
    channel: 'قناة',
    channels: 'قنوات',
    view_channel: 'عرض القناة',
    edit_channel: 'تعديل القناة',
    delete_channel: 'حذف القناة',
    my_video_channels: 'قنواتي المرئية',
    training_no_channel: 'أنت غير مسجل حاليًا في أي قناة.',
    monthly_price_required: 'السعر الشهري مطلوب',
    yearly_price_required: 'السعر السنوي مطلوب',
    one_time_price_required: 'السعر لمرة واحدة مطلوب',
    marketplace_quantity: 'دولار أمريكي',
    report_webinar: 'ويبينار',
    report_coaching: 'تدريب',
    report_channel: 'قناة',
    report_public_conference: 'مؤتمر عام',
    report_maze: 'متاهة',
    edit_price: 'تعديل السعر ($)',
    quantity: 'الكمية',
    payment_type: 'نوع الدفع',
    total_amount: 'المبلغ الإجمالي ($)',
    net_amount: 'المبلغ الصافي ($)',
    edit_option: 'تعديل الخيار',
    marketplace_price: 'السعر ($)',
    market_name: 'الاسم',
    duration_min: 'المدة (دقيقة)',
    users_total: 'المستخدمون (الإجمالي)',
    sales_total: 'إجمالي المبيعات (دولار أمريكي)',
    search_coaching: 'بحث في التدريب',
    search_channel: 'بحث في القناة',
    search_webinar: 'بحث في الويبينار',
    search_maze: 'بحث في المتاهة',
    search_public_conference: 'بحث في المؤتمر العام',
    buyer_type: 'نوع المشتري',
    quanity: 'الكمية',
    channel_unit_amount: 'المبلغ الصافي ($)',
    channel_updated_at: 'تاريخ التحديث',
    month_price: 'السعر (شهري)',
    year_price: 'السعر (سنوي)',
    one_time_price: 'السعر (مرة واحدة)',
    sharebot_organization: 'أضف اسم مؤسسة جديد',
    share_sphere: 'شيرسـفير',
    ai_course_title: 'عنوان الدورة',
    ai_input_course_title: 'يرجى إدخال عنوان الدورة!',
    learning_objective_label: 'هدف التعلم',
    learning_objective_message: 'يرجى إدخال هدف التعلم!',
    standard_question: 'هل هناك معايير يجب على المتعلم اتباعها؟',
    standard_details_label: 'تفاصيل المعيار',
    standard_details_message: 'يرجى إدخال تفاصيل المعيار!',
    estimated_duration_label: 'المدة التقديرية للدورة (بالدقائق)',
    estimated_duration_message: 'يرجى إدخال المدة التقديرية!',
    min_duration_message: 'الحد الأدنى للمدة هو 5 دقائق.',
    ai_mins: '25 دقيقة',
    industry_specific_question: 'هل هي مخصصة لصناعة معينة؟',
    industry_label: 'حدد الصناعة',
    industry_message: 'يرجى إدخال الصناعة!',
    ai_course_creation: 'إنشاء دورة عبر الذكاء الاصطناعي',
    course_generated: 'تم إنشاء الدورة بواسطة Sharelook',
    ai: 'الذكاء الاصطناعي',
    ai_you: 'أنت',
    ai_prompt_ready: 'المطالبة جاهزة. أنت الآن جاهز لإنشاء جدول المحتويات.',
    ai_unable_respond:
      'عذراً! الذكاء الاصطناعي غير قادر على الرد. يرجى المحاولة مرة أخرى.',
    ai_hide_toc: 'إخفاء جدول المحتويات',
    ai_preview_toc: 'عرض جدول المحتويات',
    ai_generate_toc_now: 'إنشاء جدول المحتويات الآن',
    ai_creation_course_title: 'عنوان الدورة:',
    ai_creation_industry_specific: 'هل هي مخصصة لصناعة معينة؟',
    ai_creation_industry: 'الصناعة:',
    ai_creation_standard_needed: 'هل لدى المتعلم أي معيار يجب اتباعه؟',
    ai_creation_standard_details: 'تفاصيل المعيار:',
    ai_creation_estimated_duration: 'المدة التقديرية للدورة (بالدقائق):',
    minutes: 'دقائق',
    ai_creation_learning_objective: 'هدف التعلم:',
    setup_again: 'إعادة الإعداد',
    ai_creation_confirm_title: 'هل أنت متأكد من إعادة إعداد النموذج؟',
    ai_creation_confirm_content:
      'سيتم إعادة ضبط الدردشة وجميع المحتوى الذي أنشأته.',
    ai_toc: 'جدول المحتويات',
    ai_note_topic: 'ملاحظة: يمكنك سحب وإفلات لإعادة ترتيب المواضيع داخل الدرس.',
    ai_add_topic: '+ أضف موضوعًا',
    add_topic: 'أضف موضوعًا',
    add_lesson: 'أضف درسًا',
    add_new_lesson: 'أضف درسًا جديدًا',
    ai_add_lesson: '+ أضف درسًا',
    attention: 'انتباه',
    before_varifying: 'قبل التحقق',
    ai_save_later: 'احفظ لاحقًا',
    ai_download_word_doc: 'تحميل كملف Word',
    ai_download_course_word_doc: 'تحميل الدورة كملف Word',
    ai_create_course_button: 'إنشاء الدورة',
    ai_generate_course_content: 'إنشاء محتوى الدورة',
    ai_out_of: 'من أصل',
    ai_subtopic_failed_content:
      'فشل إنشاء المحتوى لبعض المواضيع الفرعية. اضغط "إنشاء محتوى الدورة" مرّة أخرى لإنشاء محتوى لها فقط.',
    ai_edit_topic: 'تعديل الموضوع',
    ai_edit_lesson_title: 'تعديل عنوان الدرس',
    ai_save_topic: 'حفظ الموضوع',
    ai_save: 'حفظ',
    ai_save_lesson_title: 'حفظ عنوان الدرس',
    ai_add_new_topic: 'أضف موضوعًا جديدًا',
    ai_download_ref: 'تحميل مع المراجع',
    ai_download_ref_content: 'سيتم تنزيل الدورة كملف Word مع المراجع.',
    ai_download_without_ref: 'تحميل بدون مراجع',
    ai_download_two_word: 'سيتم تنزيل ملفي Word:',
    ai_download_two_word_content_one:
      '- واحد يحتوي على المحتوى الرئيسي بدون مراجع،',
    ai_download_two_word_content_two:
      'والآخر يحتوي فقط على قائمة بالمراجع دون محتوى إضافي.',
    ai_manage_content: 'إدارة المحتوى',
    ai_add_content_from_internet: '+ أضف محتوى من الإنترنت',
    ai_confirm_start: 'تأكيد البدء',
    ai_Verify: 'تحقق',
    ai_undo_warning:
      'قد يستغرق هذا بعض الوقت. يرجى عدم إغلاق هذه النافذة حتى اكتمال الإنشاء، لأنه لا يمكن التراجع عن ذلك.',
    ai_verified_content:
      'لقد تحققت من المحتوى. بعد التأكيد، لن تتمكن من العودة للدردشة مع مساعد الذكاء الاصطناعي بالمحتوى الحالي.',
    ai_want_proceed: 'هل أنت متأكد أنك تريد المتابعة؟',
    upload_simulation: 'تحميل المحاكاة',
    name_simulation: 'اسم المحاكاة',
    selected_simulation_files: 'ملفات المحاكاة المحددة',
    score_between_one_hundred: 'يجب أن تكون درجتك بين 1 و100.',
    are_sure_simulation: 'هل أنت متأكد من حذف ملف المحاكاة هذا؟',
    required_simulation: 'الدرجة مطلوبة',
    required_section_file: 'ملف القسم مطلوب',
    simulation: 'محاكاة',
    simulation_quiz_games: 'يلزم إضافة اختبار في الألعاب',
    simulation_alert_des:
      'يمكنك إضافة الألعاب فقط إذا كانت جميع الأسئلة من نوع إجابة واحدة أو متعددة.',
    alert_info: 'معلومة',
    ai_number_quiz: 'عدد الاختبارات',
    ai_point: 'نقطة',
    ai_points: 'نقاط',
    val_required: 'مطلوب',
    games: 'ألعاب',
    add_simulation: 'أضف محاكاة',
    text_tiewer: 'عارض النص',
    back_to_account: 'العودة إلى الحساب',
    delete_account: 'حذف الحساب',
    delete_account_title: 'حذف الحساب؟',
    delete_account_subtitle: 'يمكنك حذف حسابك من هنا.',
    delete_account_cannot_undo:
      'أنت على وشك حذف حسابك. لا يمكن التراجع عن هذا الإجراء.',
    account_org_profile:
      'ستفقد جميع الدورات التي أنشأتها، وملف مؤسستك وجميع إعداداتك.',
    deleting_account_database:
      'سيتم حذف جميع بياناتك من قاعدة بياناتنا عند حذف الحساب.',
    account_confirm_delete: 'هل أنت متأكد من حذف حسابك؟',
    action_cannot_be_undone: 'لا يمكن التراجع عن هذا الإجراء.',
    account_delete_message_success: 'تم حذف حسابك بنجاح.',
    message_edit: 'تعديل',
    message_delete: 'حذف',
    message_reply: 'رد',
    attached_file: 'ملف مرفق',
    attach_file: 'إرفاق ملف',
    attach_des: '25 ميغابايت، الحد الأقصى لحجم الملف',
    view: 'عرض',
    go_to_marketplace: 'الذهاب إلى السوق',
    learning_center: 'مركز التعلم',
    knowledge_center: 'مركز المعرفة',
    sharebot: 'شيربوت',
    sharebot_help_message: 'كيف يمكنني مساعدتك اليوم؟',
    my_organization: 'منظمتي',
    world_knowledge: 'معرفة العالم',
    welcome_to_sharelook: 'مرحبًا بك في Sharelook!',
    sharelook_you_want_go: 'إلى أين تريد الذهاب اليوم؟',
    shareLook_learning_management_system:
      'الوصول إلى نظام إدارة التعلم الخاص بـ ShareLook لإنشاء أو الوصول إلى موارد التعلم مثل الأحداث المباشرة والدورات في مؤسستك.',
    shareLook_powerful_ai_system:
      'الوصول إلى نظام ShareLook المدعوم بالذكاء الاصطناعي حيث يمكنك تحميل ملفات PDF والحصول على رؤى مفيدة بسرعة. استخرج إجابات فورية بناءً على الموارد في مؤسستك أو اسأل من نظام الذكاء الاصطناعي العالمي.',
    edit_now: 'حرر الآن',
    sharelook_log_out: 'تم تسجيل خروجك من Sharelook. يرجى تسجيل الدخول!',
    sorry_error: 'عذرًا! واجهنا خطأ ما.',
    login: 'تسجيل الدخول',
    refresh_page: 'تحديث الصفحة',
    just_a_moment: 'لحظة من فضلك',
    enter_lname_fname: 'يرجى إدخال الاسم الأول واسم العائلة للمتابعة.',
    procced_to_sharelook: 'المتابعة إلى Sharelook',
    option_one: 'الخيار 1',
    option_two: 'الخيار 2',
    selected_image: 'الصورة المحددة:',
    add_text: 'أضف نصاً',
    linkdin_is_required: 'لينكدإن مطلوب.',
    bio_is_required: 'السيرة الذاتية مطلوبة.',
    save_user_information: 'حفظ معلومات المستخدم',
    select_all: 'تحديد الكل',
    enable_ai: 'تفعيل الذكاء الاصطناعي',
    load_more: 'تحميل المزيد',
    channel_id: 'معرّف القناة.',
    send: 'إرسال',
    v4: 'معلومات',
    subscription: 'الاشتراك',
    reset_user_flag: 'إعادة تعيين علامة المستخدم',
    delete_my_accont: 'حذف حسابي',
    sharebot_sub_error: 'خطأ في جلب الاشتراكات. حاول مرة أخرى!',
    sharebot_no_sub: 'ليس لديك اشتراكات نشطة حالياً.',
    sharebot_dont_sub: 'ليس لديك اشتراكات سابقة.',
    sharebot_prev_sub: 'مشترك سابقاً',
    sharebot_sub: 'اشتراك ShareBot',
    sharebot_un_sub: 'إلغاء اشتراك ShareBot',
    sharebot_no_available: 'لا يوجد وصف متاح',
    sharebot_start_date: 'تاريخ البدء:',
    sharebot_end_date: 'تاريخ الانتهاء:',
    sharebot_sure: 'هل أنت متأكد؟',
    sharebot_do_you_want: 'هل ترغب في',
    unsubscribe: 'إلغاء الاشتراك',
    unsubscribe_what: 'إلغاء الاشتراك؟',
    subscribe: 'اشترك',
    subscribe_what: 'اشترك؟',
    subscribe_now: 'اشترك الآن',
    confirm: 'تأكيد',
    sharebot_intel_knowledge_center: 'مركز المعرفة الذكي لذكاء ShareBot',
    sharebot_welcome_paragraph:
      'مرحباً بك في مركز معرفة ShareBot، روبوت المحادثة الذكي المتطور الذي يغير طريقة وصول المهنيين إلى المعلومات والتعاون.',
    expired: 'منتهي الصلاحية',
    active: 'نشط',
    Inactive: 'غير نشط',
    yearly_subscription: 'اشتراك سنوي',
    monthly_subscription: 'اشتراك شهري',
    no_sharebot_org: 'ليس لديك منظمة ShareBot',
    sharebot_start_free_trial: 'ابدأ التجربة المجانية',
    sub_month: 'اشتراك شهري',
    sub_year: 'اشتراك سنوي',
    question_per_month: 'تخزين البيانات (1 تيرابايت) و1000 سؤال شهرياً',
    sharebot_para:
      'بالمتابعة، أنت تؤكد حذف المنظمة فوراً. هذا يؤدي إلى فقدان جميع الرؤى القيمة من ShareBot ولا يمكن التراجع عنه.',
    cancelled_date: 'تاريخ الإلغاء:',
    live_straming_para:
      'إذا رغبت في تغيير حد البث المباشر الشهري، يرجى الاتصال بـ',
    sharelook_agree: 'أوافق على شروط Sharelook',
    terms_condition: 'الشروط والأحكام',
    and: 'و',
    privacy_policy: 'سياسة الخصوصية',
    save_for_later: 'احفظ للرجوع لاحقاً',
    ai: 'الذكاء الاصطناعي',
    no_video_yet: 'لم يتم اختيار أي فيديو حتى الآن!',
    are_you_sure_delete_video: 'هل أنت متأكد من حذف هذا الفيديو؟',
    video_des: 'الوصف',
    video_now: 'الآن',
    video_playing: 'جارٍ التشغيل:',
    video_no: 'رقم الفيديو.',
    ai_generated_course: 'دورة تم إنشاؤها بواسطة الذكاء الاصطناعي',
    create_course_on_our_own: 'إنشاء دورة بنفسك',
    ai_Assisted_ourse_reation: 'إنشاء دورة بمساعدة الذكاء الاصطناعي',
    pending: 'قيد الانتظار',
    published: 'منشور',
    intro_course: 'إلى دورتك؟',
    clone_course: 'هل ترغب في استنساخ',
    browser_audio_not_support: 'متصفحك لا يدعم عنصر الصوت.',
    audio_popup_content:
      'حيث يمكنك استخدام أنماط صوتية عديدة على النص الذي تكتبه... (قسْ نص الإنذار)...',
    close: 'إغلاق',
    podcast_rec: 'تسجيل',
    create_podcast: 'إنشاء بودكاست',
    add_admin: 'أضف مشرف',
    delete_all: 'حذف الكل',
    ai_podcast_audio: 'صوت بودكاست AI',
    language: 'اللغة',
    podcast_download_content:
      '*قم بتنزيل ملف الصوت AI للتعديل ليصبح ملفك الصوتي.',
    upload_audio: 'تحميل الصوت',
    browser_do_not_support_audio: 'متصفحك لا يدعم عنصر الصوت.',
    upload_cover: 'تحميل الغلاف',
    upload_ai_creator: 'منشئ AI',
    required_cover_image: 'صورة الغلاف مطلوبة!',
    room_required_name: 'اسم البث مطلوب!',
    add_guest_list: 'يرجى إضافة قائمة الضيوف!',
    podcast_add_participants: 'أضف مشارك',
    topic_required: 'الموضوع مطلوب على الأقل',
    podcast_description: 'الوصف',
    podcast_date: 'التاريخ',
    date: 'التاريخ',
    podcast_time: 'الوقت',
    podcast_to: 'إلى',
    podcast_all_day: 'طوال اليوم',
    podcast_start_date_time: 'مطلوب تاريخ بدء ووقت للبودكاست!',
    podcast_id: 'المعرّف',
    selected_user: 'دعوة المستخدمين المحددين',
    see_more: 'عرض المزيد',
    see_less: 'عرض أقل',
    no_review_yet: 'لا توجد مراجعات بعد، كن أول من يكتب مراجعة.',
    request_to_speak: 'قبول طلب المستخدم للتحدث؟',
    kick_user: 'هل تود طرد هذا المستخدم؟',
    accept_request: 'قبول الطلب',
    kick: 'طرد',
    started: 'بدأ',
    end: 'انتهاء',
    join_now: 'انضم الآن',
    podcast_end: 'انتهى البودكاست',
    connecting: 'جارٍ الاتصال...',
    knowledge_center_know_today: 'ماذا ترغب بمعرفته اليوم؟',
    knowledge_center_question: 'يرجى إدخال سؤال أولاً',
    knowledge_center_error: 'عذرًا! واجهنا خطأ ما.',
    knowledge_center_tooltrip:
      'احصل على إجابات سريعة من مصادر التعلم في مستودع مؤسستك على ShareLook، مع مراجع وإمكانية معاينة وتنزيل ملفات PDF.',
    my_organization: 'منظمتي',
    world_knowledge: 'معرفة العالم',
    open_file: 'فتح الملف',
    reference: 'مرجع',
    are_you_cancel: 'هل أنت متأكد أنك تريد الإلغاء؟',
    are_you_remove_media: 'هل أنت متأكد أنك تريد إزالة الوسائط؟',
    terms_agree: 'أوافق على هذه',
    ready: 'جاهز',
    send_email: 'إرسال بريد إلكتروني',
    active_users: 'المستخدمون النشطون',
    sign_up_user: 'المستخدمون المسجلون',
    non_sign_up_user: 'مستخدمون غير مسجلين',
    organisation: 'المؤسسة',
    usage_report: 'تقرير الاستخدام',
    check_email: 'تحقق من بريدك الإلكتروني',
    delete_schedule: 'حذف الجدول',
    are_you_sure_delete_schedule: 'هل أنت متأكد من حذف هذا الجدول؟',
    add_task: 'يرجى إدخال مهمة!',
    coaching_available: 'تمييز كموعد تدريب متاح',
    message_booking_coaching: 'تم حجز هذا الوقت من قبل مستخدم للتدريب.',
    task_day: 'يوم المهمة',
    created_task_day: 'لقد أنشأت مهمة لهذا اليوم.',
    event_day: 'يوم الفعالية',
    has_booked_coaching: 'تم حجز تدريب لهذا اليوم.',
    active_day: 'اليوم النشط',
    selectable_time_slots:
      'الفترات الزمنية القابلة للاختيار على اليمين متاحة لهذا اليوم.',
    compare_last_month: 'مقارنة بالشهر الماضي',
    uploading_file: 'جارٍ رفع ملفك',
    attach_file_course: 'مرفق لهذه الدورة.',
    fetch_request: 'جارٍ استرجاع طلبك',
    finilize_upload: 'جارٍ إنهاء الرفع',
    scorm_scanned: 'يرجى الانتظار... ملف SCORM الذي رفعته يتم فحصه.',
    scan_status: 'حالة الفحص:',
    scan_completed: 'اكتمل الفحص. ملفك هو',
    scan_progress: 'جارٍ الفحص...',
    check_scorm: 'جارٍ التحقق من تنسيق ملف SCORM... يرجى الانتظار...',
    file_check_success: 'تم التحقق من الملف بنجاح',
    file_check_progress: 'جارٍ التحقق من الملف...',
    scorm_not_upload:
      'الملف المرفوع ليس وفق معيار SCORM 1.2، يرجى رفعه مرة أخرى.',
    select_question: 'خيارات الإجابة (اختر إجابة صحيحة واحدة)',
    select_answer: 'يرجى اختيار خيار الإجابة!',
    check_option_one: 'يرجى إدخال الخيار الأول!',
    check_option_two: 'يرجى إدخال الخيار الثاني!',
    check_option_three: 'يرجى إدخال الخيار الثالث!',
    check_option_four: 'يرجى إدخال الخيار الرابع!',
    question_image: 'صورة السؤال',
    select_question_image: 'يرجى اختيار صورة للسؤال!',
    ans_image: 'صورة الإجابة',
    upload_image_question: 'تحميل صورة الإجابة',
    select_image_answer: 'يرجى اختيار صورة للإجابة!',
    save_question: 'حفظ السؤال',
    do_you_leave: 'هل أنت متأكد أنك تريد المغادرة؟',
    loose_all_progress: 'ستخسر كل تقدمك.',
    welcome: 'مرحبًا',
    team_knowledge_quest: 'رحلة معرفة الفريق',
    your_score: 'درجتك',
    start_playing: 'ابدأ اللعب',
    share_sphere_complete: 'تم إكمال ShareSphere',
    final_score: 'النتيجة النهائية',
    play_next: 'العب التالي',
    you_donot_access_event: 'ليس لديك إذن لهذا الحدث.',
    ai_content_generated: 'تم إنشاء المحتوى لهذا الموضوع.',
    ai_popup_confirm_content: 'تأكيد إنشاء المحتوى',
    limit_transcribe_text:
      'الدقائق المتبقية للنسخ: <0>{{ transcribe_limit }}</0> دقيقة <1/><2/> <3>. لتغيير حد النسخ، يرجى الاتصال بـ </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'ليس لديك صلاحية الوصول إلى هذا الحدث.',
    ai_course_title_training: 'دورات تدريبية في القيادة',
    ai_course_object: 'التنقل في القيادة في العصر الرقمي',
    create_ai_video: 'إنشاء فيديو بالذكاء الاصطناعي',
    generate: 'إنشاء',
    video_generate_process:
      'قد تستغرق عملية إنشاء الفيديو بعض الوقت. سيتم إعلامك عبر البريد الإلكتروني عند الانتهاء.',
    stripe_account_connect:
      'حساب Stripe الخاص بك غير نشط. يرجى توصيله أو تفعيله للمتابعة.',
    ai_creator: 'منشئ الذكاء الاصطناعي',
    check_video_status: 'جارٍ التحقق من حالة إنشاء الفيديو...',
    video_on_queue: 'تمت إضافة الفيديو إلى قائمة الانتظار.',
    video_fail_generation: 'عذرًا، فشل إنشاء الفيديو. يرجى المحاولة مرة أخرى.',
    video_currently_generated: 'هذا الفيديو قيد الإنشاء حاليًا.',
    checking_status: 'جارٍ التحقق من الحالة',
    check_status: 'تحقق من الحالة',
    browser_does_not_support_audio: 'متصفحك لا يدعم وسم الصوت',
    existing_edit_scenario:
      'هل تريد تعديل السيناريو الحالي أم إنشاء سيناريو جديد؟ إذا اخترت إنشاء سيناريو جديد، فستفقد السيناريو القديم.',
    generate_scenario: 'إنشاء سيناريو',
    layout: 'التخطيط',
    confirm_change: 'تأكيد التغيير',
    generated_ai_creation_message:
      'يرجى ملاحظة أنه سيتم الاحتفاظ فقط بالعناصر النصية التي تم إنشاؤها من خلال الذكاء الاصطناعي. سيتم حذف جميع العناصر الأخرى من الصفحة.',
    generate_story: 'إنشاء قصة',
    save_original_content: 'حفظ المحتوى الأصلي:',
    story_added_specified_position:
      'موضع القصة في الدرس. ستُضاف القصة ككتلة في الموضع المحدد.',
    position_of_story: 'موضع القصة',
    start_the_lesson: 'بداية الدرس',
    end_the_lesson: 'نهاية الدرس',
    add_story_pages: 'إضافة القصة إلى الصفحات',
    browser_does_not_support: 'متصفحك لا يدعم عنصر الصوت.',
    no_video_available: 'لا توجد مقاطع فيديو متاحة.',
    no_podcast_available: 'لا توجد ملفات بودكاست متاحة.',
    no_item_baskets: 'لا توجد عناصر في السلة.',
    ai_course_object: 'التنقل في القيادة في العصر الرقمي'
  },

  v2: {
    n_data: 'لا توجد بيانات',
    change: 'تغيير',
    remove: 'إزالة',
    auto_background: 'خلفية تلقائية',
    create_new_course_org: 'إنشاء دورة جديدة لمؤسستك.',
    create_new_course_marketplace: 'إنشاء دورة جديدة للسوق.',
    create_new_course_both: 'إنشاء دورة جديدة لكل من المؤسسة والسوق.',
    ok: 'موافق',
    page_bg: 'خلفية الصفحة',
    lesson_cover: 'صورة غلاف الدروس',
    create_skill_journey: 'إنشاء رحلة مهارية',
    Metamaze: 'ميتاماير',
    events: 'الفعاليات',
    scroms: 'SCORMs',
    min_score_pass: 'الدرجة الدنيا للنجاح',
    no_scorms_available: 'لا توجد SCORMs متاحة.',
    no_events_available: 'لا توجد فعاليات متاحة.',
    no_courses_available: 'لا توجد دورات متاحة.',
    no_courses_baskets: 'لا توجد دورات في السلة.',
    no_mazes_baskets: 'لا توجد متاهات في السلة.',
    no_scroms_baskets: 'لا توجد SCORMs في السلة.',
    no_events_baskets: 'لا توجد فعاليات في السلة.',
    sorry: 'عذرًا!',
    option_1: 'الخيار 1',
    option_2: 'الخيار 2',
    enter_number_words: 'أدخل الحد الأقصى لعدد الكلمات.',
    summarize: 'تلخيص',
    answer: 'إجابة',
    hold_tight_one_minute: 'انتظر لحظة! ما زلنا نجهز. قد يستغرق ذلك دقيقة.',
    enter_question: 'أدخل سؤالك.',
    enter_relevant_documents: 'أدخل عدد المستندات ذات الصلة.',
    please_input_relevant_documents: 'يرجى إدخال عدد المستندات ذات الصلة!',
    please_wait_loading_results: 'يرجى الانتظار حتى يتم تحميل النتائج...',
    proceed_to_add_voice: 'تابع لإضافة الصوت',
    results: 'النتائج',
    no_result_found_try_asking_questions:
      'لم يتم العثور على نتائج. حاول طرح المزيد من الأسئلة.',
    eg: 'مثال،',
    what_make_sales_manager: 'ما الذي يجعلني مدير مبيعات؟',
    please_select_lang: 'يرجى اختيار لغة!',
    search: 'بحث',
    please_copy_desired_content:
      'يرجى نسخ المحتوى المطلوب من المربع الأيسر إلى الأيمن.',
    rating_req: 'التقييم حقل مطلوب.',
    review_req: 'المراجعة حقل مطلوب.',
    rating_review_req: 'يجب تقديم التقييم والمراجعة معًا.',
    how_rate_this: 'كيف تقيّم هذا؟',
    amazing_above_expectations: 'رائع! فوق التوقعات!',
    certificates: 'الشهادات',
    you_no_certificates: 'ليس لديك أي شهادات متاحة حاليًا.',
    please_add_review: 'يرجى تقديم مراجعة مع التقييم، شكرًا!',
    post: 'نشر',
    rate: 'تقييم',
    avg_rating: 'متوسط التقييم',
    no_review_found: 'لم يتم العثور على مراجعة',
    are_sure_to_disale_zoom_integration:
      'هل أنت متأكد من أنك تريد تعطيل تكامل Zoom؟',
    badges: 'شارات',
    you_no_badge_available: 'ليس لديك شارات متاحة حاليًا.',
    download_certificate: 'تحميل الشهادة',
    loading: 'جارٍ التحميل...',
    no_file_attached: 'لا توجد ملفات مرفقة',
    you_do_not_have_any_notes: 'ليس لديك أي ملاحظات.',
    question: 'سؤال',
    score: 'الدرجة',
    alert_score_message: 'قام أشخاص بإرسال درجاتهم.',
    alert_question_message: 'لم تتم إضافة أي أسئلة حتى الآن.',
    button_submit: 'إرسال',
    button_allScores: 'تم إرسال جميع الدرجات.',
    record_wait: 'جارٍ بدء التسجيل. يرجى الانتظار...',
    buttonSubmit_warning: 'يرجى إدخال جميع الدرجات قبل الإرسال.',
    upload_ar_assets: 'تحميل أصول الواقع المعزز',
    edit_ar_assets: 'تعديل أصول الواقع المعزز',
    edit_maze_assets: 'تعديل أصول MetaMaze',
    upload_assets: 'تحميل الأصول',
    upload_maze_assets: 'تحميل أصول MetaMaze',
    trigger_title: 'عنوان المشغل',
    model_title: 'عنوان النموذج',
    trigger_description: 'وصف المشغل',
    model_description: 'وصف النموذج',
    please_type_target_description: 'يرجى كتابة وصف الهدف.',
    please_type_model_description: 'يرجى كتابة وصف النموذج.',
    trigger_image: 'صورة المشغل*',
    model_image: 'صورة النموذج*',
    upload_trigger_image: 'تحميل صورة المشغل',
    upload_model_image: 'تحميل صورة النموذج',
    drag_n_drop: 'السحب والإفلات',
    file_size_should_not_exceed: '(يجب ألا يتجاوز حجم صورة JPEG 512 كيلوبايت)',
    zip_size_should_not_exceed: '(يجب ألا يتجاوز حجم ملف ZIP 60 ميغابايت)',
    ar_content: 'محتوى الواقع المعزز*',
    model_content: 'النموذج ثلاثي الأبعاد*',
    upload_3d_zip: 'تحميل ملف ZIP / فيديو',
    upload_3d_maze_zip: 'تحميل ملف ZIP',
    audio_content: 'محتوى الصوت',
    _mp3: '(.mp3)',
    content_attached: 'تم إرفاق ملف ZIP.',
    video_attached: 'تم إرفاق الفيديو.',
    audio_attached: 'تم إرفاق الصوت.',
    enter_trigger_image_title: 'أدخل عنوان صورة المشغل.',
    enter_model_title: 'أدخل عنوان نموذج MetaMaze.',
    ar_preview_image: 'صورة معاينة الواقع المعزز',
    upload_preview_image: 'تحميل صورة المعاينة',
    upload_audio: 'تحميل الصوت',
    creating___: 'جارٍ الإنشاء...',
    updating___: 'جارٍ التحديث...',
    create: 'إنشاء',
    update: 'تحديث',
    ar_assets: 'صورة ثلاثية الأبعاد',
    _3d_files_mp4: '(ملفات مضغوطة .obj، .fbx أو فيديو .mp4)',
    _3d_files_mp4_ar: '(ملفات مضغوطة .obj، .fbx)',
    maze_3d_files_mp4: '(ملفات مضغوطة .obj، .fbx)',
    _jpg_files: 'يدعم فقط .jpg',
    persons_have_submitted_their_scores: 'قام شخص/أشخاص بإرسال درجاتهم.',
    no_questions_added_till_now: 'لم تتم إضافة أي أسئلة حتى الآن.',
    submit: 'إرسال',
    all_scores_submitted: 'تم إرسال جميع الدرجات.',
    recording_is_starting: 'جارٍ بدء التسجيل. الرجاء الانتظار...',
    please_input_scores_before_submitting:
      'يرجى إدخال جميع الدرجات قبل الإرسال.',
    end_for_all: 'إنهاء للجميع',
    full_screen: 'ملء الشاشة',
    breakout_room: 'غرفة فرعية',
    send_invitations: 'إرسال الدعوات',
    add_participants: 'إضافة المشاركين',
    create_breakout_room: 'إنشاء غرفة فرعية',
    connecting: 'جارٍ الاتصال...',
    currently_broadcaster_unavailable: 'المذيع غير متوفر حالياً.',
    how_many_breakout_room_to_create: 'كم عدد الغرف الفرعية التي تريد إنشاؤها؟',
    create_upto_three_breakout_rooms: '*إنشاء حتى 3 غرف فرعية',
    allow: 'السماح',
    additional: 'إضافي',
    attachment: 'مرفقات',
    no_description_available: 'لا يوجد وصف متاح.',
    people: 'الأشخاص',
    waiting: 'بانتظار',
    hand_raising_users: 'المستخدمون الذين يرفعون أيديهم',
    invite: 'دعوة',
    create_room: 'إنشاء غرفة',
    create_live_event: 'إنشاء حدث مباشر',
    support_upto_fivethousand_participants: 'يدعم حتى 5000 مشارك في الحدث',
    support_upto_ten_participants: 'يدعم حتى 10 مشاركين في الفيديو المباشر',
    support_upto_twohundred_participants: 'يدعم حتى 200 مشارك في الحدث',
    supprt_upto_five_participants: 'يدعم حتى 5 مشاركين في الفيديو المباشر',
    support_upto_twentyfive_participants:
      'يدعم حتى 25 مشاركاً في الحدث المباشر',
    two_live_video_participants:
      'يوجد مشاركان في الفيديو المباشر (المضيف والحضور)',
    you_can_have_upto_five_examinees: 'يمكنك أن تملك حتى 5 ممتحنين فقط.',
    you_can_have_upto_twentyfive_participants:
      'يمكنك أن تملك حتى 25 مشاركاً فقط.',
    you_can_have_upto_five_participants: 'يمكنك أن تملك حتى 5 مشاركين فقط.',
    you_can_have_upto_ten_participants: 'يمكنك أن تملك حتى 10 مشاركين فقط.',
    select_hosts_email: 'اختر بريد المضيف الإلكتروني',
    send_invite_email: 'إرسال دعوة عبر البريد',
    do_not_send_invite_email: 'لا ترسل دعوة عبر البريد',
    error: 'خطأ',
    max_twentyfive_users_allowed: 'الحد الأقصى المسموح 25 مستخدمًا',
    max_five_users_allowed: 'الحد الأقصى المسموح 5 مستخدمين',
    max_ten_users_allowed: 'الحد الأقصى المسموح 10 مستخدمين',
    no_user_found: 'لم يتم العثور على مستخدم',
    transcribe_to: 'نسخ إلى',
    integrate_zoom_to_start_meeting: 'قم بدمج Zoom في حسابك لبدء الاجتماع.',
    zoom_is_not_integrated: 'لم يتم دمج Zoom.',
    delete_poll: 'حذف الاستطلاع',
    add_poll: 'إضافة استطلاع',
    live_now: 'مباشر الآن!',
    average_rating: 'متوسط التقييم',
    review: 'مراجعة',
    time_spent: 'الوقت المستغرق',
    total: 'الإجمالي',
    mins: 'دقائق',
    no_data: 'لا توجد بيانات لهذا الاختبار.',
    total_score: 'إجمالي النقاط',
    pass_score: 'نقاط النجاح',
    point: 'نقطة',
    wrong: 'خطأ',
    response: 'إجابة',
    submitted: 'تم الإرسال',
    average: 'المتوسط',
    total_play: 'إجمالي التشغيل',
    view_graph: 'عرض الرسم البياني',
    time_spent_mins: 'الوقت المستغرق (دقائق)',
    play: 'تشغيل',
    ideal_path: 'المسار المثالي',
    user_incorrect_path: 'المسار غير الصحيح للمستخدم',
    ideal_path_taken: 'المسار المثالي الذي اتبعه المستخدم',
    scenario: 'سيناريو',
    option: 'خيار',
    spend: 'الوقت المنقضي',
    average_spending_time: 'متوسط وقت الإنفاق',
    activity_overview: 'نظرة عامة على النشاط',
    live_event: 'حدث مباشر',
    live_assessment: 'تقييم مباشر',
    report_download: 'تحميل التقرير',
    all_workshops: 'جميع الورش',
    overview_average_activity: 'متوسط نظرة عامة على النشاط',
    overview_workshop_graph: 'رسم بياني لنظرة عامة على الورش',
    mazes: 'متاهات',
    correct_feedback: 'تغذية راجعة صحيحة',
    incorrect_feedback: 'تغذية راجعة غير صحيحة',
    checkin_checkout: 'تسجيل الدخول - تسجيل الخروج',
    minutes: 'دقائق',
    incorrect_path: 'مسار غير صحيح',
    answer_not_available: 'الإجابة غير متاحة',
    views: 'المشاهدات',
    item: 'عنصر',
    questions: 'الأسئلة',
    total_points: 'إجمالي النقاط',
    total_attempts: 'إجمالي المحاولات',
    created_date: 'تاريخ الإنشاء',
    host_name: 'اسم المضيف',
    host_section: 'قسم المضيف',
    choose_products: 'اختر المنتجات',
    add_to_basket: 'أضف إلى السلة',
    basket: 'السلة',
    times: 'مرات',
    scorms: 'SCORMs',
    skill_journey_overview: 'نظرة عامة على رحلة المهارة',
    how_to_use: 'كيفية الاستخدام',
    live_broadcast_description:
      'لقد دمجنا الفيديو المباشر في منشئ الدورات سهل الاستخدام',
    live_broadcast_subdescription:
      'من خلال نظام البث المباشر الحاصل على براءة اختراع من ShareLook، يمكنك إنشاء تفاعل، وأتمتة التعلم، وتعظيم مشاركة المعرفة.',
    disclaimer: `أقر بأن رحلة المهارة الخاصة بي لن:
    - تنتهك حقوق أي طرف ثالث
    - تحتوي على أي شيء غير قانوني، بما في ذلك التشهير، أو الفاحش، أو غير اللائق، أو البذيء، أو الإباحي، أو العنيف، أو المسيء، أو المهين، أو التهديدي، أو التمييزي، حتى لو تم تمويهه باستخدام نجوم (*)
    - تحتوي على أي هجمات شخصية ضد أشخاص آخرين
    - تحتوي على انتحال شخصية للمشاركين الآخرين أو الشخصيات العامة أو المشاهير
    - تحتوي على أي تسجيل أو معلومات شخصية لأي فرد دون موافقة ذلك الفرد أو تنتهك أي قوانين لحماية البيانات
    - تحتوي على أي ترويج تجاري أو أي شكل من أشكال "البريد العشوائي"`,
    price: 'السعر',
    video_link: 'رابط الفيديو',
    category: 'الفئة',
    objectives: 'الأهداف',
    marketplace_description: 'وصف السوق',
    live_discussion: 'نقاش مباشر',
    poll: 'استطلاع',
    hide_grid: 'إخفاء الشبكة',
    show_grid: 'إظهار الشبكة',
    stop_screen_share: 'إيقاف مشاركة الشاشة',
    screen_share: 'مشاركة الشاشة',
    mute: 'كتم',
    unmute: 'إلغاء الكتم',
    raise_hand: 'رفع اليد',
    waiting__: 'بانتظار...',
    audio_active: 'الصوت مفعل'
  },

  general: {
    save: 'حفظ',
    autosaved: ' محفوظ تلقائيًا ',
    back_to: 'العودة إلى',
    by: 'بواسطة',
    chat: 'دردشة',
    completed: 'مكتمل',
    canceled: 'ملغي',
    component: 'مكون',
    confirm: 'تأكيد',
    course: 'دورة',
    skill: 'رحلة المهارة',
    maze: 'المتاهة الفوقية',
    channel: 'القناة',
    podcast: 'Podcast',
    date: 'تاريخ',
    details: 'تفاصيل',
    empty: 'لا توجد بيانات,',
    enrolled: 'المقيدين',
    free: 'مجانا',
    graph: ' رسم بياني',
    loading: ' جاري التحميل...',
    lesson: ':درس',
    lessons: 'دروس',
    live_assessment: 'تقييم مباشر',
    live_event: 'فعالية مباشر',
    no: 'لا',
    of: 'من',
    or: 'بدلا من',
    organization: 'منظمة',
    page: 'صفحة',
    pages: 'صفحات',
    personal: 'شخصي',
    poll: 'تصويت',
    rating: 'تقييم',
    reset: 'إعادة تعيين',
    signin: 'تسجيل الدخول',
    signup: 'الاشتراك  تسجيل',
    soon: 'قريبا',
    type: 'نوع',
    uploading: ': جارٍ التحميل ... ',
    yes: 'نعم',
    something_went_wrong: 'هناك خطأ ما!',
    view_all: 'عرض الكل',
    upload_successful: 'تحميل ناجح',
    upload_successful_message:
      '"تم تحميل مستندات excel بنجاح وهي قيد المعالجة حاليًا. هذا قد يستغرق بعض الوقت.',
    check_email_upload_successful:
      'الرجاء <0> التحقق من بريدك الإلكتروني </0> للحصول على <1> تقرير </ 1> لقائمة المستخدمين التي تم تحميلها.',
    is_private: 'خاص',
    to_attach: 'أرفق ملف',
    file_attached: 'ملف مرفق'
  },

  account: {
    title: 'الحساب',
    subtitle: 'إدارة إعداداتك ومعلومات حسابك.',
    saved: 'تم تغيير الحساب بنجاح'
  },

  assessments: {
    title: 'التقييمات',
    subtitle: 'إنشاء تقييم',
    finished: 'التقييم انتهى',
    countdown: 'سيتم بث التقييم المباشر في خلال',
    create: 'إنشاء التقييم',
    list_title: 'تقييماتك',
    delete_warning: 'هل أنت متأكد أنك تريد حذف هذا البند؟',
    details_title: 'إضافة تفاصيل التقييم',
    details_subtitle:
      'قم بتسمية تقييمك وأخبر جمهورك بما يجب عليهم توقعه للتعلم منه.',
    disclaimer: `أتعهد بأن تقييمي المسجل لن: '
     - ينتهك حقوق أي طرف ثالث
     - يحتوي على أي عدم شرعية ، بما في ذلك المحتوى التشهيري أو الفاحش أو غير اللائق أو الفاحش أو الإباحية أو العنيفة أو المسيئة أو المهينة أو التهديدية أو التمييزية ، حتى المخفاة بعلامات النجمة
     - يحتوي على أي اعتداءات شخصية على أشخاص آخرين
     - يحتوي على أي انتحال صفة لمشاركين آخرين أو شخصيات عامة أو مشاهير
     - يحتوي على أي تسجيل أو معلومات شخصية عن أي فرد دون موافقة هذا الفرد ولا ينتهك أي لائحة لحماية البيانات في أي جزء من العالم
     - يحتوي على أي دعوة تجارية أو أي شكل من أشكال "البريد العشوائي",`,

    assessment_details: 'تفاصيل التقييم',
    assessment_settings: 'إعدادات التقييم'
  },

  buildersettings: {
    title: 'نشر الإعدادات',
    subtitle:
      'إضافة إعدادات إلى الفعالية الخاص بك ، من الذي يمكنه مشاهدة الفعالية الخاص بك والتفاعل معه'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'إضافة',
    add_page: 'إضافة صفحة',
    add_lesson: 'إضافة دروس',
    add_answer: 'إضافة إجابات جديدة',
    add_group: 'إضافة مجموعة',
    add_organization: 'إضافة منظمة',
    add_question: 'إضافة سؤال',
    add_quiz: ' إضافة اختبار',
    add_users: 'إضافة مستخدمين',
    back: 'العودة',
    back_to_course: 'العودة إلى نظرة عامة على الدورة التدريبية',
    // back_to_lesson: العودة إلى نظرة عامة على الدروس,
    back_to_media: 'العودة إلى مكتبة الوسائط',
    back_to_details: 'العودة إلى التفاصيل',
    cancel: 'إلغاء',
    clear: ' مسح ',
    close: 'إغلاق',
    clone: 'نسخ',
    close_lesson: 'إغلاق الدرس',
    clone_course: 'نسخ الدورة',
    confirm: 'تأكيد',
    create: 'إنشاء',
    download: `تحميل,`,
    download_mass_user_tamplate: 'تحميل القالب',
    add_mass_users: 'إضافة مستخدمين جماعيين ',
    upload_excel_list: 'تحميل قائمة Excel',
    delete: 'حذف الوسائط',
    edit: 'تحرير',
    edit_course: ' تحرير الدورة',
    enroll: 'تسجيل',
    finish: 'إنهاء',
    upload_image: 'تحميل الصور',
    upload_image_video: 'تحميل صورة أو فيديو',
    select_media_library: 'حدد مكتبة الوسائط',
    make_public: 'اجعله عاماً',
    make_private: 'اجعله خاصًا',
    make_org: 'اصنع منظمة',
    media: 'مكتبة الوسائط',
    my_theme: ' نمطي',
    next: 'التالى',
    next_lesson: 'الدرس التالي',
    next_step: 'الخطوة التالية',
    previous_step: ' الخطوة السابقة',
    publish: ' نشر',
    publish_assessment: 'نشر تقييمك',
    publish_course: 'نشر دورتك',
    publish_event: 'نشر فعالية',
    reset: 'إعادة تعيين',
    reset_elements: 'إعادة تعيين العناصر',
    save: ' حفظ',
    creating: ' إنشاء...',
    updating: ' تحديث...',
    saved: ' تم الحفظ',
    save_for_later: 'احفظ لوقت لاحق',
    save_settings: 'احفظ التغييرات',
    select_files: 'اختر الملفات',
    select_theme: 'اختر نمطا',
    start_lesson: 'بدء الدرس',
    update: 'تحديث',
    upload: ' تحميل ',
    upload_audio: 'تحميل الصوت',
    upload_photo: 'تحميل صورة ملف شخصي',
    upload_video: 'تحميل الفيديو',
    enrolled: 'المقيدين',
    unenroll: 'إلغاء التسجيل',
    from_library: 'مكتبة الوسائط',
    remove: ' إزالة',
    removed: 'تمت الإزالة',
    start_broadcast: 'بدء البث',
    end_broadcast: 'إنهاء البث',
    camera: 'الة تصوير',
    screen: 'عرض على الشاشة ',
    screen_with_camera: ' التصوير بواسطة كاميرا',

    insert: 'إدخال',
    inserting: 'إدخال',
    upload_pdf: 'تحميل ملف PDF',

    portrait: 'صورة',
    landscape: 'المناظر الطبيعيه'
  },

  card: {
    quick_add: 'إضافة سريعة',
    add: 'إضافة,',
    clone: 'نسخ',
    completed: 'الدروس أكتملت'
  },

  course: {
    upcoming_course: 'الدورة القادمة',
    unPublishEvent: ' عدم نشر الفعالية',
    unPublishAssessment: 'عدم نشر التقييم ',
    pastCourse: 'دورة تدريبية',
    upcoming: 'فعالية مباشر قادم',
    pastEvent: 'فعالية مباشر فائت',
    pastAssessment: 'تقييم مباشر فائت',
    upcomingAssessment: 'تقييم مباشر قادم',
    created: 'تاريخ الإنشاء:',
    assignees: ' المعهود إليه, ',
    organisations: '{{المنظمات}} المؤسسات ، <2> {{users}} المستخدمين </2>',
    event_date: 'تاريخ الفعالية المباشر <1> {{date}} </1>',
    delete_warning: 'هل أنت متأكد أنك تريد حذف هذا',
    clonning_no_lesson: 'يرجى إضافة درس واحد على الأقل لاستنساخ هذه الدورة.',
    clone_warning: 'هل أنت متأكد أنك تريد استنساخ هذا',
    clone_success: 'في عملية استنساخ',
    disclaimer: `أضمن أن دورتي لا::
	•	تنتهك حقوق أي طرف ثالث
  - تحتوي على أي محتوى غير قانوني ، بما في ذلك المحتوى التشهيري أو الفاحش أو غير اللائق أو البذيء أو الإباحي أو العنيف أو المسيء أو المهين أو التهديد أو التمييزي ، حتى المقنع بعلامات النجمة
  - تحتوي على أي اعتداء شخصي على أشخاص آخرين
  - تحتوي على أي انتحال صفة لمشاركين آخرين أو شخصيات عامة أو مشاهير
  - تحتوي على أي معلومات شخصية عن أي فرد دون موافقة هذا الفرد ولا تنتهك أي لائحة لحماية البيانات في أي جزء من العالم
  - تحتوي على أي طلب تجاري أو أي شكل من أشكال "البريد العشوائي",`
  },

  coursecreate: {
    dropzone_text: 'إدراج الوسائط',
    sidebar_text: 'حدد نمطا <1 /> لـ <3 /> الدروس',
    delete_warning: ' هل أنت متأكد أنك تريد حذف هذا الدرس؟'
  },

  coursepage: {
    quizview_loading: ' التحقق من الإجابات. يرجى الانتظار...',
    quizview_answer: 'اجابتك'
  },

  coursequiz: {
    title: 'اختبارات في كل الدروس'
  },

  dashboard: {
    tooltip_title: 'لا تعرض هذا الفيديو مرة أخرى',
    // page_title: "الدورات الخاصة بك" الإحصاء ",
    page_subtitle: 'حالة الدورات التي أنشأتها',
    profile_add_info: 'أضف <1> {{نص غير مكتمل}} </1> لاستكمال ملفك الشخصي.',
    profile_build:
      'أنشئ ملفك الشخصي <1> هنا </1> ، وأخبرنا عن اهتماماتك ومهاراتك.',
    profile_title: 'قوة الملف الشخصي',
    more_details: 'المزيد من التفاصيل'
  },

  errors: {
    answer: 'الرجاء إدخال إجابة',
    answer_correct: 'اختر الاجابة الصحيحة',
    code: 'الرجاء إدخال الرمز الخاص بك',
    criterion: 'الرجاء إدخال المعيار',
    duration: 'المدة مطلوبة',
    element: 'الرجاء إدخال عنصر',
    email: 'الرجاء إدخال البريد الإلكتروني الخاص بك',
    email_invalid: 'المدخل ليس بريدًا إلكترونيًا صالحًا',
    feedback_correct: 'يرجى إدخال تعليقات صحيحة',
    feedback_incorrect: 'الرجاء إدخال تعليقات غير صحيحة',
    host: 'الرجاء إدخال مضيف الفعالية',
    host_assessment: 'الرجاء إدخال مضيف التقييم',
    image: 'يرجى تحميل صورة',
    location: 'الرجاء إدخال موقعك',
    live_location: 'الرجاء اختيار موقع البث',
    limit: 'يُرجى إدخال دقائق البث المباشر',
    min_3char: '3 أحرف كحد أدنى',
    number: 'الرجاء إدخال رقم موجب',
    host_email_require: 'رسائل البريد الإلكتروني للمضيف مطلوبة',
    attendee_email_require: 'رسائل البريد الإلكتروني للحضور مطلوبة ',
    name: 'الرجاء إدخال اسمك',
    not_found_course: 'لم يتم العثور على الدورة التدريبية',
    not_found_event: 'لم يتم العثور على الفعالية',
    not_found_assessment: 'لم يتم العثور على التقييم ',
    password: 'الرجاء إدخال كلمة المرور الخاصة بك',
    password_digit: 'رقم واحد على الأقل',
    password_short: 'كلمة المرور قصيرة جدًا ، الحد الأدنى 10 أحرف',
    password_special: 'حرف واحد مميز على الأقل',
    password_uppercase: 'حرف واحد كبير على الأقل',
    password_lowercase: 'حرف واحد صغير على الأقل',
    phone: 'الرجاء إدخال هاتفك',
    phone_invalid: 'رقم الهاتف غير صحيح',
    position: 'يرجى إدخال وظيفتك',
    question: 'الرجاء إدخال السؤال',
    start_date: 'تاريخ ووقت البدء مطلوبان',
    tag: 'يرجى تحديد علامة',
    topics: 'الرجاء تحديد موضوع واحد على الأقل.',
    live_topics: 'الرجاء إضافة مواضيع',
    title: 'الرجاء إدخال العنوان',
    title_assessment: 'الرجاء إدخال عنوان التقييم',
    title_course: 'الرجاء إدخال عنوان الدورة',
    title_empty: 'العنوان لا يمكن أن يكون فارغا',
    title_event: 'يرجى إدخال عنوان الفعالية',
    title_lesson: 'يرجى إدخال عنوان الدرس',
    title_quiz: 'يرجى إدخال عنوان الاختبار',
    username: 'الرجاء إدخال اسم المستخدم الخاص بك',
    upload_error: 'خطأ - الملف غير متوافق!',
    upload_more_than_10: 'يمكنك فقط تحميل 10 ملفات كحد أقصى في وقت واحد',
    topics_max: 'يرجى إضافة 3 مواضيع كحد أقصى',
    upload_excel: 'يرجى التأكد من تحميل الملف الصحيح',
    title_excel: 'خطأ في تحميل النموذج',
    file_size_exceed: 'حجم الملف يتجاوز',
    subtitle_excel:
      'يرجى التأكد من استخدام النموذج المقدم وملء الأعمدة بشكل صحيح',
    select_broadcast_option: 'يرجى تحديد خيار لبث هذا الفعالية',
    multi_hosts_number_error:
      'لا يمكن أن يتجاوز عدد المقدمين العدد المحدد للفعالية',
    conference_people_number_error:
      'لا يمكن أن يتجاوز عدد الحضور العدد المحدد للفعالية',
    select_max_host: 'حدد مقدمًا واحدًا على الأقل للفعالية',
    select_max_conference: 'حدد ضيفًا واحدًا على الأقل لهذا الفعالية',
    stream_stop_error: 'توقف البث بشكل غير متوقع!',
    unsecure_context:
      'خطأ فادح: لا يمكن للمستعرض الوصول إلى الكاميرا والميكروفون بسبب السياق غير الآمن. يرجى تثبيت SSL والوصول عبر https ',
    ws_not_supported: 'خطأ فادح: WebSocket غير مدعوم في هذا المستعرض',

    no_org: 'حدد مؤسسة واحدة على الأقل للمتابعة. ',
    no_org_group: 'حدد مجموعة تنظيمية واحدة على الأقل للمتابعة.',
    waiting_to_join: 'في انتظار شخص ما للانضمام!',
    select_transcribe_locale: 'حدد اللغة المراد نسخها',
    transcribe_limit: 'الرجاء إدخال نسخ دقيقة',
    monthly_transcribe: 'حد الكتابة الشهري:'
  },

  events: {
    title: 'إضافة تفاصيل الفعالية المباشر',
    change_host: 'تغيير المضيف',
    finished: 'انتهى الفعالية',
    countdown: 'سيتم بث الفعالية المباشر في',
    subtitle:
      'قم بتسمية فعاليةك المباشر وأخبر جمهورك بما يجب عليهم توقعه للتعلم منه',
    poll_disabled: 'الاستطلاع غير متوفر في هذا الفعالية',
    disclaimer: `أتعهد بأن فعاليةي المسجل لن'
     - ينتهك حقوق أي طرف ثالث
     - يحتوي على أي محتوى غير قانوني ، بما في ذلك المحتوى التشهيري أو الفاحش أو غير اللائق أو البذيء أو الإباحي أو العنيف أو المسيء أو المهين أو التهديد أو التمييزي ، حتى المقنع بعلامات النجمة
     - يحتوي على أي اعتداء شخصي على أشخاص آخرين
     - يحتوي على أي انتحال صفة لمشاركين آخرين أو شخصيات عامة أو مشاهير
     - يحتوي على أي تسجيل أو معلومات شخصية عن أي فرد دون موافقة هذا الفرد ولا تنتهك أي لائحة لحماية البيانات في أي جزء من العالم
     - يحتوي على أي التماس تجاري أو أي شكل من أشكال "البريد المزعج "،`,
    prompt_message:
      ', ستؤدي مغادرة هذه الصفحة إلى إنهاء الفعالية. هل أنت متأكد من مغادرة هذه الصفحة؟',
    duration_exceed_message: 'تجاوز وقت البث لديك ، سيتوقف التطبيق عن البث',
    before_schedule_message:
      'أنت على وشك بدء البث قبل وقت الفعالية المجدول. يرجى ملاحظة أن إيقاف البث سينهي الفعالية ',
    browser_unsupportive_message:
      'متصفحك لا يدعم مشاركة الشاشة. يمكنك مشاهدة المتصفحات المدعومة في هذا الرابط',
    cancel_switch_host_message: 'المضيف غير متوفر. سيستمر الفعالية من نهايتك',
    coaching_prompt_message: 'لا يمكنك مغادرة هذه الصفحة حتى انتهاء الفعالية.',
    event_modal_warn: 'هل تريد مغادرة هذا الفعالية؟',
    event_end_warn: 'هل تريد إنهاء هذا الحدث؟',
    event_breakout_leave: 'هل تريد مغادرة غرفة الاجتماعات الفرعية هذه؟',
    event_breakout_end: 'هل تريد إنهاء غرفة الاجتماعات الفرعية هذه؟',
    confirm_message: 'سينتهي الحدث الخاص بك إذا نقرت على موافق.',
    screen_share_denied: 'لقد رفضت مشاركة شاشتك.',
    media_not_found:
      'الكاميرا أو الميكروفون غير موجودان أو غير مسموح بهما في جهازك',
    media_not_access:
      'يتم استخدام الكاميرا أو الميكروفون من قبل عملية أخرى لا تسمح بقراءة الأجهزة',
    constraint_error: `  لم يتم العثور على جهاز يناسب قيود الفيديو والصوت. يمكنك تغيير قيود الفيديو والصوت, `,
    media_access_denied: 'غير مسموح لك بالوصول إلى الكاميرا والميكروفون'
  },

  filters: {
    days7: 'اخر 7 ايام',
    days15: 'اخر 15 يوم',
    days30: ` 'اخر 30 يوم, `,
    days365: 'آخر 365 يومًا',
    date: 'تاريخ الإنشاء',
    relevance: 'ملاءمة',
    popularity: 'شعبية',
    name: 'اسم',
    group: 'مجموعة',
    Newest_to_Oldest: 'من الأفعالية إلى الأقدم ',
    Oldest_to_Newest: 'من الأقدم إلى الأفعالية',
    A_Z: 'أ إلى ي',
    Z_A: 'ي إلى أ'
  },

  helpers: {
    password: ` ,"لضمان أمان حسابك ، نطلب حرفاً صغيرًا واحدًا ورقماً على الأقل ، في كلمة مرورك. يجب أيضًا أن يكون الحد الأدنى للطول هو 10 أحرف"`,
    phone: 'يرجى تضمين رمز بلد هاتفك ، على سبيل المثال: +65',
    username:
      ' يتم التعامل مع اسم المستخدم الخاص بك كمعلومات عامة ويتم مشاركته مع المستخدمين الآخرين حسب الحاجة. على هذا النحو ، نوصي بعدم استخدام المعلومات الشخصية في اسم المستخدم الخاص بك ',
    public_description_normal:
      'تم حفظ <0><0/> </0> الخاص بك ويعتبر خاصًا بشكل افتراضي. هذا يعني أنه يمكنك فقط رؤية هذا المحتوى. لنشر هذا المحتوى ، يمكنك تحديد أحد الخيارات أدناه. يعني نشر الدورة التدريبية الخاصة بك للجمهور أنها ستكون متاحة لجميع المستخدمين في المنصة. سيتيح لك خيار المستخدمين المحددين مشاركة دورتك التدريبية مع مستخدمين محددين باستخدام عنوان البريد الإلكتروني المرتبط بحساب Sharelook الخاص بهم',
    public_description_admin:
      '   تم حفظ هذا <0><0/> </0> ويتم اعتباره خاصًا بشكل افتراضي. هذا يعني أنه يمكنك أنت (ومنشئ المحتوى) فقط مشاهدة هذا المحتوى. لنشر هذا المحتوى ، يمكنك تحديد أحد الخيارات أدناه. يعني نشر الدورة التدريبية الخاصة بك للجمهور أنها ستكون متاحة لجميع المستخدمين في النظام الأساسي - بما في ذلك أولئك الذين هم خارج مؤسستك. يعني نشره في المؤسسة أن جميع المستخدمين داخل المؤسسة سيتمكنون من رؤيته. يمكنك أيضًا نشره إلى مجموعة واحدة أو أكثر ، مما يعني أنه لن يتمكن من رؤيته سوى المستخدمين داخل هذه المجموعات. أخيرًا ، لديك خيار نشره إلى مستخدمين محددين داخل مؤسستك وخارجها باستخدام عنوان البريد الإلكتروني لحساب Sharelook الخاص بهم'
  },

  labels: {
    add: 'إضافة',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'نوع الإجابة',
    answers: 'الإجابات',
    back_to_quiz: 'العودة إلى قائمة الاختبارات',
    back_to_question: 'العودة إلى قائمة الأسئلة',
    chat: 'دردشة',
    chat_available: 'الدردشة غير متاحة في هذا الفعالية',
    chat_report: 'تقرير الدردشة',
    choice_single: 'خيار واحد',
    choice_multiple: 'متعدد الخيارات',
    choice_free: '" حرية الاختيار',
    choice_sorting: ` 'اختيار "الفرز", `,
    // choice_matrix: " فرز المصفوفة "" اختيار" ,
    clone_lesson_permission: 'إذن استنساخ',
    code: 'الشفرة',
    correct: 'صحيح',
    created: 'تاريخ الإنشاء',
    clone_modal: 'الدورة   استنساخ ',
    // cloning_course: الدورة   استنساخ ",
    cloning: 'استنساخ...',
    cloning_course_desc:
      ' سوف تستغرق هذه العملية بعض الوقت. يرجى التحلي بالصبر ',
    cloning_success: `  تم استنساخ "الدورة التدريبية" <0 /> بنجاح "!", `,
    description: 'وصف',
    disclaimer: 'إخلاء المسئولية',
    drop_file: `"اسقاط الملف هنا ...',`,
    duration: 'المدة الزمنية',
    edit: 'تعديل',
    email: 'البريد الإلكتروني',
    event: 'فعالية',
    event_all: 'كل فعالياته',
    event_date: 'فعالية مباشر التاريخ / الوقت المحلي',
    event_this: 'هذا الفعالية',
    expire: 'انتهاء الصلاحية',
    expiry_date: 'تاريخ الانتهاء',
    forgot: 'هل نسيت كلمة المرور؟',
    group: 'مجموعة',
    groups_list: 'قائمة المجموعات',
    host: 'مضيف',
    id_annotation: 'معرف التعليق التوضيحي',
    id_quiz: 'معرف الاختبار',
    incorrect: 'غير صحيح',
    interests: 'الإهتمامات',
    invited: 'مدعو',
    live_chat: 'مناقشة مباشرة',
    live_stream_limit: 'دقائق البث المباشر',
    contact_text: 'لتغيير حد البث المباشر الشهري ، يرجى الاتصال',
    contact_admin:
      'إذا كنت ترغب في تغيير حد البث المباشر الشهري ، فيرجى الاتصال بـ </0> <1<0>  admin@sharelook.com </1>',
    limit_stream_text:
      'دقائق البث المباشر المتبقية: <0> {{limit}} </0> دقيقة <1 /> <2 /> <3> لتغيير حد البث المباشر الشهري الخاص بك ، يُرجى الاتصال بـ </3> <4> admin @ sharelook.com </4> ',
    location: 'الموقع',
    lessons: 'الدروس',
    location_broadcast: ' موقع خادم المضيف<0> ',
    location_broadcast_subtitle:
      'أضف موقعًا قريبًا من موقع مضيف البث لتقليل التأخير السمعي البصري',
    media_manager: 'مدير الإعلام',
    minutes: 'الدقائق',
    name: 'اسم',
    online_quiz: 'اختبار عبر الإنترنت',
    organiser: 'مؤلف',
    organization: 'منظمة',
    overall_emotion: ' الخبرة الشاملة',
    organizations_list: ` قائمة المنظمات, `,
    password: 'كلمه السر',
    participants: 'المشاركين',
    picture: ' صورة (16:9 ) ',
    phone: 'هاتف',
    photo: 'صورة فوتوغرافية',
    poll: 'تصويت',
    position: 'موضع',
    processing: 'معالجة',
    privacy_settings: 'إعدادات الخصوصية',
    question: 'سؤال',
    quiz_create: 'إنشاء اختبار جديد',
    quiz_name: 'اسم الاختبار',
    quiz_update: 'تحديث الاختبار',
    select_organization: 'اختر منظمة',
    settings: 'الإعدادات',
    show: 'يعرض',
    show_graph: 'إظهار نتيجة الرسم البياني',
    signin: 'تسجيل الدخول',
    signup: 'سجل',
    sort_by: 'صنف حسب',
    start_date: 'تاريخ البدء',
    tags: 'العلامات',
    terms: 'أوافق على <1> هذه الأحكام والشروط </1>.',
    title: 'عنوان',
    topics: 'المواضيع',
    topic: 'موضوع',
    total_comments: 'إجمالي التعليقات',
    username: 'اسم المستخدم',
    users_list: 'قائمة المستخدمين',
    users_emails: 'إدراج رسائل بريد إلكتروني محددة للمستخدمين',
    description_specifiction_email:
      'الرجاء إدخال عنوان بريد إلكتروني واحد في كل سطر لمشاركة هذا مع عدة مستخدمين محددين',
    message_specific_email: 'الرجاء إدخال بريد إلكتروني للمستخدم المحدد',
    viewers: 'المشاهدون',
    edit_course: 'تعديل',
    edit_assessment: 'تعديل',
    edit_event: 'تعديل',
    delete_course: 'حذف',
    delete_event: 'حذف',
    delete_assessment: 'حذف',
    view_course: 'عرض',
    view_event: 'عرض',
    view_assessment: 'عرض',
    date_event: 'تاريخ الفعالية المباشر',
    date_assessment: 'تاريخ التقييم المباشر',
    clone_of: 'استنساخ',
    clone_course:
      'إنشاء نسخة من هذه الدورة التدريبية يمكنك تعديلها بشكل مستقل عن الأصل ، وتتضمن جميع الدروس والصفحات',
    make: ' جعل',
    available_to: 'متاح لأي مستخدم ShareLook',
    uploaded_by: 'تم الرفع بواسطة: ',
    course: 'دورة',
    assessment: 'تقييم',
    user_not_exist: 'المستخدم غير موجود ، هل ترغب في إرسال دعوة؟',
    check_user: 'تنويه',
    user_not_exist_in_org:
      'المستخدم غير موجود في هذه المؤسسة ، هل ترغب في إرسال دعوة؟',
    title_modal_stream: 'تغيير حد البث المباشر للمؤسسة',
    des_warning_stream: 'أنت على وشك التغيير',
    monthly_stream: 'حد البث المباشر الشهري:',
    min_per_month: 'دقيقة / شهر',
    broadcast_label: 'أريد أن أفعل',
    hosts_emails: ' أدخل رسائل البريد الإلكتروني الخاصة بالمضيف ،',
    attendee_emails: ' أدخل رسائل البريد الإلكتروني الخاصة بالحضور',
    description_host_specifiction_email:
      'الرجاء إدخال عنوان بريد إلكتروني واحد في كل سطر.',
    presenter_label: 'مقدم',
    presenter_label_conference: 'عدد الناس',
    event_privacy: 'وضع المؤتمر',
    alert: 'إنذار!',
    warning: 'تحذير!',
    ok: 'حسنا',
    cancel: 'إلغاء',
    done: 'منجز',
    insert: 'إدراج',
    private: 'نشر',
    public: 'عامة',
    no_connection: 'انقطع الاتصال بالإنترنت',
    switch: 'مفتاح كهربائي',
    share_screen: 'شاشة المشاركة',
    stop_share_screen: 'إيقاف مشاركة الشاشة',
    share_screen_with_camera: 'مشاركة الشاشة مع الكاميرا',
    stop_share_screen_with_camera: 'وقف مشاركة الشاشة مع الكاميرا',
    camera_on: 'الكاميرا قيد التشغيل',
    camera_off: 'إيقاف تشغيل الكاميرا',
    mic_on: 'إعادة الصوت',
    mic_off: 'كتم الصوت',
    fullscreen: 'تكبير الشاشة',
    live_now: 'يعيش الآن',
    schedule_on: 'جدول ل',
    organisations: 'المنظمات',
    org_groups: 'مجموعات المنظمة',
    specific_user: 'مستخدم محدد',
    gif: 'GIF',
    unavailable: 'غير متوفره',
    yes: 'نعم',
    no: 'لا',
    event_duration_message: '300 دقيقة كحد أقصى (5 ساعات)',
    send_email: 'إرسال إشعار بالبريد الإلكتروني',
    admin_only: 'المسؤول فقط',
    join: 'انضم',
    leave: 'غادر',
    share: 'شارك',
    share_text: 'الرجاء كتابة البريد الإلكتروني لمن تريد مشاركة هذا الملف',
    share_text_title: 'شارك PDF',
    select_users: 'حدد المستخدمين',
    delete: 'حذف', // to_translate
    attachment_event: 'مرفقات الفعالية:', // to_translate
    transcribe_limit: 'كتابة الدقائق'
  },

  broadcastOptions: {
    stream_from_phone: 'البث المباشر بهاتفي',
    other_webrtc: 'Webinar من جهاز الكمبيوتر الخاص بي',
    multihost: 'برنامج تعليمي على الويب متعدد البث من جهاز الكمبيوتر الخاص بي',
    peer2peer: 'دورة تدريب',
    conference: 'مؤتمر مباشر'
  },

  lessoncreate: {
    title: 'إضافة تفاصيل الدرس',
    subtitle: 'قم بتسمية درسك وأخبر جمهورك بما يجب عليهم توقعه للتعلم منه',
    input_label_title: ' عنوان الدرس ',
    input_label_topics: 'مواضيع الدرس',
    input_label_description: 'وصف الدرس',
    delete_warning: 'هل أنت متأكد أنك تريد حذف هذه الصفحة؟'
  },

  lessonoverview: {
    title: 'إضافة درس',
    subtitle: 'إضافة درس موجود أو إنشاء درس جديد',
    new_lesson: 'إنشاء درس جديد',
    new_lesson_sub: 'أنشئ درسًا جديدًا تمامًا من البداية!',
    existing_lesson: 'اختر الدرس الحالي',
    existing_lesson_sub:
      'الارتباط بدرس موجود ، ستؤثر التغييرات التي يتم إجراؤها على هذا الدرس أيضًا على هذا الدرس في الدورات التدريبية الأخرى',
    clone_lesson: 'تكرار الدرس الحالي',
    clone_lesson_sub:
      'قم بإنشاء نسخة فريدة من الدرس في هذه الدورة التدريبية ، ولن تؤثر التغييرات التي يتم إجراؤها على هذا الدرس على الدرس الأصلي',
    clone_lesson_modal_sub:
      'الرجاء النقر فوق زر النسخ الموجود أسفل الدرس الذي ترغب في إضافته إلى الدورة التدريبية الخاصة بك'
  },

  management: {
    groups_title: 'إدارة المجموعات',
    delete_warning: 'هل أنت واثق؟',
    organizations_title: 'مؤسساتي',
    organizations_subtitle: 'أضف منظمات إلى قائمتك',
    users_title: 'ادارة المستخدمين',
    users_position: 'مدير حسابات أول',
    user_not_found: 'المستخدم ليس موجود',
    select_org: 'الرجاء البحث عن واختيار منظمة لإدارة المستخدمين'
  },

  audio: {
    modal_title: 'أدخل الصوت',
    list_view: 'عرض القائمة',
    create_audio_modal_title: 'إنشاء الصوت',
    edit_audio_modal_title: 'تحرير الصوت',
    public_audio_not_found: 'الصوت غير موجود',
    private_audio_not_found: 'لم تقم بتحميل أي ملف صوتي بعد',
    are_you_sure_to_delete: 'هل تريد بالتأكيد الحذف؟',
    type_something: 'اطبع شيئا',
    select_voice: 'تحديد',
    file_name: 'اسم الملف',
    description: 'وصف',
    topic: 'موضوع',
    key_words_tag: ' علامة الكلمات الرئيسية ',
    mp3_audio: 'صوت MP3',
    created: ' تم الإنشاء ',
    duration: 'المدة الزمنية',
    close: 'إغلاق'
  },

  image: {
    modal_title: 'إدراج صورة',
    image: 'صورة',
    pixel: 'بكسل',
    dimension: 'البعد',
    public_image_not_found: 'الصورة غير موجودة',
    private_image_not_found: 'لم تقم بتحميل أي صورة بعد'
  },

  annotation: {
    modal_title: 'حاشية. ملاحظة'
  },

  text: {
    modal_title: 'محرر النص'
  },

  video: {
    modal_title: 'إدراج فيديو',
    image: `فيديو,`,
    mp4_video: 'MP4 فيديو',
    public_video_not_found: 'لم يتم العثور على الفيديو',
    private_video_not_found: 'لم تقم بتحميل أي فيديو حتى الآن'
  },

  media: {
    title: 'مكتبة الوسائط',
    subtitle: 'مكتبة ملفاتك',
    modal_title: 'تحميل الوسائط',
    delete_warning: ' تأكيد الحذف ',
    delete_message:
      'ستظل الوسائط المحذوفة تظهر في الصفحات التي تم استخدامها فيها',
    dropzone_text: 'أو السحب والإفلات',
    delete_success: 'تم حذف الوسائط بنجاح',
    upload_file: 'رفع ملف',
    drag_drop: 'أو السحب والإفلات',
    import_file: 'استيراد ملف (ملفات) من جهاز الكمبيوتر الخاص بك',
    no_media: 'لم تقم بتحميل أي وسائط حتى الآن',
    media_type: 'نوع الوسائط',
    video: 'فيديو',
    image: 'صورة',
    transcribed_text: 'Transcribed Text',
    audio: 'صوت',
    gif: 'صورة متحركة',
    pdf: 'PDF',
    media_not_found: 'الوسائط غير موجودة',
    of: 'of',
    disclaimer: ` أضمن أن وسائط الإعلام الخاصة بي لا:
     - تنتهك حقوق أي طرف ثالث
     - تحتوي على أي محتوى غير قانوني ، بما في ذلك المحتوى التشهيري أو الفاحش أو غير اللائق أو البذيء أو الإباحي أو العنيف أو المسيء أو المهين أو التهديد أو التمييزي ، حتى المقنع بعلامات النجمة
     - تحتوي على أي اعتداء شخصي على أشخاص آخرين
     - تحتوي على أي انتحال صفة لمشاركين آخرين أو شخصيات عامة أو مشاهير
     - تحتوي على أي معلومات شخصية عن أي فرد دون موافقة هذا الفرد ولا تنتهك أي لائحة لحماية البيانات في أي جزء من العالم
     - تحتوي على أي طلب تجاري أو أي شكل من أشكال "البريد العشوائي",`,
    my_media: 'وسائطي',
    public_library: 'مكتبة عامه',
    organization_library: 'مكتبة المؤسسه',
    upload_from_computer: 'التحميل من الكمبيوتر',
    create: 'إنشاء',
    all: 'الجميع',
    male: 'رجل',
    female: 'أنثى',
    processing_audio: 'معالجة الصوت',
    create_annotation: 'إنشاء تعليق توضيحي',
    popup_over_lesson_text: 'سيظهر التعليق التوضيحي على صفحة الدرس بعد النقر',
    edit_detail: 'تعديل التفاصيل',
    delete: 'حذف',
    go_create_audio: `اذهب لإنشاء الصوت`,
    show_more_details: `اذهب لإنشاء الصوت`,
    show_less_details: `اذهب لإنشاء الصوت`,
    drop_files: `اذهب لإنشاء الصوت`,
    or: `اذهب لإنشاء الصوت`,
    import_files: `اذهب لإنشاء الصوت`,
    human: 'بشري',
    shared_file: 'تم مشاركة ملفك بنجاح', // to_translate
    error_shared_file: 'هناك مشكلة في مشاركة الملف ، يرجى المحاولة مرة أخرى' // to_translate
  },
  navigation: {
    account: 'الحساب',
    assessments: ' التقييمات',
    dashboard: 'لوحة القيادة',
    groups: 'إدارة المجموعة',
    logout: 'تسجيل خروج',
    organisations: 'المنظمات',
    organizations_users: 'المنظمات والمستخدمون',
    reports: 'التقارير',
    schedule: 'جدول',
    training: 'تدريب',
    users: 'المستخدمون',
    workshop: 'ورشة العمل الخاصة بي',
    nowLive: 'بث'
  },

  onboarding: {
    step1_title: 'الخطوة 1: أخبرنا قليلاً عن نفسك',
    step1_subtitle: 'ما اسمك؟ من أي بلد أنت؟ ما هو المسمى الوظيفي الخاص بك؟',
    step2_title: 'الخطوة 2: حدد بعض المهارات التي يمكنك تحسينها',
    step2_subtitle:
      ' بعد ذلك ، أخبرنا بما تريد أن تفهمه بشكل أفضل. ربما شيء لم تلتقطه بعد؟ مجال جديد للدراسة؟ ماذا يفعل محبوبك؟'
  },

  pagebuilder: {
    title: 'إنشاء درس',
    subtitle:
      'حان الوقت لإنشاء المحتوى لكي يتعلم جمهورك منك ، يمكنك الصور ومقاطع الفيديو والرسوم البيانية',
    select_layout: 'حدد تخطيط الصفحة',
    template1: 'فارغ',
    template2: 'العنوان والعنوان الفرعي',
    template3: 'العنوان والنص',
    template4: 'العنوان والوسائط والنص',
    template5: 'العنوان والوسائط',
    template6: 'العنوان والاختبار'
  },

  pageconstructor: {
    title: 'إنشاء واستنساخ الدرس',
    subtitle:
      'حان الوقت لإنشاء المحتوى لجمهورك للتعلم منك ، يمكنك إضافة الصور ومقاطع الفيديو والرسوم البيانية'
  },

  passwordreset: {
    success_coded:
      'لقد أرسلنا رمز تأكيد بالبريد الإلكتروني إلى العنوان الذي قدمته ، يرجى نسخ الرمز في الحقل أدناه لتعيين كلمة مرور جديدة.',
    success_changed:
      'لقد قمت بتعيين كلمة مرور جديدة بنجاح. يمكنك تسجيل الدخول الآن '
  },

  placeholders: {
    search: 'بحث',
    answer: 'إجابة',
    chat: 'قل شيئا...',
    code: 'الشفرة',
    criterion: 'معيار',
    date_event: 'حدد التاريخ والوقت',
    date_start: 'تاريخ البدء',
    date_expire: 'تاريخ الانتهاء',
    description: 'وصف',
    elements: 'فرز العناصر',
    email: 'البريد الإلكتروني',
    feedback_correct: 'الملاحظات صحيحة',
    feedback_incorrect: 'الملاحظات غير صحيحة',
    host: 'مضيف',
    keywords: 'كلمات البحث)',
    lesson_description: 'وصف الدرس',
    location: 'موقعك',
    minutes: 'الدقائق',
    name: 'اسم',
    organiser: 'مؤلف',
    organization: 'منظمة',
    password: 'كلمه السر',
    phone: 'هاتف',
    photo: 'صورة فوتوغرافية',
    picture: 'صورة',
    point: 'نقطة',
    position: 'منصب',
    question: 'سؤال',
    quiz: 'اسم الاختبار',
    search_course: 'البحث بالدورة',
    search_media: 'البحث في الوسائط',
    search_name: 'البحث عن طريق الإسم',
    search_title: 'البحث حسب العنوان',
    search_training: 'التدريب على البحث',
    settings: 'الإعدادات',
    tags: 'العلامات',
    title: 'عنوان',
    topics: 'المواضيع',
    username: 'اسم المستخدم',
    keyword: 'الكلمات الدالة',
    max_500_characters: `500 حرف كحد أقصى`,
    no_description: 'لا يحتوي هذا الملف على وصف',
    no_keyword: 'هذا الملف لا يحتوي على أية كلمات رئيسية',
    no_topics: 'لا يحتوي هذا الملف على مجموعة مواضيع',
    feedback: 'رسالة',
    contact: ` "كيف يمكننا المساعدة؟', `
  },

  publishsettings: {
    title: 'إعدادات النشر',
    event_subtitle:
      'إضافة إعدادات إلى الفعالية الخاص بك ، الذي يمكنه عرض الفعالية والتفاعل معه',
    assessment_subtitile:
      'حدد اسمًا لتقييمك وأخبر جمهورك بما يجب أن يتوقعوا تعلمه منه',
    course_subtitle:
      'إضافة إعدادات إلى مقررك الدراسي ، الذي يمكنه عرض الدورة التدريبية والتفاعل معها',
    disclaimer: `•	التسجيل

بالتسجيل كمستخدم / إنشاء حساب فإنك توافق على [اتفاقية المستخدم] وتقر بقراءة [سياسة الخصوصية] الخاصة بنا



	•	إنشاء دورة

باستخدام أدواتنا وإنشاء محتوى الدورة التدريبية ، فإنك توافق على [اتفاقية المستخدم] وتقر بقراءة [سياسة الخصوصية]



	•	إنشاء فعالية

باستخدام أدواتنا وإنشاء فعالية ، فإنك توافق على [اتفاقية المستخدم] وتقر بقراءة [سياسة الخصوصية]


	•	إنشاء التقييم

باستخدام أدواتنا وإنشاء تقييم ، فإنك توافق على [اتفاقية المستخدم] وتقر بقراءة [سياسة الخصوصية] الخاصة بنا"`,
    dates_validation_error: 'يجب ملء كلا التاريخين.',
    emails_validation_error: 'قائمة البريد الإلكتروني غير صالحة.',
    specific_email_validation_error: 'مسموح بريد إلكتروني واحد فقط',
    i_agree_to_these: 'أوافق على هذه',
    terms_and_conditions: 'الأحكام والشروط.',
    PublicDescription:
      'المستخدمون المستقلون المستقلون: (الخيارات الخاصة والعامة) تم حفظ [الدورة التدريبية | الفعالية | التقييم] واعتبرت خاصة بشكل افتراضي. هذا يعني أنه يمكنك فقط رؤية هذا المحتوى. لنشر هذا المحتوى ، يمكنك تحديده لجعله عامًا أدناه. هذا يعني أن الدورة ستكون متاحة لجميع المستخدمين في المنصة.,',
    OrganisationsDescription:
      'المستخدمون في المؤسسة: (بدلاً من "" إنهاء "" ، استخدم "" نشر "" وأحضرهم إلى صفحة النشر مثل المستخدمين الآخرين ولكن بدون أي من خيارات النشر.) [الدورة التدريبية | فعالية | التقييم] تم حفظه وهو خاص. هذا يعني أنه يمكنك أنت والمسؤولون في مؤسستك فقط رؤيتها. كمستخدم ، لا يمكنك نشر المحتوى الخاص بك داخل مؤسستك بنفسك لأن هذا يتطلب حقوق المسؤول. يرجى الاتصال بأحد المسؤولين لديك واطلب منهم نشر المحتوى الخاص بك علنًا أو للمؤسسة بأكملها أو لمجموعات محددة داخل مؤسستك أو لمستخدمين محددين.,',
    OrganisationGroupsDescription:
      'مسؤولو المؤسسة: (للمحتوى الموجود داخل المؤسسة: خاص ، عام ، مؤسسة ، مجموعات ، مستخدمين محددين): هذا [الدورة التدريبية | فعالية | التقييم] تم حفظه ويعتبر خاصًا بشكل افتراضي. هذا يعني أنه يمكنك أنت (ومنشئ المحتوى) فقط مشاهدة هذا المحتوى. لنشر هذا المحتوى ، يمكنك تحديد أحد الخيارات أدناه. يعني نشر الدورة التدريبية الخاصة بك للجمهور أنها ستكون متاحة لجميع المستخدمين في النظام الأساسي - بما في ذلك أولئك الذين هم خارج مؤسستك. يعني نشره في المؤسسة أن جميع المستخدمين داخل المؤسسة سيتمكنون من رؤيته. يمكنك أيضًا نشره إلى مجموعة واحدة أو أكثر ، مما يعني أنه لن يتمكن من رؤيته سوى المستخدمين داخل هذه المجموعات. أخيرًا ، لديك خيار نشره إلى مستخدمين محددين داخل مؤسستك وخارجها باستخدام عنوان البريد الإلكتروني لحساب Sharelook الخاص بهم., ',
    SpecificUsersDescription: ` المستخدمون المستقلون المدفوعون: (المستخدمون الخاصون والعامون والمستخدمون المحددون) [دورة | فعالية | التقييم] تم حفظه ويعتبر خاصًا بشكل افتراضي. هذا يعني أنه يمكنك فقط رؤية هذا المحتوى. لنشر هذا المحتوى ، يمكنك تحديد أحد الخيارات أدناه. يعني نشر الدورة التدريبية الخاصة بك للجمهور أنها ستكون متاحة لجميع المستخدمين في المنصة. سيتيح لك خيار المستخدمون المحددون مشاركة الدورة التدريبية الخاصة بك مع مستخدمين محددين باستخدام عنوان البريد الإلكتروني المرتبط بحساب Sharelook الخاص بهم.'`
  },

  quiz: {
    quiz_empty: 'لم تقم بإنشاء اختبار حتى الآن',
    questions_empty: 'لم تقم بعد بإنشاء سؤال'
  },

  regions: {
    asia_pacific_australia: 'أستراليا',
    asia_pacific_india: 'الهند',
    asia_pacific_japan: 'اليابان',
    asia_pacific_s_korea: 'كوريا الجنوبية',
    asia_pacific_singapore: 'سنغافورة',
    asia_pacific_taiwan: 'تايوان',
    eu_belgium: 'بلجيكا',
    eu_germany: 'ألمانيا',
    eu_ireland: 'أيرلندا',
    south_america_brazil: 'البرازيل',
    us_central_iowa: 'أيوا',
    us_east_s_carolina: 'كارولينا الجنوبية',
    us_east_virginia: 'فرجينيا',
    us_west_california: 'كاليفورنيا',
    us_west_oregon: 'أوريغون'
  },

  publishmaze: {
    title: 'إعدادات النشر',
    maze_subtitle:
      'أضف إعدادات إلى متاهتك واختر من يمكنه عرض والتفاعل مع متاهتك.',
    disclaimer: `أضمن أن متاهتي لن:
     - تنتهك حقوق أي طرف ثالث
     - تحتوي على أي مخالفة قانونية، بما في ذلك المحتوى التشهيري أو الفاحش أو غير اللائق أو الفاضح أو الإباحي أو العنيف أو المسيء أو المهين أو التهديدي أو التمييزي، حتى لو كان مموهًا بعلامات النجمة
     - تحتوي على أي هجمات شخصية على أشخاص آخرين
     - تحتوي على أي انتحال لشخصية مشاركين آخرين أو شخصيات عامة أو مشاهير
     - تحتوي على أي تسجيل أو معلومات شخصية عن أي فرد دون موافقة هذا الفرد ولا تنتهك أي لوائح حماية البيانات في أي جزء من العالم
     - تحتوي على أي طلبات تجارية أو أي شكل من أشكال البريد العشوائي`
  },

  reports: {
    title: 'التقارير',

    workshop_report: 'تقرير ورشة العمل',
    user_report: 'تقرير المستخدم',
    organization_workshop: 'ورشة التنظيم',
    course: 'دورة',
    live_event: 'حدث مباشر',
    workShop_graph: 'الرسم البياني لورشة العمل',
    organization_account: 'حساب المؤسسه',
    all: 'الجميع',
    name: 'الأسم',
    id_number: 'رقم الهويه',
    email: 'البريد الألكتروني',
    search_user_report: 'بحث في تقرير المستخدم',
    participant: 'المشارك',
    participants: 'المشاركون',
    host: 'ضيف',
    username: 'أسم المستخدم',
    event: 'حدث',
    quiz: 'أختبار',
    assessment: 'التقييم',
    time: 'الوقت',
    no_recent_activity: 'لا يوجد نشاط حديث',
    workshops: 'ورش العمل',
    courses: 'الدورات',
    live_events: 'حدث مباشر',
    live_assessments: 'تقييمات حيه',
    quizzes: 'أختبارات قصيره',
    overview: ' نظرة عامة',
    by: 'بواسطة',
    views: 'وجهات النظر',
    status: 'الحاله',
    poll: 'أستطلاع الرأي',
    comment: 'تعليق',
    comments: 'تعليقات',
    no_comments: 'لا تعليقات',
    no_polls: 'لا استطلاعات رأي',
    live_date: 'تاريخ حي',
    score: 'النتيجة',
    question: 'سؤال',
    submit: 'إرسال تقديم',
    recent_activity: 'النشاط الأخير',
    ago: 'منذ',
    no_data_found: 'لم يتم العثور على بيانات',
    start_end_live: ' بدء / إنهاء البث المباشر',
    join_leave_date: ' انضمام / مغادرة',
    watched_time: `وقت المشاهده`,
    complete: 'مكتمل',
    in_complete: `Iغير مكتمل`,
    today: 'اليوم',
    seven_days: `سبعة أيام`,
    last_month: `الشهر الماضي`,
    one_year: ' سنة واحدة',
    all_time: 'كل الوقت',
    report: 'تقرير',
    from_date: 'من تاريخ',
    to_date: 'حتى الان',
    all_workshop: 'جميع ورش العمل',
    all_marketplace: 'جميع السوق',
    all_participants: 'كل المشاركين',
    live_assessment: 'تقييم حي',
    users: 'المستخدمون',
    user: 'المستخدم',
    download: 'تنزيل',
    recent: 'الأخيرة',
    WorkShop: 'ورشة عمل',
    Activity: 'نشاط',
    created_date: 'تاريخ الإنشاء',
    purchased_date: 'تاريخ الشراء',
    product: 'المنتج',
    buyers: 'المشترون',
    lessons: 'دروس',
    lesson: 'درس',
    completed: 'مكتمل',
    search_course: `الدورة التي يتم البحث عنها`,
    participants_graph: 'الرسم البياني للمشاركين',
    viewed: `ينظر`,
    enrolled: `المقيدين`,
    description: `وصف`,
    topic: `موضوع`,
    analytic: `تحليلي`,
    quiz_list: `قائمة الاختبار`,
    report_download: `تقرير تنزيل`,
    this_mont: `هذا الشهر`,
    select_one: 'حدد واحدًا ',
    group_status: 'حالة المجموعه',
    duration_min: 'المدة الزمنية(دقيقه)',
    submit_poll: 'إرسال الاستطلاع',
    download_events: 'تنزيل الأحداث',
    search_event: 'الحدث الذي يتم البحث عنه',
    duration: 'المدة الزمنية',
    total_participants: 'إجمالي عدد المشاركين',
    message: 'رسالة',
    avg_message: 'متوسط الرسالة',
    per_message: 'النسبة المئوية من الرسائل / الحدث'
  },

  signup: {
    success_step1:
      'لقد أرسلنا رمز التحقق عبر البريد الإلكتروني إلى العنوان الذي قدمته ، يرجى نسخ الرمز في الحقل أدناه لتأكيد تسجيلك.',
    success_step2: `'شكر. لقد تم تسجيلك بنجاح. ", `,
    privacy:
      ' أوافق على <1> البنود والشروط </ 1> و <3> سياسة الخصوصية </3 < الخاصة بـ Sharelook'
  },

  stream: {
    emotion_impressive: 'مثير للإعجاب',
    emotion_unimpressive: 'غير مثير للإعجاب',
    message_not_started: 'قريبا',
    message_running: 'مباشر',
    message_processing:
      'نقوم حاليًا بمعالجة التسجيل المباشر للتشغيل. يرجى إعادة التحقق لاحقًا لمشاهدة الفيديو ولمتابعة إضافة التقييمات والتعليقات '
  },

  tabs: {
    audience: 'الجمهور',
    course: 'نظرة عامة على الدورة التدريبية',
    details: 'تفاصيل الفعالية المباشر',
    description: 'وصف',
    host: 'مضيف',
    lesson: 'نظرة عامة على الدرس',
    lessons: 'الدروس',
    overview: 'نظرة عامة',
    page: 'منشئ الصفحات',
    publish: 'ينشر',
    settings: 'إعداد النشر',
    total_views: 'عدد المشاهدات',
    live_participates: 'المشاركون المباشرون',
    live_chats: 'محادثات مباشرة',
    live_quiz: 'الاستطلاعات المباشرة',
    trainer_rating: 'تقييم المدرب',
    trainer_times: 'أوقات المدرب',
    courses_quizzes: 'اختبارات الدورات',
    user_list: 'قائمة المستخدم',
    discussion: 'المناقشة',
    notes: 'ملاحظاتي',
    attachments: 'مرفق إضافي'
  },

  topics: {
    SALES_TRAINING: 'تدريب المبيعات',
    NEGOTIATION_TRAINING: ' تدريب على التفاوض',
    CROSS_CULTURAL_AWARENESS: 'الوعي بين الثقافات',
    NETWORKING_SKILLS: 'مهارات التواصل',
    SOFTWARE_ARCHITECTURE: 'هيكلة البرمجيات',
    PROJECT_MANAGEMENT: 'ادارة مشروع',
    DIGITAL_TRANSFORMATION: 'التحول الرقمي',
    IT_CONSULTING: 'استشارات تكنولوجيا المعلومات',
    MANAGEMENT_CONSULTING: 'الاستشارات الإدارية',
    HR_CONSULTING: 'استشارات الموارد البشرية',
    INTERNET_OF_THINGS: 'إنترنت الأشياء (IoT)',
    CYBERSECURITY: 'الأمن السيبراني',
    PRIVACY_AND_GDRP: 'الخصوصية واللائحة العامة لحماية البيانات'
  },

  training: {
    title: 'تدريب',
    title_assessment: 'التقييمات',
    subtitle: 'الدورات والفعاليات المباشرة',
    enrolled_title: 'الدورات المسجلة والفعاليات المباشرة',
    enrolled_subtitle: 'الدورات والفعاليات المباشرة التي قمت بالتسجيل فيها',
    enrolled_message: 'أنت غير مسجل حاليًا في أي دورات أو فعاليات.',
    past_live_event_title: 'الفعاليات المباشرة الماضية',
    past_live_event_subTitle: 'الفعاليات المباشرة المنتهية',
    past_live_event: 'لا توجد حاليًا فعاليات مباشرة سابقة',
    recomended_title: ' الدورات الموصى بها والفعاليات المباشرة ',
    now_live_event_title: 'مباشرة الان',
    now_live_event_subTitle: 'الفعاليات المباشرة أو التي ستصبح قريبًا جدًا',
    now_live_event: ' لا يوجد حاليا أي فعالة مباشرة ',
    webinar_event_title: 'قناة الندوات عبر الإنترنت ',
    webinar_event_subTitle: 'ندوات عبر الإنترنت منتهية',
    webinar_event: 'لا توجد حاليًا أي ندوة عبر الإنترنت',
    p2p_event_title: 'جلسات التدريب',
    p2p_event_subTitle: 'جلسة تدريب منتهية',
    p2p_event: 'لا توجد حاليا جلسة تدريب',

    now_live_assessment_title: ' مباشرة الان',
    now_live_assessment_subTitle: 'تقييم مباشر أو قريب جدًا',
    now_live_assessment_message: ' لا يوجد تقييم مباشر حاليًا',

    upcoming_assessment_title: 'التقييمات المباشرة القادمة',
    upcoming_assessment_subtitle: 'التقييمات المباشرة القادمة',
    upcoming_assessment_message: 'لا يوجد تقييم مباشر قادم حاليًا.',

    past_live_assessment_title: 'تقييمات مباشرة سابقة',
    past_live_assessment_subTitle: 'تقييمات مباشرة منتهية',
    past_live_assessment_message: 'لا توجد حاليًا تقييمات حية سابقة',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'قمنا بتنظيم دورات تدريبية وأحداث مباشرة بناءً على <0><0/> </0>',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'التدريب على البحث',
    search_assessment: 'تقييم البحث',
    recomended_message: 'لا توجد دورات وفعاليات موصى بها حاليًا'
  },

  warnings: {
    delete: 'هل أنت متأكد؟'
  },

  workshop: {
    title: 'ورشة العمل الخاصة بي',
    subtitle: 'إنشاء دورة أو استضافة فعالية مباشرة خاصة بك',
    new_course: ' إنشاء دورة جديدة',
    new_event: 'إنشاء فاعلية مباشرة جديدة',
    new_assessment: 'إنشاء تقييم مباشر جديد',
    courses_title: 'الدورات التي تم إنشاؤها والفعاليات المباشرة',
    courses_subtitle:
      'تحرير ونشر الدورة التدريبية التي تم إنشاؤها وتخطيط الفعالية المباشرة',
    tags_course: 'دورة',
    tags_live: 'حدث مباشر',
    tags_assessment: 'تقييم مباشر'
  },

  help_center: {
    sidebar: {
      title: 'كيف يمكننا مساعدتك؟',
      back_to: 'لوحة القيادة'
    },
    menu: {
      help_center: 'مركز المساعدة',
      whats_new: ' ما هو الجديد',
      feedback: 'تغذية راجعة',
      feedback_title: 'إرسال ملاحظات إلى Sharelook',
      terms_and_conditions: 'الشروط والأحكام',
      privacy_policy: 'سياسة الخصوصية',
      contact_us: 'اتصل بنا'
    },
    get_started: {
      title: 'ابدأ بـ ShareLook ',
      description: {
        main:
          'لقد قمنا بدمج فيديو مباشر متكامل إلى برنامج إنشاء دورة تدريبية سهل الاستخدام',
        tagline:
          '         مع نظام البث المباشر ShareLook الحاصل على براءة اختراع ، يمكنك إنشاء تفاعل وأتمتة التعلم وتعظيم مشاركة المعرفة, '
      }
    },
    whats_new: {
      title: 'ابدأ ب ShareLook ',
      description: {
        main: `"هل تعلم أن إنشاء أسلوب تعلم القص يمكن أن يخلق في وقت قصير وغير مكلف؟ يجب عليك الجمع بين منشئ دورة ShareLook والمواهب ذات الصلة. يمكنك أن تسألنا "كيف"،`,
        tagline: ''
      }
    },
    create_workshop: ' كيفية إنشاء ورشة عمل',
    create_course: 'كيفية إنشاء دورة',
    create_user: 'كيفية إنشاء مستخدم',
    create_group: 'كيفية إنشاء مجموعة',
    create_webinar: 'كيفية إنشاء ندوة عبر الإنترنت',
    create_live_event: 'كيفية إنشاء فعالية مباشرة',
    create_live_assessment: 'كيفية إنشاء تقييم مباشر',
    create_live_on_mobile: 'إنشاء مباشر على الجوال',
    personalize_profile: 'تخصيص ملف تعريف',
    manage_group: 'إدارة المجموعة',
    report: 'الإبلاغ',
    add_annotations: 'كيفية إضافة التعليقات التوضيحية / النوافذ المنبثقة',
    add_audio: 'كيفية إضافة صوت',
    add_header_and_footer: 'إضافة رأس وتذييل',
    add_image: 'كيفية إضافة صورة',
    add_quiz_content: 'كيفية إضافة محتوى الاختبار',
    add_text_content: 'كيفية إضافة محتوى نصي',
    add_user: 'كيفية إضافة مستخدم',
    add_video: 'كيفية إضافة فيديو',
    clone_course: 'كيفية استنساخ دورة',
    find_live_broadcast: 'كيفية البحث عن البث المباشر',
    contact_us: {
      title: 'اتصل بنا',
      subject_placeholder: ' أدخل الموضوع *',
      content_placeholder: 'أدخل رسالة *',
      subject_required: '* الموضوع مطلوب ',
      content_required: ` '* الرسالة مطلوبة ", `,
      submit: 'إرسال',
      cancel: 'إلغاء',
      sent: 'أرسلت'
    },
    feedback: {
      title: 'إرسال ملاحظات إلى شارلوك',
      attach_title: 'إرفاق ملف',
      choose: 'اختر ملف',
      detail: 'ستتم مشاركة الملف مع فريق الدعم',
      content_placeholder: ` أدخل رسالة *', `,
      content_required: `'* الرسالة مطلوبة `,
      submit: 'إرسال',
      cancel: 'إلغاء',
      sent: 'أرسلت'
    }
  },
  discussion: {
    join_discussion: 'انضم إلى المناقشة'
  },
  notes: {
    title: 'ملاحظاتي',
    add_note: 'إضافة ملاحظة جديدة'
  },
  groups: {
    search_group: `بحث المجموعة`
  }
}
